export default {
  "club_accept_invite": {
    "HK": "接受邀請",
    "TW": "接受邀請",
    "ar_SA": "قبول",
    "de_DE": "Einladung annehmen",
    "en_US": "Accept the invitation",
    "es_ES": "Aceptar invitación",
    "fr_FR": "Accepter l'invitation",
    "hi_IN": "Accept the invitation",
    "in_ID": "Menerima undangan",
    "ja_JP": "Accept the invitation",
    "ko_KR": "Accept the invitation",
    "ms_MY": "Terima",
    "pt_PT": "Aceitar o convite",
    "ru_RU": "Принять",
    "th_TH": "ตอบรับ",
    "tr_TR": "Kabul Et",
    "ur": "دعوت نامہ قبول کریں",
    "uz": "Taklifni qabul qiling",
    "vi_VN": "Đồng Ý",
    "zh_CN": "接受邀请"
  },
  "club_auth_benefits": {
    "HK": "獲得驗證後，你可以",
    "TW": "獲得認證後，您可以",
    "ar_SA": "تتضمن فوائد التحقق الآتي",
    "de_DE": "Zu den Vorteilen der Verifizierung gehört",
    "en_US": "Benefits for verification include",
    "es_ES": "Beneficios de la verificación",
    "fr_FR": "Les avantages de certification incluent",
    "hi_IN": "Benefits for verification include",
    "in_ID": "Manfaat untuk verifikasi termasuk",
    "ja_JP": "Benefits for verification include",
    "ko_KR": "Benefits for verification include",
    "ms_MY": "Manfaat pengesahan termasuk",
    "pt_PT": "Benefícios da verificação incluem",
    "ru_RU": "Преимущества прохождения проверки",
    "th_TH": "สิทธิประโยชน์สำหรับการยืนยันตนประกอบด้วย",
    "tr_TR": "Doğrulama avantajları şunları içerir",
    "ur": "تصدیق کے فوائد میں درج ذیل شامل ہے",
    "uz": "Tekshirish imtiyozlari quyidagilarni oʻz ichiga oladi",
    "vi_VN": "Lợi ích xác thực bao gồm:",
    "zh_CN": "获得认证后，您可以"
  },
  "club_auth_benefits_1": {
    "HK": "特殊身份標籤",
    "TW": "特殊身分標籤",
    "ar_SA": "علامة تحقق مميزة",
    "de_DE": "Besonderes Verifizierungsabzeichen",
    "en_US": "Special verified badge",
    "es_ES": "Insignia de verificación especial",
    "fr_FR": "Insigne certifié spécial",
    "hi_IN": "Special verified badge",
    "in_ID": "Lencana terverifikasi khusus",
    "ja_JP": "Special verified badge",
    "ko_KR": "Special verified badge",
    "ms_MY": "Label Pengesahan Khas",
    "pt_PT": "Emblema verificado especial",
    "ru_RU": "Особая метка «Подтверждено»",
    "th_TH": "สัญลักษณ์ยืนยันตนพิเศษ",
    "tr_TR": "Özel Onaylı İşareti",
    "ur": "خاص مصدقہ بیج",
    "uz": "Maxsus tasdiqlangan nishon",
    "vi_VN": "Dấu hiệu xác thực đặc biệt",
    "zh_CN": "特殊的身份标签"
  },
  "club_auth_benefits_2": {
    "HK": "更容易獲得推薦",
    "TW": "更易獲淂推薦",
    "ar_SA": "التميُّز بسهولة أكبر",
    "de_DE": "Leichter, Empfehlungen zu erhalten",
    "en_US": "Easier to get recommendations",
    "es_ES": "Mayor facilidad para obtener recomendaciones",
    "fr_FR": "Recommandations plus faciles à obtenir",
    "hi_IN": "Easier to get recommendations",
    "in_ID": "Lebih mudah mendapatkan rekomendasi",
    "ja_JP": "Easier to get recommendations",
    "ko_KR": "Easier to get recommendations",
    "ms_MY": "Lebih mudah membuat penampilan",
    "pt_PT": "Maior facilidade em obter recomendações",
    "ru_RU": "Проще оказаться в списке рекомендаций",
    "th_TH": "ได้รับฟีเจอร์ง่ายขึ้น",
    "tr_TR": "Daha kolay tanıtım",
    "ur": "تجاویز کا حصول آسان تر",
    "uz": "Tavsiyalarni olish osonroq",
    "vi_VN": "Dễ dàng được đề cử",
    "zh_CN": "更容易获得推荐"
  },
  "club_auth_benefits_3": {
    "HK": "專屬特權",
    "TW": "專屬特權",
    "ar_SA": "فوائد حصرية",
    "de_DE": "Exklusive Privilegien",
    "en_US": "Exclusive privilege",
    "es_ES": "Privilegios exclusivos",
    "fr_FR": "Privilège exclusif",
    "hi_IN": "Exclusive privilege",
    "in_ID": "Hak istimewa eksklusif",
    "ja_JP": "Exclusive privilege",
    "ko_KR": "Exclusive privilege",
    "ms_MY": "Manfaat Eksklusif",
    "pt_PT": "Privilégio exclusivo",
    "ru_RU": "Эксклюзивные перки",
    "th_TH": "สิทธิพิเศษ",
    "tr_TR": "Özel Avantajlar",
    "ur": "خصوصی استحقاق",
    "uz": "Ekskluziv imtiyoz",
    "vi_VN": "Đặc quyền độc quyền",
    "zh_CN": "专属的特权"
  },
  "club_auth_example": {
    "HK": "查看範例",
    "TW": "查看範例",
    "ar_SA": "عرض مثال",
    "de_DE": "Beispiel ansehen",
    "en_US": "View example",
    "es_ES": "Ver ejemplo",
    "fr_FR": "Voir un exemple",
    "hi_IN": "View example",
    "in_ID": "Lihat contoh",
    "ja_JP": "View example",
    "ko_KR": "View example",
    "ms_MY": "Lihat contoh",
    "pt_PT": "Ver exemplo",
    "ru_RU": "Посмотреть образец",
    "th_TH": "ดูตัวอย่าง",
    "tr_TR": "Örneği görüntüle",
    "ur": "مثال دیکھیں",
    "uz": "Misolni koʻrish",
    "vi_VN": "Xem Ví Dụ",
    "zh_CN": "查看示例"
  },
  "club_auth_form_account": {
    "HK": "社交媒體帳號連結",
    "TW": "社群媒體帳號連結",
    "ar_SA": "ربط بحساب وسائل التواصل الاجتماعي الخاص بك.",
    "de_DE": "Link zu deiner Social-Media-Seite.",
    "en_US": "Link to your social media account.",
    "es_ES": "Enlace a tu cuenta de red social.",
    "fr_FR": "Lien de votre compte de réseau social.",
    "hi_IN": "Link to your social media account.",
    "in_ID": "Tautan akun media sosial kamu.",
    "ja_JP": "Link to your social media account.",
    "ko_KR": "Link to your social media account.",
    "ms_MY": "Pautkan ke akaun media sosial anda.",
    "pt_PT": "Link para página da sua rede social.",
    "ru_RU": "Привяжите свою учетную запись в соцсети.",
    "th_TH": "ผูกกับบัญชีโซเชียลมีเดียของคุณ",
    "tr_TR": "Sosyal medya hesabını bağla.",
    "ur": "آپ کے سوشل میڈیا اکاؤنٹ کا لنک۔",
    "uz": "Ijtimoiy tarmoqdagi akkaunt havolasi.",
    "vi_VN": "Liên Kết Tài Khoản Mạng Xã Hội",
    "zh_CN": "社媒账号链接"
  },
  "club_auth_form_homepage": {
    "HK": "請填寫對應社交媒體帳號的連結網址",
    "TW": "請填寫對應社群媒體帳號的連結網址",
    "ar_SA": "يُرجى إدراج رابط حساب وسائل التواصل الاجتماعي الخاص بك.",
    "de_DE": "Bitte gib den Link zu deiner Social-Media-Seite ein.",
    "en_US": "Please enter the link to your social media account.",
    "es_ES": "Ingresa el enlace de tu cuenta de red social.",
    "fr_FR": "Saisissez le lien de votre compte de réseau social.",
    "hi_IN": "Please enter the link to your social media account.",
    "in_ID": "Harap masukkan tautan akun media sosial kamu.",
    "ja_JP": "Please enter the link to your social media account.",
    "ko_KR": "Please enter the link to your social media account.",
    "ms_MY": "Sila masukkan pautan ke akaun media sosial anda.",
    "pt_PT": "Insira o link para a página da sua rede social.",
    "ru_RU": "Введите ссылку на страницу вашей учетной записи в соцсети.",
    "th_TH": "กรุณาใส่ลิ้งก์บนบัญชีโซเชียลมีเดียของคุณ",
    "tr_TR": "Lütfen sosyal medya hesabının bağlantısını gir.",
    "ur": "براہ کرم اپنے سوشل میڈیا اکاؤنٹ کا لنک داخل کریں۔",
    "uz": "Ijtimoiy tarmoq akkauntingiz havolasini kiriting.",
    "vi_VN": "Hãy nhập liên kết để đến tài khoản mạng xã hội của bạn.",
    "zh_CN": "请填写对应社媒账号的链接地址"
  },
  "club_auth_form_plat": {
    "HK": "主要營運的社交媒體平台",
    "TW": "主要經營的社群媒體平台",
    "ar_SA": "منصة التواصل الاجتماعي الرئيسية",
    "de_DE": "Haupt-Social-Media-Plattform",
    "en_US": "Main social media platform",
    "es_ES": "Plataforma principal de redes sociales",
    "fr_FR": "Plateforme de réseau social principale",
    "hi_IN": "Main social media platform",
    "in_ID": "Platform media sosial utama",
    "ja_JP": "Main social media platform",
    "ko_KR": "Main social media platform",
    "ms_MY": "Platform media sosial utama",
    "pt_PT": "Principal plataforma de rede social",
    "ru_RU": "Основная платформа в соцсетях",
    "th_TH": "แพลตฟอร์มโซเชียลมีเดียหลัก",
    "tr_TR": "Ana sosyal medya platformu",
    "ur": "مرکزی سوشل میڈیا پلیٹ فارم",
    "uz": "Asosiy ijtimoiy tarmoq platformasi",
    "vi_VN": "Trang Mạng Xã Hội Chính",
    "zh_CN": "主要运营的社媒平台"
  },
  "club_auth_form_plat_other": {
    "HK": "其他",
    "TW": "其他",
    "ar_SA": "غير ذلك",
    "de_DE": "Sonstige",
    "en_US": "Other",
    "es_ES": "Otro",
    "fr_FR": "Autre",
    "hi_IN": "Other",
    "in_ID": "Lain",
    "ja_JP": "Other",
    "ko_KR": "Other",
    "ms_MY": "Lain-lain",
    "pt_PT": "Outra",
    "ru_RU": "Другое",
    "th_TH": "อื่นๆ",
    "tr_TR": "Diğer",
    "ur": "‏دیگر",
    "uz": "Boshqa",
    "vi_VN": "Khác",
    "zh_CN": "其他"
  },
  "club_auth_form_plat_tip": {
    "HK": "請選擇您主要經營的社交媒體平台",
    "TW": "請選擇您主要經營的社群媒體平台",
    "ar_SA": "يُرجى اختيار منصة التواصل الاجتماعي الخاصة بك.",
    "de_DE": "Bitte wähle deine Haupt-Social-Media-Plattform",
    "en_US": "Please choose your main social media platform.",
    "es_ES": "Selecciona tu plataforma principal de red social.",
    "fr_FR": "Choisissez votre plateforme de réseau social principale.",
    "hi_IN": "Please choose your main social media platform.",
    "in_ID": "Harap pilih platform media sosial utama kamu.",
    "ja_JP": "Please choose your main social media platform.",
    "ko_KR": "Please choose your main social media platform.",
    "ms_MY": "Sila pilih platform media sosial utama anda",
    "pt_PT": "Escolha sua principal plataforma de rede social",
    "ru_RU": "Выберите свою основную платформу в соцсетях.",
    "th_TH": "กรุณาเลือกแพลตฟอร์มโซเชียลมีเดียหลักของคุณ",
    "tr_TR": "Lütfen ana sosyal medya platformunu seç.",
    "ur": "براہ کرم اپنا مرکزی سوشل میڈیا پلیٹ فارم منتخب کریں۔",
    "uz": "Asosiy ijtimoiy tarmoq platformasini tanlang.",
    "vi_VN": "Hãy chọn trang mạng xã hội chính của bạn.",
    "zh_CN": "请选择您主要运营的社媒平台"
  },
  "club_auth_form_title": {
    "HK": "提交驗證資訊",
    "TW": "認證資訊提交",
    "ar_SA": "إرسال معلومات التحقق",
    "de_DE": "Übermittlung von Verifizierungsinformationen",
    "en_US": "Verification information submission",
    "es_ES": "Envío de información de verificación",
    "fr_FR": "Envoi d'informations de certification",
    "hi_IN": "Verification information submission",
    "in_ID": "Pengiriman informasi verifikasi",
    "ja_JP": "Verification information submission",
    "ko_KR": "Verification information submission",
    "ms_MY": "Penyerahan maklumat pengesahan",
    "pt_PT": "Envio de informações para verificação",
    "ru_RU": "Отправка информации для подтверждения",
    "th_TH": "ส่งข้อมูลยืนยันตน",
    "tr_TR": "Doğrulama bilgisi gönderme",
    "ur": "تصدیق کی معلومات کی جمع کاری",
    "uz": "Tekshirish maʼlumotlarini yuborish",
    "vi_VN": "Gửi thông tin yêu cầu để xác thực.",
    "zh_CN": "认证信息提交"
  },
  "club_auth_name": {
    "HK": "驗證申請",
    "TW": "認證申請",
    "ar_SA": "طلب التحقق من النادي",
    "de_DE": "CLUB-Verifizierung beantragen",
    "en_US": "Apply for CLUB verification",
    "es_ES": "Solicitar verificación de CLUB",
    "fr_FR": "Postuler pour la certification de CLUB",
    "hi_IN": "Apply for CLUB verification",
    "in_ID": "Terapkan untuk verifikasi CLUB",
    "ja_JP": "Apply for CLUB verification",
    "ko_KR": "Apply for CLUB verification",
    "ms_MY": "Pohon untuk pengesahan KELAB",
    "pt_PT": "Solicite verificação do CLUBe",
    "ru_RU": "Подать заявку на проверку клуба",
    "th_TH": "ยื่นขอการยืนยันตนสำหรับคลับ",
    "tr_TR": "KULÜP doğrulaması için başvur",
    "ur": "کلب کی تصدیق کے لیے اپلائی کریں",
    "uz": "CLUB tekshiruviga murojaat qiling",
    "vi_VN": "Đăng ký xác thực Câu Lạc Bộ",
    "zh_CN": "认证申请"
  },
  "club_auth_prove": {
    "HK": "請提交你的帳號截圖以進行身份驗證，必須包括你本人的PUBG MOBILE玩家ID。",
    "TW": "請提交您的帳號截圖以進行身份驗證，必須包含您本人的PUBG MOBILE玩家ID。",
    "ar_SA": "يرجى تحميل لقطة شاشة لحسابك لإثبات هويتك. يجب تضمين مُعرف لاعب PUBG MOBILE الخاص بك.",
    "de_DE": "Bitte lade einen Screenshot deines Accounts hoch, um deine Identität zu bestätigen. (Muss deine eigene PUBG MOBILE-Spieler-ID beinhalten)",
    "en_US": "Please upload a screenshot of your account to prove your identity. The screenshot must include your own PUBG MOBILE Player ID.",
    "es_ES": "Carga una captura de pantalla de tu cuenta para probar tu identidad. La captura de pantalla debe incluir tu propio ID de jugador de PUBG MOBILE.",
    "fr_FR": "Importez une capture d'écran de votre compte pour prouver votre identité. L'image doit comporter votre ID de joueur PUBG MOBILE.",
    "hi_IN": "Please upload a screenshot of your account to prove your identity. The screenshot must include your own PUBG MOBILE Player ID.",
    "in_ID": "Unggah tangkapan layar akun untuk membuktikan identitasmu. Tangkapan layar harus menyertakan ID Pemain PUBG MOBILE kamu.",
    "ja_JP": "Please upload a screenshot of your account to prove your identity. The screenshot must include your own PUBG MOBILE Player ID.",
    "ko_KR": "Please upload a screenshot of your account to prove your identity. The screenshot must include your own PUBG MOBILE Player ID.",
    "ms_MY": "Sila muat naik tangkap skrin akaun anda untuk membuktikan identiti anda. Tangkapan skrin mesti termasuk ID Pemain PUBG MOBILE anda sendiri.",
    "pt_PT": "Envie um print da sua conta para provar sua identidade (precisa incluir sua ID de Jogador do PUBG MOBILE).",
    "ru_RU": "Для подтверждения личности загрузите снимок экрана вашего аккаунта (на нем должен быть виден ваш ID игрока в PUBG MOBILE).",
    "th_TH": "กรุณาอัปโหลดภาพสกรีนช็อตบัญชีของคุณเพื่อยืนยันตน โดยภาพสกรีนช็อตจะต้องประกอบด้วย ID ผู้เล่น PUBG MOBILE ของคุณ)",
    "tr_TR": "Lütfen kimliğini doğrulamak için hesabının ekran görüntüsünü yükle. Ekran görüntüsü sana ait PUBG MOBILE Oyuncu Kimliğini içermelidir.",
    "ur": "اپنی شناخت ثابت کرنے کے لیے براہ کرم اپنے اکاؤنٹ کا اسکرین شاٹ اپ لوڈ کریں۔ اسکرین شاٹ میں آپ کی اپنی PUBG MOBILE پلیئر ID شامل ہونی ضروری ہے۔",
    "uz": "Shaxsingizni tasdiqlash uchun akkauntingiz skrinshotini yuklang. Skrinshotda shaxsiy PUBG MOBILE o‘yinchi identifikatoringiz bo‘lishi kerak.",
    "vi_VN": "Hãy tải ảnh chụp màn hình tài khoản của bạn lên để chứng minh danh tính của bạn. Ảnh chụp màn hình phải bao gồm ID Người Chơi PUBG MOBILE của bạn.",
    "zh_CN": "请提交您的账号截图以进行身份验证，必须包含您本人的PUBG MOBILE玩家ID。"
  },
  "club_auth_req": {
    "HK": "驗證要求",
    "TW": "認證要求",
    "ar_SA": "متطلبات التحقق",
    "de_DE": "Verifizierungsanforderungen",
    "en_US": "Verification requirements",
    "es_ES": "Requisitos para la verificación",
    "fr_FR": "Conditions de certification",
    "hi_IN": "Verification requirements",
    "in_ID": "Persyaratan verifikasi",
    "ja_JP": "Verification requirements",
    "ko_KR": "Verification requirements",
    "ms_MY": "Syarat pengesahan",
    "pt_PT": "Requisitos de verificação",
    "ru_RU": "Требования проверки",
    "th_TH": "ข้อกำหนดในการยืนยันตน",
    "tr_TR": "Doğrulama gereksinimleri",
    "ur": "تصدیق کے تقاضے",
    "uz": "Tekshirish talablari",
    "vi_VN": "Yêu Cầu Xác Thực",
    "zh_CN": "认证要求"
  },
  "club_auth_req_1": {
    "HK": "PUBG MOBILE KOL",
    "TW": "PUBG MOBILE KOL",
    "ar_SA": "مشاهير PUBG MOBILE",
    "de_DE": "PUBG MOBILE-Influencer",
    "en_US": "PUBG MOBILE influencer",
    "es_ES": "Ser influencer de PUBG MOBILE",
    "fr_FR": "Influenceur PUBG MOBILE",
    "hi_IN": "PUBG MOBILE influencer",
    "in_ID": "Infulencer PUBG MOBILE",
    "ja_JP": "PUBG MOBILE influencer",
    "ko_KR": "PUBG MOBILE influencer",
    "ms_MY": "Pempengaruh PUBG MOBILE",
    "pt_PT": "Influenciador(a) do PUBG MOBILE",
    "ru_RU": "Инфлюенсер PUBG MOBILE",
    "th_TH": "PUBG MOBILE อินฟลูเอนเซอร์",
    "tr_TR": "PUBG MOBILE Fenomeni",
    "ur": "‏PUBG MOBILE کا بااثر شخص",
    "uz": "PUBG MOBILE influenseri",
    "vi_VN": "KOL PUBG MOBILE",
    "zh_CN": "PUBG MOBILE KOL"
  },
  "club_auth_req_2": {
    "HK": "你的帳號或者群組不包括非PUBG MOBILE內容",
    "TW": "您的帳號或群組不包含非關PUBGM的內容",
    "ar_SA": "لا يحتوي حسابك أو مجموعتك على محتوى غير تابع لـ PUBG MOBILE",
    "de_DE": "Dein Account oder deine Gruppe enthält keine PUBG MOBILE-fremden Inhalte.",
    "en_US": "Your account or group does not contain non-PUBG MOBILE content.",
    "es_ES": "Que tu cuenta o grupo no tenga contenido que no sea de PUBG MOBILE.",
    "fr_FR": "Le contenu de votre compte ou groupe est exclusivement lié à PUBG MOBILE.",
    "hi_IN": "Your account or group does not contain non-PUBG MOBILE content.",
    "in_ID": "Akun atau grup Anda tidak berisi konten non-PUBG MOBILE.",
    "ja_JP": "Your account or group does not contain non-PUBG MOBILE content.",
    "ko_KR": "Your account or group does not contain non-PUBG MOBILE content.",
    "ms_MY": "Akaun atau kumpulan anda mempunyai kandungan yang berkaitan dengan PUBG MOBILE sahaja.",
    "pt_PT": "Sua conta ou grupo não pode conter conteúdo que não seja do PUBG MOBILE.",
    "ru_RU": "От лица вашей учетной записи или в группе должен публиковаться исключительно контент, посвященный PUBG MOBILE.",
    "th_TH": "บัญชีหรือกลุ่มของคุณต้องมีเนื้อหาที่เกี่ยวข้องกับ PUBG MOBILE เท่านั้น",
    "tr_TR": "Hesabında ya da grubunda sadece PUBG MOBILE ile ilgili içerikler olması.",
    "ur": "آپ کے اکاؤنٹ یا گروپ میں غیر PUBG MOBILE مواد شامل نہ ہو۔",
    "uz": "Akkauntingiz yoki guruhingizda PUBG MOBILE bo‘lmagan kontent mavjud emas.",
    "vi_VN": "Tại khoản hoặc nhóm của bạn có nội dung liên quan đến PUBG MOBILE.",
    "zh_CN": "您的账号或者群组不包含非PUBG MOBILE内容"
  },
  "club_auth_reselect": {
    "HK": "重新選擇",
    "TW": "重新選擇",
    "ar_SA": "إعادة تحديد",
    "de_DE": "Erneut auswählen",
    "en_US": "Reselect",
    "es_ES": "Seleccionar de nuevo",
    "fr_FR": "Sélectionner de nouveau",
    "hi_IN": "Reselect",
    "in_ID": "Pilih ulang",
    "ja_JP": "Reselect",
    "ko_KR": "Reselect",
    "ms_MY": "Pilih semula",
    "pt_PT": "Selecionar de novo",
    "ru_RU": "Изменить выбор",
    "th_TH": "เลือกใหม่",
    "tr_TR": "Tekrar seç",
    "ur": "دوبارہ منتخب کریں",
    "uz": "Qayta tanlash",
    "vi_VN": "Chọn lại",
    "zh_CN": "重新选择"
  },
  "club_auth_screenshot": {
    "HK": "社交媒體帳號截圖",
    "TW": "社群媒體帳號截圖",
    "ar_SA": "التقط لقطة شاشة من حساب التواصل الاجتماعي الخاص بك.",
    "de_DE": "Screenshot deiner Social-Media-Seite",
    "en_US": "Screenshot of your social media account.",
    "es_ES": "Captura de pantalla de tu cuenta de red social.",
    "fr_FR": "Capture d'écran de votre compte de réseau social.",
    "hi_IN": "Screenshot of your social media account.",
    "in_ID": "Tangkapan layar akun media sosial kamu.",
    "ja_JP": "Screenshot of your social media account.",
    "ko_KR": "Screenshot of your social media account.",
    "ms_MY": "Tangkapan skrin akaun media sosial anda.",
    "pt_PT": "Captura de tela da página da sua rede social.",
    "ru_RU": "Снимок экрана с вашей учетной записью в соцсети",
    "th_TH": "ภาพสกรีนช็อตบัญชีโซเชียลมีเดียของคุณ",
    "tr_TR": "Sosyal medya hesabının ekran görüntüsü.",
    "ur": "آپ کے سوشل میڈیا اکاؤنٹ کا اسکرین شاٹ۔",
    "uz": "Ijtimoiy akkauntingiz skrinshoti.",
    "vi_VN": "Ảnh Chụp Màn Hình Tài Khoản Mạng Xã Hội",
    "zh_CN": "社媒账号截图"
  },
  "club_auth_submit": {
    "HK": "提交",
    "TW": "提交",
    "ar_SA": "إرسال",
    "de_DE": "Absenden",
    "en_US": "Submit",
    "es_ES": "Enviar",
    "fr_FR": "Envoyer",
    "hi_IN": "Submit",
    "in_ID": "Kirimkan",
    "ja_JP": "Submit",
    "ko_KR": "Submit",
    "ms_MY": "Serah",
    "pt_PT": "Enviar",
    "ru_RU": "Отправить",
    "th_TH": "ส่ง",
    "tr_TR": "Gönder",
    "ur": "جمع کروائیں",
    "uz": "Yuborish",
    "vi_VN": "Gửi",
    "zh_CN": "提交"
  },
  "club_auth_timmsg_error": {
    "HK": "伺服器異常，請重試",
    "TW": "伺服器異常，請重試",
    "ar_SA": "حدث خطأ بالخادم، يُرجى المحاولة مرة أخرى لاحقًا.",
    "de_DE": "Serverfehler. Bitte versuche es später erneut.",
    "en_US": "Server error, please try again later",
    "es_ES": "Error del servidor. Inténtalo de nuevo más tarde.",
    "fr_FR": "Erreur de serveur, réessayez plus tard.",
    "hi_IN": "Server error, please try again later",
    "in_ID": "Kesalahan server, silakan coba lagi nanti.",
    "ja_JP": "Server error, please try again later",
    "ko_KR": "Server error, please try again later",
    "ms_MY": "Ralat pelayan, sila cuba semula nanti.",
    "pt_PT": "Erro do servidor, tente de novo mais tarde.",
    "ru_RU": "Ошибка сервера. Повторите позже.",
    "th_TH": "เซิร์ฟเวอร์ผิดพลาด กรุณาลองใหม่อีกครั้ง",
    "tr_TR": "Sunucu hatası, lütfen daha sonra tekrar dene.",
    "ur": "سرور کا نقص، براہ کرم کچھ دیر بعد دوبارہ کوشش کریں",
    "uz": "Server xatoligi, keyinroq qayta urining",
    "vi_VN": "Lỗi server. Hãy thử lại sau",
    "zh_CN": "服务异常，请重试"
  },
  "club_auth_tipmsg_account": {
    "HK": "帳號不能為空白",
    "TW": "帳號不能為空白",
    "ar_SA": "لا يمكن أن يكون حقل الحساب فارغًا.",
    "de_DE": "Der Account darf nicht leer sein.",
    "en_US": "The account cannot be empty.",
    "es_ES": "La cuenta no puede estar vacía.",
    "fr_FR": "Le compte ne peut pas être vide.",
    "hi_IN": "The account cannot be empty.",
    "in_ID": "Akun tidak boleh kosong.",
    "ja_JP": "The account cannot be empty.",
    "ko_KR": "The account cannot be empty.",
    "ms_MY": "Medan akaun tidak boleh dibiar kosong.",
    "pt_PT": "A conta não pode ficar em branco.",
    "ru_RU": "Поле учетной записи не может быть пустым.",
    "th_TH": "บัญชีไม่สามารถเว้นว่างได้",
    "tr_TR": "Hesap alanı boş olamaz.",
    "ur": "اکاؤنٹ خالی نہیں ہو سکتا۔",
    "uz": "Akkaunt boʻsh qolishi mumkin emas.",
    "vi_VN": "Tài khoản không thể để trống.",
    "zh_CN": "账号不能为空"
  },
  "club_auth_tipmsg_auth_fail": {
    "HK": "驗證失敗，請重試",
    "TW": "認證失敗，請重試",
    "ar_SA": "فشل التحقق. يُرجى المحاولة مرة أخرى.",
    "de_DE": "Verifizierung fehlgeschlagen. Bitte versuche es später erneut.",
    "en_US": "Verification failed, please try again later.",
    "es_ES": "Verificación fallida. Inténtalo de nuevo más tarde.",
    "fr_FR": "Échec de la vérification, réessayez plus tard.",
    "hi_IN": "Verification failed, please try again later.",
    "in_ID": "Verifikasi gagal, coba lagi nanti.",
    "ja_JP": "Verification failed, please try again later.",
    "ko_KR": "Verification failed, please try again later.",
    "ms_MY": "Pengesahan gagal. Sila cuba semula.",
    "pt_PT": "Falha na verificação. Tente novamente mais tarde.",
    "ru_RU": "Подтверждение не удалось. Повторите попытку.",
    "th_TH": "ยืนยันตนล้มเหลว กรุณาลองใหม่อีกครั้ง",
    "tr_TR": "Doğrulama başarısız. Lütfen tekrar dene.",
    "ur": "تصدیق ناکام ہو گئی، براہ کرم کچھ دیر بعد دوبارہ کوشش کریں۔",
    "uz": "Tekshirish amalga oshmadi, keyinroq qayta urining.",
    "vi_VN": "Xác thực thất bại. Vui lòng thử lại sau.",
    "zh_CN": "认证失败，请重试"
  },
  "club_auth_tipmsg_auth_first": {
    "HK": "請先登入社交媒體帳號以驗證",
    "TW": "請先登入社群媒體帳號以認證",
    "ar_SA": "يُرجى تسجيل الدخول إلى حسابك الاجتماعي للتحقق.",
    "de_DE": "Bitte logge dich zur Verifizierung bei deinem Social-Media-Account ein.",
    "en_US": "Please log in to your social media account to verify.",
    "es_ES": "Inicia sesión en tu cuenta de red social para confirmar.",
    "fr_FR": "Connectez-vous à votre compte de réseau social pour confirmer.",
    "hi_IN": "Please log in to your social media account to verify.",
    "in_ID": "Harap login ke akun media sosial kamu untuk melakukan verifikasi.",
    "ja_JP": "Please log in to your social media account to verify.",
    "ko_KR": "Please log in to your social media account to verify.",
    "ms_MY": "Sila log masuk ke akaun media sosial anda untuk mengesahkan.",
    "pt_PT": "Faça login na sua conta de rede social para verificar.",
    "ru_RU": "Чтобы подтвердить, войдите в свою учетную запись в соцсети.",
    "th_TH": "กรุณาล็อกอินบัญชีโซเชียลของคุณเพื่อทำการยืนยัน",
    "tr_TR": "Lütfen doğrulama için sosyal medya hesabına giriş yap.",
    "ur": "براہ کرم تصدیق کے لیے اپنے سوشل میڈیا اکاؤنٹ میں لاگ ان کریں۔",
    "uz": "Tasdiqlash uchun ijtimoiy tarmoq akkauntingizga kiring.",
    "vi_VN": "Hãy đăng nhập vài tài khoản mạng xã hội để xác thực.",
    "zh_CN": "请先登录社媒账号进行验证"
  },
  "club_auth_tipmsg_homepage": {
    "HK": "帳號連結未填寫",
    "TW": "帳號連結未填寫",
    "ar_SA": "رابط حساب التواصل الاجتماعي غير موجود.",
    "de_DE": "Der Social-Media-Link fehlt.",
    "en_US": "Social media account link is missing.",
    "es_ES": "Falta el enlace a tu cuenta de red social.",
    "fr_FR": "Lien du compte de réseau social non renseigné.",
    "hi_IN": "Social media account link is missing.",
    "in_ID": "Tautan akun media sosial kosong.",
    "ja_JP": "Social media account link is missing.",
    "ko_KR": "Social media account link is missing.",
    "ms_MY": "Pautan akaun media sosial tiada.",
    "pt_PT": "O link da conta de mídia social está ausente.",
    "ru_RU": "Отсутствует ссылка на страницу вашей учетной записи в соцсети.",
    "th_TH": "ยังไม่ได้ใส่ลิ้งก์บัญชีโซเชียลมีเดีย",
    "tr_TR": "Sosyal medya hesabının bağlantısı yok.",
    "ur": "سوشل میڈیا اکاؤنٹ کا لنک غائب ہے۔",
    "uz": "Ijtimoiy tarmoq akkauntiga havola yetmayapti.",
    "vi_VN": "Chưa điền liên kết tài khoản mạng xã hội.",
    "zh_CN": "账号链接未填写"
  },
  "club_auth_tipmsg_screenshot": {
    "HK": "未上傳截圖",
    "TW": "截圖未上傳",
    "ar_SA": "لقطة الشاشة غير موجودة.",
    "de_DE": "Der Screenshot fehlt.",
    "en_US": "Screenshot is missing",
    "es_ES": "Falta la captura de pantalla.",
    "fr_FR": "Capture d'écran manquante.",
    "hi_IN": "Screenshot is missing",
    "in_ID": "Tangkapan layar tidak ada.",
    "ja_JP": "Screenshot is missing",
    "ko_KR": "Screenshot is missing",
    "ms_MY": "Tangkap layar belum dimuat naik.",
    "pt_PT": "Captura de tela ausente.",
    "ru_RU": "Отсутствует снимок экрана.",
    "th_TH": "ยังไม่ได้เพิ่มภาพสกรีนช็อต",
    "tr_TR": "Ekran Görüntüsü eksik.",
    "ur": "اسکرین شاٹ غائب ہے",
    "uz": "Skrinshot yetmayapti",
    "vi_VN": "Thiếu ảnh chụp màn hình.",
    "zh_CN": "截图未上传"
  },
  "club_auth_title": {
    "HK": "個人驗證申請",
    "TW": "個人認證申請",
    "ar_SA": "طلب التحقق من نادي PUBG MOBILE",
    "de_DE": "PUBG MOBILE CLUB-Verifizierung beantragen",
    "en_US": "Apply for PUBG MOBILE CLUB verification",
    "es_ES": "Solicitar verificación de PUBG MOBILE CLUB",
    "fr_FR": "Postuler pour la certification du PUBG MOBILE CLUB",
    "hi_IN": "Apply for PUBG MOBILE CLUB verification",
    "in_ID": "Terapkan untuk verifikasi CLUB",
    "ja_JP": "Apply for PUBG MOBILE CLUB verification",
    "ko_KR": "Apply for PUBG MOBILE CLUB verification",
    "ms_MY": "Mohon untuk pengesahan Kelab PUBG MOBILE",
    "pt_PT": "Solicite verificação do PUBG MOBILE CLUB",
    "ru_RU": "Пройти проверку для использования PUBG MOBILE CLUB",
    "th_TH": "ยื่นขอการยืนยันตนสำหรับ PUBG MOBILE คลับ",
    "tr_TR": "PUBG MOBILE Kulüp doğrulaması için başvur",
    "ur": "‏PUBG Mobile کلب کی تصدیق کے لیے اپلائی کریں",
    "uz": "PUBG MOBILE CLUB tekshiruviga murojaat qiling",
    "vi_VN": "Đăng ký xác thực Câu Lạc Bộ PUBG MOBILE",
    "zh_CN": "个人认证申请"
  },
  "club_auth_under_review": {
    "HK": "正在審核你的驗證資訊，審核結果將在5星期內透過訊息通知。",
    "TW": "正在審核您的認證資訊，審核結果會在5週內透過訊息通知。",
    "ar_SA": "معلومات التحقق قيد المراجعة حاليًا. ستصلك رسالة بالنتائج خلال 5 أسابيع.",
    "de_DE": "Die Verifizierungsinformationen werden momentan überprüft. Das Ergebnis wird dir innerhalb von 5 Wochen mitgeteilt.",
    "en_US": "Verification information is now under review. You will receive a message with the results within 5 weeks.",
    "es_ES": "La información de verificación está en proceso de revisión. Recibirás un mensaje con el resultado en un plazo de 5 semanas.",
    "fr_FR": "Les informations de vérification sont en cours d'examen. Vous recevrez un message vous informant du résultat sous 5 semaines.",
    "hi_IN": "Verification information is now under review. You will receive a message with the results within 5 weeks.",
    "in_ID": "Informasi verifikasimu sedang ditinjau. Kamu akan menerima pesan hasilnya dalam 5 minggu.",
    "ja_JP": "Verification information is now under review. You will receive a message with the results within 5 weeks.",
    "ko_KR": "Verification information is now under review. You will receive a message with the results within 5 weeks.",
    "ms_MY": "Maklumat pengesahan sedang disemak. Keputusan akan dihantar melalui mesej dalam masa 5 minggu.",
    "pt_PT": "Informações de verificação estão sob revisão. Você receberá uma mensagem com os resultados em até 5 semanas.",
    "ru_RU": "Данные проверки находятся на рассмотрении. В течение пяти недель вам будет отправлено сообщение с итоговым решением.",
    "th_TH": "ข้อมูลยืนยันตนอยู่ระหว่างการตรวจสอบ โดยคุณจะได้รับข้อความแจ้งผลภายใน 5 สัปดาห์",
    "tr_TR": "Doğrulama bilgilerin inceleniyor. 5 hafta içinde sonuçlarla ilgili bir mesaj alacaksın.",
    "ur": "تصدیقی معلومات ابھی زیر جائزہ ہے۔ آپ کو 5 ہفتوں کے اندر نتائج کا پیغام موصول ہو گا۔",
    "uz": "Tasdiqlash ma’lumotlari tekshirilmoqda. Sizga 5 hafta ichida tekshiruv natijasi haqida xabar yuboriladi.",
    "vi_VN": "Thông tin xác thực của bạn đang được kiểm tra. Bạn sẽ nhận được tin nhắn kèm kết quả trong vòng 5 tuần.",
    "zh_CN": "正在审核您的认证信息，审核结果将在5周内通过消息通知进行回复"
  },
  "club_auth_upload": {
    "HK": "上傳截圖",
    "TW": "上傳截圖",
    "ar_SA": "تحميل لقطة شاشة",
    "de_DE": "Screenshot hochladen",
    "en_US": "Upload screenshot",
    "es_ES": "Subir captura de pantalla",
    "fr_FR": "Capture d'écran de l'import",
    "hi_IN": "Upload screenshot",
    "in_ID": "Unggah tangkapan layar",
    "ja_JP": "Upload screenshot",
    "ko_KR": "Upload screenshot",
    "ms_MY": "Muat naik tangkap layar",
    "pt_PT": "Enviar captura de tela",
    "ru_RU": "Загрузить снимок экрана",
    "th_TH": "อัปโหลดภาพสกรีนช็อต",
    "tr_TR": "Ekran görüntüsü yükle",
    "ur": "اسکرین شاٹ اپ لوڈ کریں",
    "uz": "Skrinshot yuklash",
    "vi_VN": "Tải Ảnh Chụp Màn Hình Lên",
    "zh_CN": "上传截图"
  },
  "club_copy_success": {
    "HK": "已複製到剪貼簿",
    "TW": "已複製到剪貼簿",
    "ar_SA": "تم النسخ",
    "de_DE": "Kopiert",
    "en_US": "Copied",
    "es_ES": "Copiado",
    "fr_FR": "Copié",
    "hi_IN": "Copied",
    "in_ID": "disalin",
    "ja_JP": "Copied",
    "ko_KR": "Copied",
    "ms_MY": "Disalin",
    "pt_PT": "Copiado",
    "ru_RU": "Скопировано",
    "th_TH": "คัดลอกแล้ว",
    "tr_TR": "Kopyalandı",
    "ur": "نقل شدہ",
    "uz": "Nusxa olindi",
    "vi_VN": "Sao chép vào bộ nhớ tạm.",
    "zh_CN": "已复制到剪贴板"
  },
  "club_create_benefits": {
    "HK": "建立俱樂部後，你可以",
    "TW": "建立俱樂部後，您可以",
    "ar_SA": "إنشاء نادٍ يسمح لك بما يلي",
    "de_DE": "Vorteile für die Gründung eines CLUBs",
    "en_US": "Benefits for creating a club",
    "es_ES": "Beneficios de crear un club",
    "fr_FR": "Avantages de la création d'un club",
    "hi_IN": "Benefits for creating a club",
    "in_ID": "Manfaat untuk membuat klub",
    "ja_JP": "Benefits for creating a club",
    "ko_KR": "Benefits for creating a club",
    "ms_MY": "Mencipta Kelab membolehkan anda",
    "pt_PT": "Benefícios de criar um clube",
    "ru_RU": "Создание клуба позволит вам",
    "th_TH": "สร้างคลับเพื่อที่คุณจะสามารถ",
    "tr_TR": "Bir Kulüp kurduğunda şunları yapabilirsin",
    "ur": "کلب بنانے کے فوائد",
    "uz": "Klub yaratishning foydalari",
    "vi_VN": "Tạo Câu Lạc Bộ sẽ giúp bạn:",
    "zh_CN": "创建俱乐部后，您可以"
  },
  "club_create_benefits_1": {
    "HK": "直接與遊戲中數百萬的潛在追蹤者建立長久關係",
    "TW": "直接和遊戲中數百萬的潛在追蹤者建立長久的關係",
    "ar_SA": "تأسيس علاقات طويلة الأمد مع الملايين من المتابعين المحتملين مباشرةً داخل اللعبة.",
    "de_DE": "Baue langlebige Beziehungen zu Millionen von potenziellen Followern im Spiel auf.",
    "en_US": "Build a long-lasting relationships with millions of potential followers in the game directly.",
    "es_ES": "Desarrollar relaciones duraderas directamente con millones de posibles seguidores en el juego.",
    "fr_FR": "Bâtir des relations durables avec des millions d'abonnés potentiels, directement en jeu.",
    "hi_IN": "Build a long-lasting relationships with millions of potential followers in the game directly.",
    "in_ID": "Bangun hubungan tahan lama dengan jutaan calon pengikut dalam game secara langsung.",
    "ja_JP": "Build a long-lasting relationships with millions of potential followers in the game directly.",
    "ko_KR": "Build a long-lasting relationships with millions of potential followers in the game directly.",
    "ms_MY": "Jalinkan hubungan yang berkekalan dengan berjuta-juta pengikut berpotensi secara langsung dalam permainan.",
    "pt_PT": "Construir relações duradouras diretamente com milhões de potenciais seguidores no jogo.",
    "ru_RU": "Создавать продолжительные связи с миллионами потенциальных подписчиков прямо в игре.",
    "th_TH": "สร้างความสัมพันธ์แบบยั่งยืนกับผู้ติดตามที่มีศักยภาพภายในเกมกว่าล้านคน",
    "tr_TR": "Milyonlarca potansiyel takipçiyle doğrudan oyun içinde uzun süreli ilişkiler kurabilirsin.",
    "ur": "گیم میں براہ راست لاکھوں ممکنہ فالوورز کے ساتھ دیرپا تعلقات استوار کریں۔",
    "uz": "Bevosita o‘yin orqali millionlab boʻlajak kuzatuvchilar bilan uzoq muddatli munosabatlar oʻrnatasiz.",
    "vi_VN": "Xây dựng mối quan hệ lâu dài với hàng triệu người theo dõi tiềm năng trực tiếp trong trò chơi.",
    "zh_CN": "直接与游戏中的数百万潜在关注者建立持久的关系"
  },
  "club_create_benefits_2": {
    "HK": "增加社交媒體內容的曝光率",
    "TW": "增加社群媒體的內容曝光率",
    "ar_SA": "زيادة نسبة مشاهدة محتواك على مواقع التواصل الاجتماعي.",
    "de_DE": "Erhöhe die Präsenz deiner Inhalte in Social Media.",
    "en_US": "Increase content exposure of your social media.",
    "es_ES": "Aumentar la exposición del contenido de tus redes sociales.",
    "fr_FR": "Amplifier l'exposition du contenu de vos réseaux sociaux.",
    "hi_IN": "Increase content exposure of your social media.",
    "in_ID": "Tingkatkan eksposur konten media sosial Anda.",
    "ja_JP": "Increase content exposure of your social media.",
    "ko_KR": "Increase content exposure of your social media.",
    "ms_MY": "Tingkatkan pendedahan kandungan media sosial anda.",
    "pt_PT": "Aumentar a exposição do conteúdo da sua rede social.",
    "ru_RU": "Увеличить охват аудитории контента для социальных сетей.",
    "th_TH": "เพิ่มการรับรู้เนื้อหาโซเชียลมีเดียของคุณ",
    "tr_TR": "Sosyal medya içeriklerinin görünürlüğünü artırabilirsin.",
    "ur": "اپنی سوشل میڈیا کے مواد کی مقبولیت میں اضافہ کریں۔",
    "uz": "Ijtimoiy tarmoq kontentining taʼsirini oshirasiz.",
    "vi_VN": "Tăng mức độ xuất hiện cho nội dung mạng xã hội của bạn.",
    "zh_CN": "增加社交媒体的内容曝光率"
  },
  "club_create_benefits_3": {
    "HK": "使用強大的工具來幫助你組織比賽",
    "TW": "運用強大的工具來幫助您組織比賽",
    "ar_SA": "استخدام أدوات مفيدة للغاية لمساعدتك على تنظيم المباريات المخصصة.",
    "de_DE": "Verwende mächtige Werkzeuge, die dir bei der Organisation deiner spielerdefinierten Matches helfen.",
    "en_US": "Use powerful tools to help you organize custom matches.",
    "es_ES": "Usar herramientas potentes para ayudarte a organizar partidas personalizadas.",
    "fr_FR": "Utiliser des outils puissants pour vous aider à organiser des matchs personnalisés.",
    "hi_IN": "Use powerful tools to help you organize custom matches.",
    "in_ID": "Gunakan alat canggih untuk membantu Anda mengatur kecocokan khusus.",
    "ja_JP": "Use powerful tools to help you organize custom matches.",
    "ko_KR": "Use powerful tools to help you organize custom matches.",
    "ms_MY": "Gunakan alatan berkuasa untuk membantu anda menganjurkan perlawanan tersuai.",
    "pt_PT": "Usar ferramentas poderosas para ajudar a organizar partidas personalizadas.",
    "ru_RU": "Использовать эффективный инструментарий для создания пользовательских матчей.",
    "th_TH": "ใช้เครื่องมือทรงประสิทธิภาพ เพื่อช่วยจัดการแมทช์แบบสร้างเอง",
    "tr_TR": "Özel maçlar düzenlemek için güçlü araçları kullanabilirsin.",
    "ur": "اپنے حسب ضرورت میچز کو منظم کرنے میں مدد کی غرض سے طاقتور ٹولز استعمال کریں۔",
    "uz": "Maxsus matchlarni tashkil qilishda yordam berish uchun kuchli vositalardan foydalanasiz.",
    "vi_VN": "Sử dụng công cụ mạnh mẽ để giúp bạn tổ chức Trận Đấu Tùy Chỉnh.",
    "zh_CN": "使用强大的工具来帮助您组织比赛"
  },
  "club_create_benefits_4": {
    "HK": "獲得PUBG MOBILE官方認證",
    "TW": "獲得PUBG MOBILE官方認證",
    "ar_SA": "الاعتراف بك رسميًا من قِبل PUBG MOBILE.",
    "de_DE": "Lass dich offiziell von PUBG MOBILE verifizieren.",
    "en_US": "Receive verification by PUBG MOBILE Official.",
    "es_ES": "Recibir la verificación de PUBG MOBILE Oficial.",
    "fr_FR": "Vous faire certifier par PUBG MOBILE Officiel.",
    "hi_IN": "Receive verification by PUBG MOBILE Official.",
    "in_ID": "Terapkan verifikasi oleh PUBG MOBILE Official.",
    "ja_JP": "Receive verification by PUBG MOBILE Official.",
    "ko_KR": "Receive verification by PUBG MOBILE Official.",
    "ms_MY": "Dapatkan pengesahan secara rasmi oleh PUBG MOBILE.",
    "pt_PT": "Receber verificação do PUBG MOBILE Oficial.",
    "ru_RU": "Получить официальную верификацию от PUBG MOBILE.",
    "th_TH": "ได้รับการยืนยันตนอย่างเป็นทางการจาก PUBG MOBILE",
    "tr_TR": "PUBG MOBILE tarafından resmi olarak onaylanabilirsin.",
    "ur": "‏PUBG MOBILE آفیشل سے تصدیق کروائیں۔",
    "uz": "PUBG MOBILE tomonidan rasman tasdiqlaning.",
    "vi_VN": "Được PUBG MOBILE xác nhận chính thức.",
    "zh_CN": "获得PUBG MOBILE官方的验证"
  },
  "club_create_form_plat": {
    "HK": "社交媒體平台",
    "TW": "社群媒體平台",
    "ar_SA": "منصة التواصل الاجتماعي",
    "de_DE": "Social-Media-Plattform",
    "en_US": "Social media platform",
    "es_ES": "Plataforma de red social",
    "fr_FR": "Plateforme de réseau social",
    "hi_IN": "Social media platform",
    "in_ID": "Platform Media Sosial",
    "ja_JP": "Social media platform",
    "ko_KR": "Social media platform",
    "ms_MY": "Platform Media Sosial",
    "pt_PT": "Plataforma Social",
    "ru_RU": "Соцсеть",
    "th_TH": "แพลตฟอร์มโซเชียลมีเดีย",
    "tr_TR": "Sosyal medya platformu",
    "ur": "سوشل میڈیا پلیٹ فارم",
    "uz": "Ijtimoiy tarmoq platformasi",
    "vi_VN": "Trang mạng xã hội",
    "zh_CN": "社媒平台"
  },
  "club_create_form_reverify": {
    "HK": "重新驗證",
    "TW": "重新驗證",
    "ar_SA": "التحقق مجددًا",
    "de_DE": "Erneut verifizieren",
    "en_US": "Verify again",
    "es_ES": "Verificar de nuevo",
    "fr_FR": "Vérifier à nouveau",
    "hi_IN": "Verify again",
    "in_ID": "Verifikasi lagi",
    "ja_JP": "Verify again",
    "ko_KR": "Verify again",
    "ms_MY": "Sahkan semula",
    "pt_PT": "Verificar de novo",
    "ru_RU": "Подтвердить снова",
    "th_TH": "ยืนยันตนอีกครั้ง",
    "tr_TR": "Tekrar doğrula",
    "ur": "دوبارہ تصدیق کریں",
    "uz": "Qayta tasdiqlash",
    "vi_VN": "Xác Thực Lại",
    "zh_CN": "重新验证"
  },
  "club_create_form_select": {
    "HK": "請選擇平台",
    "TW": "請選擇平台",
    "ar_SA": "يُرجى تحديد منصة",
    "de_DE": "Bitte wähle eine Plattform",
    "en_US": "Please select a platform",
    "es_ES": "Selecciona una plataforma",
    "fr_FR": "Choisissez une plateforme",
    "hi_IN": "Please select a platform",
    "in_ID": "Harap pilih platform",
    "ja_JP": "Please select a platform",
    "ko_KR": "Please select a platform",
    "ms_MY": "Sila pilih platform",
    "pt_PT": "Selecione uma plataforma",
    "ru_RU": "Выберите платформу.",
    "th_TH": "กรุณาเลือกแพลตฟอร์ม",
    "tr_TR": "Lütfen bir platform seç",
    "ur": "براہ کرم پلیٹ فارم منتخب کریں",
    "uz": "Platforma tanlang",
    "vi_VN": "Hãy chọn một nền tảng",
    "zh_CN": "请选择平台"
  },
  "club_create_form_tip": {
    "HK": "主要營運社交媒體平台",
    "TW": "主要經營的社群媒體平台",
    "ar_SA": "منصة التواصل الاجتماعي الرئيسية",
    "de_DE": "Haupt-Social-Media-Plattform",
    "en_US": "Main social media platform",
    "es_ES": "Plataforma principal de red social",
    "fr_FR": "Plateforme de réseau social principale",
    "hi_IN": "Main social media platform",
    "in_ID": "Platform media sosial utama",
    "ja_JP": "Main social media platform",
    "ko_KR": "Main social media platform",
    "ms_MY": "Platform media sosial utama",
    "pt_PT": "Plataforma principal operada ou gerenciada por você",
    "ru_RU": "Основная платформа в соцсетях",
    "th_TH": "แพลตฟอร์มโซเชียลมีเดียหลัก",
    "tr_TR": "Ana sosyal medya platformu",
    "ur": "مرکزی سوشل میڈیا پلیٹ فارم",
    "uz": "Asosiy ijtimoiy tarmoq platformasi",
    "vi_VN": "Trang mạng xã hội chính",
    "zh_CN": "主要运营的社媒平台"
  },
  "club_create_form_title": {
    "HK": "驗證資訊提交",
    "TW": "驗證資訊提交",
    "ar_SA": "أرسل المعلومات المطلوبة من أجل التحقق.",
    "de_DE": "Sende die Informationen für deinen Antrag ab",
    "en_US": "Submit the information for your application",
    "es_ES": "Envía la información para tu solicitud",
    "fr_FR": "Envoyer les informations pour votre candidature",
    "hi_IN": "Submit the information for your application",
    "in_ID": "Kirim informasi untuk verifikasi Anda",
    "ja_JP": "Submit the information for your application",
    "ko_KR": "Submit the information for your application",
    "ms_MY": "Serahkan maklumat diperlukan untuk pengesahan.",
    "pt_PT": "Envie as informações para sua solicitação",
    "ru_RU": "Для подтверждения предоставьте требуемую информацию.",
    "th_TH": "ส่งข้อมูลตามที่ร้องขอเพื่อทำการยืนยันตน",
    "tr_TR": "Doğrulama için gerekli bilgileri gönder.",
    "ur": "اپنی درخواست کے لیے معلومات جمع کروائیں",
    "uz": "Soʻrov uchun maʼlumotlarni yuboring",
    "vi_VN": "Xác Thực Thông Tin Đăng Ký",
    "zh_CN": "认证信息提交"
  },
  "club_create_form_verified": {
    "HK": "帳號已驗證",
    "TW": "帳號已驗證",
    "ar_SA": "تم التحقق من الحساب.",
    "de_DE": "Der Account wurde verifiziert.",
    "en_US": "The account has been verified.",
    "es_ES": "La cuenta se verificó.",
    "fr_FR": "Le compte a été vérifié.",
    "hi_IN": "The account has been verified.",
    "in_ID": "Akun telah diverifikasi.",
    "ja_JP": "The account has been verified.",
    "ko_KR": "The account has been verified.",
    "ms_MY": "Akaun telah disahkan.",
    "pt_PT": "A conta foi verificada.",
    "ru_RU": "Учетная запись подтверждена.",
    "th_TH": "บัญชีได้รับการยืนยันตนแล้ว",
    "tr_TR": "Hesap doğrulandı.",
    "ur": "اکاؤنٹ کی تصدیق ہو گئی ہے۔",
    "uz": "Akkaunt tasdiqlandi.",
    "vi_VN": "Tài khoản này đã được xác thực.",
    "zh_CN": "账号已验证"
  },
  "club_create_form_verify": {
    "HK": "身份資訊驗證",
    "TW": "身分資訊驗證",
    "ar_SA": "التحقق من الهوية",
    "de_DE": "Verifizierung deiner Identität",
    "en_US": "Verification for your identity",
    "es_ES": "Verificación de tu identidad",
    "fr_FR": "Vérification de votre identité",
    "hi_IN": "Verification for your identity",
    "in_ID": "Verifikasi untuk identitas Anda",
    "ja_JP": "Verification for your identity",
    "ko_KR": "Verification for your identity",
    "ms_MY": "Pengesahan identiti",
    "pt_PT": "Verificação da sua identidade",
    "ru_RU": "Проверка личности",
    "th_TH": "ยืนยันตน",
    "tr_TR": "Kimlik Doğrulama",
    "ur": "اپنی شناخت کی تصدیق",
    "uz": "Shaxsingizni tekshirish",
    "vi_VN": "Xác minh danh tính",
    "zh_CN": "身份信息验证"
  },
  "club_create_form_verify_btn": {
    "HK": "登入你的社交媒體帳號以驗證身份",
    "TW": "登入您的社群媒體帳號以驗證身分",
    "ar_SA": "سجِّل الدخول إلى حساب التواصل الاجتماعي الخاص بك للتحقق.",
    "de_DE": "Logge dich zur Verifizierung bei deinem Social-Media-Account ein",
    "en_US": "Log in to your social media account to verify.",
    "es_ES": "Inicia sesión en tu cuenta de red social para confirmar.",
    "fr_FR": "Connectez-vous à votre compte de réseau social pour confirmer.",
    "hi_IN": "Log in to your social media account to verify.",
    "in_ID": "Login ke akun media sosialmu untuk melakukan verifikasi.",
    "ja_JP": "Log in to your social media account to verify.",
    "ko_KR": "Log in to your social media account to verify.",
    "ms_MY": "Log masuk ke akaun media sosial anda untuk mengesahkan.",
    "pt_PT": "Faça login na sua conta de rede social para verificar.",
    "ru_RU": "Зайдите в учетную запись в соцсети, чтобы подтвердить свою личность.",
    "th_TH": "ล็อกอินบัญชีโซเชียลมีเดียของคุณเพื่อทำการยืนยัน",
    "tr_TR": "Doğrulamak için sosyal medya hesabına giriş yap.",
    "ur": "تصدیق کے لیے اپنے سوشل میڈیا اکاؤنٹ میں لاگ ان کریں۔",
    "uz": "Tasdiqlash uchun ijtimoiy tarmoq akkauntingizga kiring.",
    "vi_VN": "Đăng nhập vào tài khoản mạng xã hội để xác thực danh tính của bạn.",
    "zh_CN": "登录您的社媒账号以进行身份验证"
  },
  "club_create_form_verify_tip": {
    "HK": "登入對應的社交媒體帳號以驗證身份",
    "TW": "登入對應的社群媒體帳號以驗證身分",
    "ar_SA": "سجِّل الدخول إلى حساب التواصل الاجتماعي المعني للتحقق من هويتك.",
    "de_DE": "Logge dich bei dem entsprechenden Social-Media-Account ein, um die Verifizierung zu autorisieren",
    "en_US": "Log in to the corresponding social media account to authorize verification",
    "es_ES": "Inicia sesión en la cuenta de redes sociales correspondiente para autorizar la verificación",
    "fr_FR": "Connectez-vous au compte de réseau social correspondant pour autoriser la vérification",
    "hi_IN": "Log in to the corresponding social media account to authorize verification",
    "in_ID": "Masuk ke akun media sosial yang sesuai untuk mengotorisasi verifikasi",
    "ja_JP": "Log in to the corresponding social media account to authorize verification",
    "ko_KR": "Log in to the corresponding social media account to authorize verification",
    "ms_MY": "Log masuk ke dalam akaun media sosial yang sepadan untuk mengesahkan identiti anda.",
    "pt_PT": "Faça login na conta de rede social correspondente para autorização a verificação",
    "ru_RU": "Зайдите в соответствующую учетную запись социальной сети, чтобы подтвердить свою личность.",
    "th_TH": "ล็อกอินบัญชีโซเชียลมีเดียตามที่กำหนดเพื่อยืนยันตัวตนของคุณ",
    "tr_TR": "Kimliğini doğrulamak için ilgili sosyal medya hesabına giriş yap.",
    "ur": "تصدیق کی اجازت دینے کے لیے متعلقہ سوشل میڈیا اکاؤنٹ میں لاگ ان کریں",
    "uz": "Tekshirishga ruxsat berish uchun tegishli ijtimoiy tarmoq akkauntiga kiring",
    "vi_VN": "Đăng nhập vào tài khoản mạng xã hội tương ứng để xác thực danh tính của bạn.",
    "zh_CN": "登录对应的社媒账号进行身份验证"
  },
  "club_create_media": {
    "HK": "社交媒體帳號",
    "TW": "社群媒體帳號",
    "ar_SA": "حساب تواصل اجتماعي",
    "de_DE": "Social-Media-Accounts",
    "en_US": "Social media accounts",
    "es_ES": "Cuentas de redes sociales",
    "fr_FR": "Comptes de réseaux sociaux",
    "hi_IN": "Social media accounts",
    "in_ID": "Akun media sosial",
    "ja_JP": "Social media accounts",
    "ko_KR": "Social media accounts",
    "ms_MY": "Akaun media sosial",
    "pt_PT": "Contas de rede social",
    "ru_RU": "Учетная запись в соцсети",
    "th_TH": "บัญชีโซเชียลมีเดีย",
    "tr_TR": "Sosyal medya hesabı",
    "ur": "سوشل میڈیا اکاؤنٹس",
    "uz": "Ijtimoiy tarmoqlardagi akkauntlar",
    "vi_VN": "Tài Khoản Mạng Xã Hội",
    "zh_CN": "社媒账号"
  },
  "club_create_placehold": {
    "HK": "請填寫對應的社交媒體帳號連結",
    "TW": "請填寫對應社群媒體帳號的連結",
    "ar_SA": "يُرجى إدراج رابط حساب التواصل الاجتماعي الخاص بك.",
    "de_DE": "Bitte gib den Link zu deinem Social-Media-Account ein.",
    "en_US": "Please enter the link to your social media account.",
    "es_ES": "Ingresa el enlace de tu cuenta de red social.",
    "fr_FR": "Saisissez le lien de votre compte de réseau social.",
    "hi_IN": "Please enter the link to your social media account.",
    "in_ID": "Harap masukkan tautan akun media sosial kamu.",
    "ja_JP": "Please enter the link to your social media account.",
    "ko_KR": "Please enter the link to your social media account.",
    "ms_MY": "Sila masukkan pautan ke akaun media sosial anda.",
    "pt_PT": "Insira o link da sua conta de rede social.",
    "ru_RU": "Введите ссылку на свою учетную запись в соцсети.",
    "th_TH": "กรุณาใส่ลิ้งก์บนบัญชีโซเชียลมีเดียของคุณ",
    "tr_TR": "Lütfen sosyal medya hesabının bağlantısını gir.",
    "ur": "براہ کرم اپنے سوشل میڈیا اکاؤنٹ کا لنک داخل کریں۔",
    "uz": "Ijtimoiy tarmoq akkauntingiz havolasini kiriting.",
    "vi_VN": "Hãy nhập liên kết để đến tài khoản mạng xã hội của bạn.",
    "zh_CN": "请填写对应社媒账号的链接"
  },
  "club_create_req": {
    "HK": "申請條件要求",
    "TW": "申請條件要求",
    "ar_SA": "متطلبات إنشاء نادٍ",
    "de_DE": "Anforderungen für die CLUBgründung",
    "en_US": "Requirements for creating clubs",
    "es_ES": "Requisitos para crear clubes",
    "fr_FR": "Conditions préalables pour la création de clubs",
    "hi_IN": "Requirements for creating clubs",
    "in_ID": "Persyaratan untuk membuat klub",
    "ja_JP": "Requirements for creating clubs",
    "ko_KR": "Requirements for creating clubs",
    "ms_MY": "Syarat penciptaan Kelab",
    "pt_PT": "Requisitos para criar clubes",
    "ru_RU": "Требования к созданию клуба",
    "th_TH": "เงื่อนไขการสร้างคลับ",
    "tr_TR": "Kulüp kurma gereksinimleri",
    "ur": "کلبز بنانے کے حوالے سے تقاضے",
    "uz": "Klub yaratish talablari",
    "vi_VN": "Yêu Cầu Tạo Câu Lạc Bộ",
    "zh_CN": "申请所需条件要求"
  },
  "club_create_req_1": {
    "HK": "PUBG MOBILE KOL、Discord伺服器或類似群組的管理者",
    "TW": "PUBG MOBILE KOL，或者是Discord伺服器或相似群組的管理者",
    "ar_SA": "أن تكون مُؤثِّرًا في PUBG MOBILE أو مسؤولاً عن خادم Discord أو مجموعة مماثلة.",
    "de_DE": "Du bist ein PUBG MOBILE-Influencer oder Administrator eines Discord-Servers.",
    "en_US": "PUBG MOBILE influencer or admins of a Discord server.",
    "es_ES": "Ser influencer de PUBG MOBILE o administrador de un servidor de Discord.",
    "fr_FR": "Influenceur PUBG MOBILE ou administrateur d'un serveur Discord.",
    "hi_IN": "PUBG MOBILE influencer or admins of a Discord server.",
    "in_ID": "Influencer PUBG MOBILE atau admin server Discord.",
    "ja_JP": "PUBG MOBILE influencer or admins of a Discord server.",
    "ko_KR": "PUBG MOBILE influencer or admins of a Discord server.",
    "ms_MY": "Pempengaruh PUBG MOBILE atau pentadbir pelayan Discord atau kumpulan yang serupa.",
    "pt_PT": "Influenciador ou administrador de um servidor do Discord do PUBG MOBILE.",
    "ru_RU": "Инфлюенсер PUBG MOBILE, администратор сервера в Discord или другого схожего сообщества.",
    "th_TH": "อินฟลูเอนเซอร์ PUBG MOBILE หรือแอดมินของเซิร์ฟเวอร์ Discord หรือกลุ่มที่คล้ายคลึงกัน",
    "tr_TR": "PUBG MOBILE fenomeni ya da bir Discord sunucusu veya benzer bir grup yöneticisi olmak.",
    "ur": "‏PUBG MOBILE کا بااثر شخص یا Discord سرور کے ایڈمنز۔",
    "uz": "PUBG MOBILE influyenseri yoki Discord serverining administratorlari .",
    "vi_VN": "KOL của PUBG MOBILE hoặc admin server Discord.",
    "zh_CN": "PUBG MOBILE KOL或Discord 等群组组织者"
  },
  "club_create_req_2": {
    "HK": "你的帳號或者群組不包括非PUBG MOBILE內容",
    "TW": "您的帳號或群組不包含非關PUBGM的內容",
    "ar_SA": "ألا يحتوي حسابك أو مجموعتك سوى على محتوى ذي صلة بـ PUBG MOBILE.",
    "de_DE": "Dein Account oder deine Gruppe enthält keine PUBG MOBILE-fremden Inhalte.",
    "en_US": "Your account or group does not contain non-PUBG MOBILE content.",
    "es_ES": "Que tu cuenta o grupo no tenga contenido que no sea de PUBG MOBILE.",
    "fr_FR": "Le contenu de votre compte ou groupe est exclusivement lié à PUBG MOBILE.",
    "hi_IN": "Your account or group does not contain non-PUBG MOBILE content.",
    "in_ID": "Akun atau grup Anda tidak berisi konten non-PUBG MOBILE.",
    "ja_JP": "Your account or group does not contain non-PUBG MOBILE content.",
    "ko_KR": "Your account or group does not contain non-PUBG MOBILE content.",
    "ms_MY": "Akaun atau kumpulan anda mempunyai kandungan yang berkaitan dengan PUBG MOBILE sahaja.",
    "pt_PT": "Sua conta ou grupo não pode conter conteúdo que não seja do PUBG MOBILE.",
    "ru_RU": "От лица вашей учетной записи или в группе должен публиковаться исключительно контент, посвященный PUBG MOBILE.",
    "th_TH": "บัญชีหรือกลุ่มของคุณต้องมีเนื้อหาที่เกี่ยวข้องกับ PUBG MOBILE เท่านั้น",
    "tr_TR": "Hesabında ya da grubunda sadece PUBG MOBILE ile ilgili içerikler olması.",
    "ur": "آپ کے اکاؤنٹ یا گروپ میں غیر PUBG MOBILE مواد شامل نہ ہو۔",
    "uz": "Akkauntingiz yoki guruhingizda PUBG MOBILE bo‘lmagan kontent mavjud emas.",
    "vi_VN": "Tại khoản hoặc nhóm của bạn có nội dung liên quan đến PUBG MOBILE.",
    "zh_CN": "您的账号或者群组不包含非PUBG MOBILE内容"
  },
  "club_create_req_3": {
    "HK": "能夠致力維持你所建立的俱樂部活躍",
    "TW": "能夠投入精力維護建立的俱樂部",
    "ar_SA": "الالتزام بأن تكون نشطًا وأن تحافظ على النادي الخاص بك.",
    "de_DE": "Du bist motiviert, deinen CLUB aktiv zu halten.",
    "en_US": "Committed to maintain your club active.",
    "es_ES": "Comprometerte a mantener el club activo.",
    "fr_FR": "Vous vous engagez à garder votre club actif.",
    "hi_IN": "Committed to maintain your club active.",
    "in_ID": "Berkomitmen untuk mempertahankan aktivitas klub Anda.",
    "ja_JP": "Committed to maintain your club active.",
    "ko_KR": "Committed to maintain your club active.",
    "ms_MY": "Komited untuk menjadi aktif dan menyelenggara Kelab anda.",
    "pt_PT": "Comprometimento em manter seu clube ativo.",
    "ru_RU": "Вы должны быть активны и управлять своим клубом.",
    "th_TH": "มอบหมายให้ดำเนินการ หรือดูแลคลับของคุณ",
    "tr_TR": "Aktif olmak ve Kulübünü devam ettirme konusunda kararlı olmak.",
    "ur": "اپنے کلب کو فعال رکھنے کے لیے پُرعزم۔",
    "uz": "Klubingizni faol holatda saqlashga intiling.",
    "vi_VN": "Cam kết hoạt động và duy trì Câu Lạc Bộ của bạn.",
    "zh_CN": "能够投入精力维护创建的俱乐部"
  },
  "club_create_title": {
    "HK": "建立俱樂部",
    "TW": "建立俱樂部",
    "ar_SA": "إنشاء نادٍ",
    "de_DE": "Gründe einen CLUB",
    "en_US": "Create a club",
    "es_ES": "Crear un club",
    "fr_FR": "Créer un club",
    "hi_IN": "Create a club",
    "in_ID": "Terapkan untuk membuat klub",
    "ja_JP": "Create a club",
    "ko_KR": "Create a club",
    "ms_MY": "Cipta Kelab",
    "pt_PT": "Crie um clube",
    "ru_RU": "Создать клуб",
    "th_TH": "สร้างคลับ",
    "tr_TR": "Kulüp Oluştur",
    "ur": "کلب بنائیں",
    "uz": "Klub yaratish",
    "vi_VN": "Tạo Câu Lạc Bộ",
    "zh_CN": "创建俱乐部"
  },
  "club_create_under_review": {
    "HK": "你已提交俱樂部建立申請，我們正在審核。相關審核結果將在5星期內透過訊息通知。",
    "TW": "您已經提交俱樂部建立申請，我們正在審核中。審核結果會在5週內透過訊息通知。",
    "ar_SA": "طلبك قيد المراجعة حاليًا. ستصلك رسالة بالنتائج خلال 5 أسابيع.",
    "de_DE": "Dein Antrag wird momentan geprüft. Das Ergebnis wird dir innerhalb von 5 Wochen mitgeteilt.",
    "en_US": "Your application is now under review. You will receive a message with the results within 5 weeks.",
    "es_ES": "Tu solicitud está en proceso de revisión. Recibirás un mensaje con el resultado en un plazo de 5 semanas.",
    "fr_FR": "Votre candidature est en cours d'examen. Vous recevrez un message vous informant du résultat sous 5 semaines.",
    "hi_IN": "Your application is now under review. You will receive a message with the results within 5 weeks.",
    "in_ID": "Pengajuanmu sedang ditinjau. Kamu akan menerima pesan hasilnya dalam 5 minggu.",
    "ja_JP": "Your application is now under review. You will receive a message with the results within 5 weeks.",
    "ko_KR": "Your application is now under review. You will receive a message with the results within 5 weeks.",
    "ms_MY": "Permohonan anda sedang disemak. Keputusan akan dihantar melalui mesej dalam masa 5 minggu.",
    "pt_PT": "Sua solicitação está sob revisão. Você receberá uma mensagem com os resultados em até 5 semanas.",
    "ru_RU": "Ваша заявка находится на рассмотрении. В течение пяти недель вам будет отправлено сообщение с итоговым решением.",
    "th_TH": "ขณะนี้คำขอของคุณอยู่ระหว่างการตรวจสอบ โดยคุณจะได้รับข้อความแจ้งผลภายใน 5 สัปดาห์",
    "tr_TR": "Başvurun şu anda inceleniyor. 5 hafta içinde sonuçlarla ilgili bir mesaj alacaksın.",
    "ur": "آپ کی درخواست ابھی زیر جائزہ ہے۔ آپ کو 5 ہفتوں کے اندر نتائج کا پیغام موصول ہو گا۔",
    "uz": "Arizangiz tekshirilmoqda. Sizga 5 hafta ichida tekshiruv natijasi haqida xabar yuboriladi.",
    "vi_VN": "Đơn đăng ký của bạn đang được kiểm tra. Bạn sẽ nhận được tin nhắn kèm kết quả trong vòng 5 tuần.",
    "zh_CN": "您已经提交了俱乐部创建申请，我们正在进行审核，相关审核结果会在5周内通过消息通知进行同步"
  },
  "club_create_upload": {
    "HK": "點擊上傳按鈕，上傳截圖以驗證身份",
    "TW": "點按上傳按鈕，上傳截圖以驗證身分",
    "ar_SA": "اضغط على الزر لتحميل لقطة شاشة من أجل التحقق.",
    "de_DE": "Klicke auf den Button, um einen Screenshot für die Verifizierung hochzuladen.",
    "en_US": "Click the button to upload a screenshot for verification.",
    "es_ES": "Pulsa el botón para subir una captura de pantalla para la verificación.",
    "fr_FR": "Cliquez sur le bouton pour importer une capture d'écran pour la vérification.",
    "hi_IN": "Click the button to upload a screenshot for verification.",
    "in_ID": "Klik tombol untuk mengupload tangkapan layar untuk verifikasi.",
    "ja_JP": "Click the button to upload a screenshot for verification.",
    "ko_KR": "Click the button to upload a screenshot for verification.",
    "ms_MY": "Ketik butang untuk memuat naik tangkap layar bagi tujuan pengesahan.",
    "pt_PT": "Clique no botão para enviar uma captura de tela para verificação.",
    "ru_RU": "Нажмите кнопку, чтобы загрузить снимок экрана для подтверждения.",
    "th_TH": "แตะปุ่มเพื่ออัปโหลดภาพสกรีนช็อตสำหรับใช้ในการยืนยันตน",
    "tr_TR": "Doğrulama amacıyla ekran görüntüsü göndermek için butona dokun.",
    "ur": "تصدیق کے لیے اسکرین شاٹ اپ لوڈ کرنے کی غرض سے بٹن پر کلک کریں۔",
    "uz": "Tekshirishga skrinshotni yuklash uchun tugmaga tegining.",
    "vi_VN": "Nhấn vào nút để tải ảnh chụp màn hình lên và xác thực.",
    "zh_CN": "点击上传按钮，上传截图以进行身份验证"
  },
  "club_invite_tip": {
    "HK": "誠邀你請加入以下PUBG MOBILE俱樂部",
    "TW": "您受邀加入以下PUBG MOBILE俱樂部",
    "ar_SA": "أنت مدعو للانضمام إلى نادي PUBG MOBILE التالي",
    "de_DE": "Du wurdest eingeladen, dem PUBG MOBILE CLUB beizutreten.",
    "en_US": "You are invited to join the PUBG MOBILE club",
    "es_ES": "Recibiste una invitación para unirte al club de PUBG MOBILE",
    "fr_FR": "Vous êtes invité à rejoindre le PUBG MOBILE CLUB",
    "hi_IN": "You are invited to join the PUBG MOBILE club",
    "in_ID": "Anda diundang untuk bergabung dengan klub PUBG MOBILE",
    "ja_JP": "You are invited to join the PUBG MOBILE club",
    "ko_KR": "You are invited to join the PUBG MOBILE club",
    "ms_MY": "Anda telah dijemput untuk menyertai Kelab PUBG MOBILE berikut",
    "pt_PT": "Você recebeu um convite para o PUBG MOBILE CLUB",
    "ru_RU": "Вы приглашены в клуб PUBG MOBILE CLUB",
    "th_TH": "คุณถูกเชิญให้เข้าร่วม PUBG MOBILE คลับดังต่อไปนี้",
    "tr_TR": "Aşağıdaki PUBG MOBILE Kulübüne katılmak için davet edildin",
    "ur": "آپ کو PUBG MOBILE کلب میں شامل ہونے کے لیے مدعو کیا گیا ہے",
    "uz": "Sizni PUBG MOBILE klubiga qoʻshilishga taklif qilamiz",
    "vi_VN": "Bạn được mời tham gia Câu Lạc Bộ PUBG MOBILE dưới đây.",
    "zh_CN": "您被邀请加入以下PUBG MOBILE俱乐部"
  },
  "club_pc_downloaded": {
    "HK": "已經下載了PUBG MOBILE",
    "TW": "已經下載PUBG MOBILE",
    "ar_SA": "تم تنزيل PUBG MOBILE",
    "de_DE": "PUBG MOBILE heruntergeladen",
    "en_US": "PUBG MOBILE downloaded",
    "es_ES": "PUBG MOBILE descargado",
    "fr_FR": "PUBG MOBILE téléchargé",
    "hi_IN": "PUBG MOBILE downloaded",
    "in_ID": "PUBG MOBILE diunduh",
    "ja_JP": "PUBG MOBILE downloaded",
    "ko_KR": "PUBG MOBILE downloaded",
    "ms_MY": "PUBG MOBILE dimuat turun",
    "pt_PT": "PUBG MOBILE baixado",
    "ru_RU": "PUBG MOBILE загружена",
    "th_TH": "ดาวน์โหลด PUBG MOBILE แล้ว",
    "tr_TR": "PUBG MOBILE indirildi",
    "ur": "‏PUBG MOBILE ڈاؤن لوڈ کردہ ہے",
    "uz": "PUBG MOBILE yuklab olindi",
    "vi_VN": "Đã tải PUBG MOBILE.",
    "zh_CN": "已经下载了PUBG MOBILE"
  },
  "club_pc_downloaded_tip": {
    "HK": "在遊戲中的俱樂部頁面，輸入對應的俱樂部ID以加入",
    "TW": "在遊戲中的俱樂部頁面，輸入對應的俱樂部ID以加入",
    "ar_SA": "انتقل إلى النادي في PUBG MOBILE، وأدخل مُعرِّف النادي للانضمام إليه.",
    "de_DE": "Gehe zu „Club“ in PUBG MOBILE und gib die Club-ID ein, um beizutreten.",
    "en_US": "Go to CLUB in PUBG MOBILE and enter the club ID to join.",
    "es_ES": "Ve al CLUB en PUBG MOBILE e ingresa la ID del club para unirte.",
    "fr_FR": "Rendez-vous dans CLUB sur PUBG MOBILE et saisissez l'ID du club pour le rejoindre.",
    "hi_IN": "Go to CLUB in PUBG MOBILE and enter the club ID to join.",
    "in_ID": "Buka KLUB di PUBG MOBILE dan masukkan ID klub untuk bergabung.",
    "ja_JP": "Go to CLUB in PUBG MOBILE and enter the club ID to join.",
    "ko_KR": "Go to CLUB in PUBG MOBILE and enter the club ID to join.",
    "ms_MY": "Pergi ke KELAB dalam PUBG MOBILE dan masukkan ID kelab untuk menyertai.",
    "pt_PT": "Acesse o CLUB no PUBG MOBILE e insira a ID do CLUB para entrar.",
    "ru_RU": "Перейдите в раздел PUBG MOBILE CLUB и введите ID клуба, чтобы к нему присоединиться.",
    "th_TH": "ไปที่คลับใน PUBG MOBILE และใส่ ID คลับเพื่อเข้าร่วม",
    "tr_TR": "PUBG MOBILE'da KULÜP sayfasına git ve katılmak için kulüp kimliğini gir.",
    "ur": "‏PUBG MOBILE میں کلب پر جائیں اور شامل ہونے کے لیے کلب ID داخل کریں۔",
    "uz": "PUBG MOBILE oʻyinida CLUBga oʻting va qoʻshilish uchun klub identifikatorini kiriting.",
    "vi_VN": "Vào Câu Lạc Bộ PUBG MOBILE và nhập ID Câu Lạc Bộ để tham gia.",
    "zh_CN": "在游戏中俱乐部模块，输入对应的俱乐部ID加入该俱乐部"
  },
  "club_pc_goto_appstore": {
    "HK": "前往應用程式商店下載",
    "TW": "前往應用程式商店下載",
    "ar_SA": "تنزيل من Play Store",
    "de_DE": "Aus dem Play Store herunterladen",
    "en_US": "Download in Play Store",
    "es_ES": "Descargar en la Play Store",
    "fr_FR": "Téléchargez dans le Play Store",
    "hi_IN": "Download in Play Store",
    "in_ID": "Unduh di Play Store",
    "ja_JP": "Download in Play Store",
    "ko_KR": "Download in Play Store",
    "ms_MY": "Muat turun di Play Store",
    "pt_PT": "Baixe na Play Store",
    "ru_RU": "Загрузить из Play Store",
    "th_TH": "ดาวน์โหลดใน Play Store",
    "tr_TR": "Play Store'dan indir",
    "ur": "پلے اسٹور سے ڈاؤن لوڈ کریں",
    "uz": "Play Marketdan yuklab oling",
    "vi_VN": "Tải Từ Cửa Hàng",
    "zh_CN": "前往应用商店下载"
  },
  "club_pc_goto_club": {
    "HK": "或前往遊戲俱樂部頁面中，輸入對應的俱樂部ID加入",
    "TW": "或前往遊戲的俱樂部頁面，輸入對應的俱樂部ID以加入",
    "ar_SA": "أو انتقل إلى النادي في PUBG MOBILE، وأدخل مُعرِّف النادي للانضمام إليه.",
    "de_DE": "Oder gehe zu „Club“ in PUBG MOBILE und gib die Club-ID ein, um beizutreten.",
    "en_US": "Or, go to CLUB in PUBG MOBILE and enter the club ID to join.",
    "es_ES": "O ve al CLUB en PUBG MOBILE e ingresa la ID del club para unirte.",
    "fr_FR": "Ou rendez-vous dans CLUB sur PUBG MOBILE et saisissez l'ID du club pour le rejoindre.",
    "hi_IN": "Or, go to CLUB in PUBG MOBILE and enter the club ID to join.",
    "in_ID": "Atau buka Klub di PUBG MOBILE dan masukkan ID klub untuk bergabung.",
    "ja_JP": "Or, go to CLUB in PUBG MOBILE and enter the club ID to join.",
    "ko_KR": "Or, go to CLUB in PUBG MOBILE and enter the club ID to join.",
    "ms_MY": "Atau, pergi ke KELAB dalam PUBG MOBILE dan masukkan ID kelab untuk menyertai.",
    "pt_PT": "Ou acesse o CLUB no PUBG MOBILE e insira a ID do CLUB para entrar.",
    "ru_RU": "Или перейдите в раздел PUBG MOBILE CLUB и введите ID клуба, чтобы к нему присоединиться.",
    "th_TH": "หรือไปที่คลับใน PUBG MOBILE และใส่ ID คลับเพื่อเข้าร่วม",
    "tr_TR": "Ya da PUBG MOBILE'da KULÜP sayfasına git ve katılmak için kulüp kimliğini gir.",
    "ur": "یا، PUBG MOBILE میں کلب پر جائیں اور شامل ہونے کے لیے کلب ID داخل کریں۔",
    "uz": "Yoki PUBG MOBILE oʻyinida CLUBga o‘ting va qo‘shilish uchun klub identifikatorini kiriting.",
    "vi_VN": "Hoặc vào Câu Lạc Bộ PUBG MOBILE và nhập ID Câu Lạc Bộ để tham gia.",
    "zh_CN": "或前往游戏俱乐部模块中，输入对应的俱乐部 ID加入"
  },
  "club_pc_jump_pc": {
    "HK": "前往下載PUBG MOBILE",
    "TW": "前往下載PUBG MOBILE",
    "ar_SA": "تنزيل PUBG MOBILE",
    "de_DE": "PUBG MOBILE herunterladen",
    "en_US": "Download PUBG MOBILE",
    "es_ES": "Descarga PUBG MOBILE",
    "fr_FR": "Téléchargez PUBG MOBILE",
    "hi_IN": "Download PUBG MOBILE",
    "in_ID": "Unduh PUBG MOBILE",
    "ja_JP": "Download PUBG MOBILE",
    "ko_KR": "Download PUBG MOBILE",
    "ms_MY": "Muat Turun PUBG MOBILE",
    "pt_PT": "Baixar PUBG MOBILE",
    "ru_RU": "Загрузить PUBG MOBILE",
    "th_TH": "ดาวน์โหลด PUBG MOBILE",
    "tr_TR": "PUBG MOBILE'ı indir",
    "ur": "‏PUBG MOBILE ڈاؤن لوڈ کریں",
    "uz": "PUBG MOBILE yuklab oling",
    "vi_VN": "Tải PUBG MOBILE",
    "zh_CN": "前往下载PUBG MOBILE"
  },
  "club_pc_not_downloaded": {
    "HK": "沒有下載遊戲",
    "TW": "沒有下載遊戲",
    "ar_SA": "لم يتم تنزيل PUBG MOBILE",
    "de_DE": "PUBG MOBILE nicht heruntergeladen",
    "en_US": "PUBG MOBILE not downloaded",
    "es_ES": "PUBG MOBILE no se ha descargado",
    "fr_FR": "PUBG MOBILE non téléchargé",
    "hi_IN": "PUBG MOBILE not downloaded",
    "in_ID": "PUBG MOBILE tidak diunduh",
    "ja_JP": "PUBG MOBILE not downloaded",
    "ko_KR": "PUBG MOBILE not downloaded",
    "ms_MY": "PUBG MOBILE belum dimuat turun",
    "pt_PT": "PUBG MOBILE não foi baixado",
    "ru_RU": "PUBG MOBILE не загружена",
    "th_TH": "ยังไม่ได้ดาวน์โหลด PUBG MOBILE",
    "tr_TR": "PUBG MOBILE indirilmedi",
    "ur": "‏PUBG MOBILE ڈاؤن لوڈ نہیں ہے",
    "uz": "PUBG MOBILE yuklab olinmadi",
    "vi_VN": "Chưa tải PUBG MOBILE.",
    "zh_CN": "没有下载游戏"
  },
  "club_pc_or": {
    "HK": "或",
    "TW": "或",
    "ar_SA": "أو",
    "de_DE": "oder",
    "en_US": "or",
    "es_ES": "o",
    "fr_FR": "ou",
    "hi_IN": "or",
    "in_ID": "atau",
    "ja_JP": "or",
    "ko_KR": "or",
    "ms_MY": "atau",
    "pt_PT": "ou",
    "ru_RU": "или",
    "th_TH": "หรือ",
    "tr_TR": "veya",
    "ur": "یا",
    "uz": "yoki",
    "vi_VN": "hoặc",
    "zh_CN": "或"
  },
  "club_race_join": {
    "HK": "報名",
    "TW": "報名",
    "ar_SA": "التسجيل",
    "de_DE": "Jetzt anmelden",
    "en_US": "Register now",
    "es_ES": "Regístrate ahora",
    "fr_FR": "S'inscrire maintenant",
    "hi_IN": "Register now",
    "in_ID": "Daftar sekarang",
    "ja_JP": "Register now",
    "ko_KR": "Register now",
    "ms_MY": "Daftar",
    "pt_PT": "Inscreva-se agora",
    "ru_RU": "Регистрация",
    "th_TH": "ลงทะเบียน",
    "tr_TR": "Kaydol",
    "ur": "ابھی رجسٹر کریں",
    "uz": "Roʻyxatdan oʻtish",
    "vi_VN": "Đăng ký",
    "zh_CN": "报名"
  },
  "club_race_promoter": {
    "HK": "舉辦者",
    "TW": "舉辦者",
    "ar_SA": "المضيف",
    "de_DE": "Moderator",
    "en_US": "Host",
    "es_ES": "Anfitrión",
    "fr_FR": "Hôte",
    "hi_IN": "Host",
    "in_ID": "Tuan rumah",
    "ja_JP": "Host",
    "ko_KR": "Host",
    "ms_MY": "Hos",
    "pt_PT": "Anfitrião",
    "ru_RU": "ведущий",
    "th_TH": "ผู้จัด",
    "tr_TR": "Ev Sahibi",
    "ur": "میزبان",
    "uz": "Mezbon",
    "vi_VN": "Người Tổ Chức",
    "zh_CN": "举办者"
  },
  "club_race_requirements": {
    "HK": "報名要求",
    "TW": "報名要求",
    "ar_SA": "متطلبات التسجيل",
    "de_DE": "Anmeldungsanforderungen",
    "en_US": "Registration Requirements",
    "es_ES": "Requisitos de registro",
    "fr_FR": "Conditions d'inscription",
    "hi_IN": "Registration Requirements",
    "in_ID": "Persyaratan Pendaftaran",
    "ja_JP": "Registration Requirements",
    "ko_KR": "Registration Requirements",
    "ms_MY": "Syarat Pendaftaran",
    "pt_PT": "Requisitos de Inscrição",
    "ru_RU": "Требования к регистрации",
    "th_TH": "ข้อกำหนดในการลงทะเบียน",
    "tr_TR": "Kayıt Gereksinimleri",
    "ur": "رجسٹریشن کے تقاضے",
    "uz": "Registratsiya talablari",
    "vi_VN": "Điều Kiện Đăng Ký",
    "zh_CN": "报名要求"
  },
  "club_race_reward": {
    "HK": "比賽獎勵",
    "TW": "比賽獎勵",
    "ar_SA": "المكافآت",
    "de_DE": "Belohnungen",
    "en_US": "Rewards",
    "es_ES": "Recompensas",
    "fr_FR": "Récompenses",
    "hi_IN": "Rewards",
    "in_ID": "Hadiah",
    "ja_JP": "Rewards",
    "ko_KR": "Rewards",
    "ms_MY": "Ganjaran",
    "pt_PT": "Recompensas",
    "ru_RU": "Награды",
    "th_TH": "รางวัล",
    "tr_TR": "Ödüller",
    "ur": "انعامات",
    "uz": "Mukofotlar",
    "vi_VN": "Phần thưởng",
    "zh_CN": "比赛奖励"
  },
  "club_race_rules": {
    "HK": "規則詳情",
    "TW": "規則詳情",
    "ar_SA": "قواعد المباراة",
    "de_DE": "Match-Regeln",
    "en_US": "Match Rules",
    "es_ES": "Reglas de la partida",
    "fr_FR": "Règles du match",
    "hi_IN": "Match Rules",
    "in_ID": "Aturan Pertandingan",
    "ja_JP": "Match Rules",
    "ko_KR": "Match Rules",
    "ms_MY": "Peraturan Perlawanan",
    "pt_PT": "Regras de Partida",
    "ru_RU": "Правила матча",
    "th_TH": "กติกาการแข่งขัน",
    "tr_TR": "Maç Kuralları",
    "ur": "میچ کے اصول",
    "uz": "Match qoidalari",
    "vi_VN": "Quy Tắc Trận Đấu",
    "zh_CN": "规则详情"
  },
  "club_race_title": {
    "HK": "PUBG MOBILE比賽",
    "TW": "PUBG MOBILE比賽",
    "ar_SA": "مباريات PUBG MOBILE المُخصصة",
    "de_DE": "PUBG MOBILE – Spielerdefinierte Matches",
    "en_US": "PUBG MOBILE Custom Matches",
    "es_ES": "Partidas personalizadas de PUBG MOBILE",
    "fr_FR": "Matchs personnalisés PUBG MOBILE",
    "hi_IN": "PUBG MOBILE Custom Matches",
    "in_ID": "Pertandingan Kustom Seluler PUBG",
    "ja_JP": "PUBG MOBILE Custom Matches",
    "ko_KR": "PUBG MOBILE Custom Matches",
    "ms_MY": "Perlawanan Tersuai PUBG MOBILE",
    "pt_PT": "Partidas Personalizadas do PUBG MOBILE",
    "ru_RU": "Пользовательские матчи в PUBG MOBILE",
    "th_TH": "PUBG MOBILE แมทช์แบบสร้างเอง",
    "tr_TR": "PUBG MOBILE Özel Maçları",
    "ur": "‏PUBG MOBILE کے حسب ضرورت میچز",
    "uz": "PUBG MOBILE maxsus matchlari",
    "vi_VN": "Trận Đấu Tùy Chỉnh PUBG MOBILE",
    "zh_CN": "PUBG MOBILE比赛"
  },
  "club_race_ways": {
    "HK": "報名方式",
    "TW": "報名方式",
    "ar_SA": "طرق التسجيل",
    "de_DE": "So kannst du dich anmelden",
    "en_US": "Ways to register",
    "es_ES": "Formas de registrarte",
    "fr_FR": "Modalités d'inscription",
    "hi_IN": "Ways to register",
    "in_ID": "Cara mendaftar",
    "ja_JP": "Ways to register",
    "ko_KR": "Ways to register",
    "ms_MY": "Cara mendaftar",
    "pt_PT": "Formas de se inscrever",
    "ru_RU": "Способы регистрации",
    "th_TH": "ช่องทางลงทะเบียน",
    "tr_TR": "Kayıt yöntemleri",
    "ur": "رجسٹر کرنے کے طریقے",
    "uz": "Registratsiya usullari",
    "vi_VN": "Cách Đăng Ký",
    "zh_CN": "报名方式"
  },
  "club_race_ways_1": {
    "HK": "組隊",
    "TW": "組隊",
    "ar_SA": "يجب التسجيل كفريق",
    "de_DE": "Man muss sich als Team anmelden",
    "en_US": "Must register as a team",
    "es_ES": "Debes registrarte como un equipo",
    "fr_FR": "Inscription en équipe requise",
    "hi_IN": "Must register as a team",
    "in_ID": "Harus mendaftar sebagai tim",
    "ja_JP": "Must register as a team",
    "ko_KR": "Must register as a team",
    "ms_MY": "Perlu mendaftar sebagai pasukan",
    "pt_PT": "A inscrição deve ser como equipe",
    "ru_RU": "Нужно зарегистрироваться как команда",
    "th_TH": "ต้องลงทะเบียนเป็นทีม",
    "tr_TR": "Bir takım halinde kayıt olunmalıdır",
    "ur": "ٹیم کے طور پر رجسٹر کرنا ضروری ہے",
    "uz": "Jamoa sifatida roʻyxatdan oʻtish zarur",
    "vi_VN": "Đăng ký theo đội",
    "zh_CN": "组队"
  },
  "club_race_ways_2": {
    "HK": "無需組隊",
    "TW": "無需組隊",
    "ar_SA": "يستطيع المشاركون التسجيل بأنفسهم أو كفريق",
    "de_DE": "Teilnehmer können sich alleine oder als Team anmelden",
    "en_US": "Participants can register by themselves or as a team",
    "es_ES": "Los participantes pueden registrarse por su cuenta o como un equipo",
    "fr_FR": "Les participants peuvent s'inscrire seuls ou en équipe",
    "hi_IN": "Participants can register by themselves or as a team",
    "in_ID": "Peserta dapat mendaftar sendiri atau sebagai tim",
    "ja_JP": "Participants can register by themselves or as a team",
    "ko_KR": "Participants can register by themselves or as a team",
    "ms_MY": "Peserta mesti mendaftarkan diri mereka atau sebagai pasukan",
    "pt_PT": "Participantes podem se registrar como solo ou equipe",
    "ru_RU": "Участники могут регистрироваться независимо и как команда",
    "th_TH": "ผู้เข้าร่วมสามารถลงทะเบียนด้วยตัวเองหรือเป็นทีม",
    "tr_TR": "Katılımcılar bireysel olarak ya da takım halinde kaydolabilirler",
    "ur": "شرکاء خود سے یا ٹیم کے طور پر رجسٹر کر سکتے ہیں",
    "uz": "Ishtirokchilar yakka yoki jamoa sifatida roʻyxatdan oʻtishlari mumkin",
    "vi_VN": "Đăng ký solo hoặc đội",
    "zh_CN": "无需组队"
  },
  "club_rank_day_title": {
    "HK": "俱樂部每日排行榜",
    "TW": "俱樂部每日排行榜",
    "ar_SA": "نادي لوحة الصدارة اليومي",
    "de_DE": "Tägliche Club-Rangliste",
    "en_US": "Club Daily Leaderboard",
    "es_ES": "Tabla de Clasificación Diaria del Club",
    "fr_FR": "Classement quotidien du club",
    "hi_IN": "Club Daily Leaderboard",
    "in_ID": "Club Daily Leaderboard",
    "ja_JP": "Club Daily Leaderboard",
    "ko_KR": "Club Daily Leaderboard",
    "ms_MY": "Carta Pendahulu Harian Kelab",
    "pt_PT": "Classificação Diária de Clube",
    "ru_RU": "Ежедневный рейтинг клуба",
    "th_TH": "อันดับคลับประจำวัน",
    "tr_TR": "Günlük Kulüp Sıralaması",
    "ur": "کلب کا یومیہ لیڈر بورڈ",
    "uz": "Klubning kunlik yetakchilari jadvali",
    "vi_VN": "BXH Ngày",
    "zh_CN": "俱乐部每日排行榜"
  },
  "club_rank_desc_1": {
    "HK": "此排行榜記錄該俱樂部活躍的成員，如果你也想登上排行榜，可透過以下方法達成！本週排行榜為本週積分總和排名。",
    "TW": "此排行榜記錄該俱樂部的活躍成員。如果您也想登上排行榜，可透過以下方式達成喔！本週排行榜為本週積分的總和排名。",
    "ar_SA": "تُسجل لوحة الصدارة الأعضاء النشطين في النادي. إذا كنت تريد أن يتم تضمينك، يمكنك القيام بذلك من خلال الطرق التالية. لوحة الصدارة الأسبوعية هي لوحة المتصدرين الإجمالية للأسبوع.",
    "de_DE": "Diese Rangliste erfasst die aktiven Mitglieder des Clubs. Wenn du auch auf der Rangliste stehen willst, kannst du das auf folgende Weise tun! Die wöchentliche Rangliste enthält die Gesamtpunktzahl der Woche.",
    "en_US": "This leaderboard records the active members of the club. If you also want to be on the leaderboard, you can do it in the following ways! The Weekly Leaderboard is the total point ranking of the week.",
    "es_ES": "Esta Tabla de Clasificación registra los miembros activos del club. ¡Si tú también quieres estar en la clasificación, puedes hacerlo de las siguientes maneras! La Tabla de Clasificación semanal es la clasificación total de puntos de la semana.",
    "fr_FR": "Ce classement recense les membres actifs du club. Si vous souhaitez y figurer, vous pouvez le faire via les méthodes ci-dessous. Le classement hebdomadaire est le classement total de points de la semaine.",
    "hi_IN": "This leaderboard records the active members of the club. If you also want to be on the leaderboard, you can do it in the following ways! The Weekly Leaderboard is the total point ranking of the week.",
    "in_ID": "Leaderboard ini mencatat anggota klub yang aktif. Jika kamu juga ingin berada di Leaderboard, kamu dapat melakukannya dengan cara berikut! Weekly Leaderboard adalah peringkat poin total dalam seminggu.",
    "ja_JP": "This leaderboard records the active members of the club. If you also want to be on the leaderboard, you can do it in the following ways! The Weekly Leaderboard is the total point ranking of the week.",
    "ko_KR": "This leaderboard records the active members of the club. If you also want to be on the leaderboard, you can do it in the following ways! The Weekly Leaderboard is the total point ranking of the week.",
    "ms_MY": "Carta pendahulu ini merekodkan ahli aktif dalam kelab. Jika anda juga ingin tersenarai dalam carta pendahulu, anda boleh menggunakan cara berikut! Carta Pendahulu Mingguan ialah jumlah kedudukan mata pada minggu itu.",
    "pt_PT": "Esta classificação registra os membros ativos do clube. Se você também quer estar na classificação, pode fazê-lo das seguintes maneiras! A Classificação Semanal é a classificação total de pontos da semana.",
    "ru_RU": "В рейтинг заносятся активные члены клуба. Если вы тоже хотите оказаться в рейтинге, вы можете сделать это различными способами! В еженедельном рейтинге указывается общее количество очков за неделю.",
    "th_TH": "ตารางอันดับนี้จะบันทึกสมาชิกคลับที่มีการเคลื่อนไหว หากคุณต้องการอยู่ในตารางอันดับ คุณสามารถทำได้ด้วยวิธีการต่างๆ ดังต่อไปนี้! ตารางอันดับประจำสัปดาห์เป็นการจัดอันดับคะแนนรวมประจำสัปดาห์",
    "tr_TR": "Bu sıralama tablosu kulübün aktif üyelerini kaydeder. Sıralama tablosunda yer almak istiyorsan aşağıdaki yöntemleri izleyebilirsin! Haftalık Sıralama, haftanın toplam puan sıralamasını gösterir.",
    "ur": "یہ لیڈر بورڈ کلب کے فعال ممبرز کا ریکارڈ رکھتا ہے۔ اگر آپ بھی لیڈر بورڈ پر رہنا چاہتے ہیں، تو آپ ایسا درج ذیل طریقوں سے کر سکتے ہیں! ہفتہ وار لیڈر بورڈ میں ہفتے کی کُل پوائنٹ رینکنگ ہوتی ہے۔",
    "uz": "Bu yetakchilar jadvalida klubning faol aʼzolar qayd etiladi. Siz ham yetakchilar jadvaliga kirishni istasangiz, buni quyidagi usullar bilan qilishingiz mumkin! Haftalik yetakchilar jadvali – haftaning umumiy ball reytingidir.",
    "vi_VN": "Bảng xếp hạng này ghi nhận thành viên hoạt động tích cực trong Câu Lạc Bộ. Nếu bạn cũng muốn xuất hiện tên bảng xếp hạng, bạn có thể thực hiện các phương pháp sau! Bảng Xếp Hạng Tuần được tính bằng tổng điểm xếp hạng trong tuần.",
    "zh_CN": "此排行榜记录该俱乐部活跃的成员，如果你也想登上排行榜，可通过以下方式实现哦！本周排行榜为本周积分总和排名。"
  },
  "club_rank_desc_2": {
    "HK": "每日讚好建立發佈的動態（每條動態僅能讚好1次）",
    "TW": "每日按讚建立者發佈的動態（每則動態僅能按讚1次）",
    "ar_SA": "مثل مشاركات المؤسس يوميًا. (لا يمكن إبداء الإعجاب بكل منشور إلا مرة واحدة.)",
    "de_DE": "LIKE täglich die Beiträge des Gründers. (Jeder Beitrag kann nur einmal geliked werden.)",
    "en_US": "LIKE the Founder's posts daily. (Each post can only be liked once.)",
    "es_ES": "Dale ME GUSTA a las publicaciones del fundador diariamente. (Máximo un ME GUSTA a cada publicación)",
    "fr_FR": "Likez les billets du fondateur tous les jours. (Chaque billet ne peut être liké qu'une seule fois.)",
    "hi_IN": "LIKE the Founder's posts daily. (Each post can only be liked once.)",
    "in_ID": "SUKAI postingan Pendiri setiap hari. (Setiap postingan hanya dapat disukai satu kali.)",
    "ja_JP": "LIKE the Founder's posts daily. (Each post can only be liked once.)",
    "ko_KR": "LIKE the Founder's posts daily. (Each post can only be liked once.)",
    "ms_MY": "SUKA siaran Pengasas setiap hari. (Setiap siaran hanya boleh disukai satu kali.)",
    "pt_PT": "CURTA os posts do Fundador diariamente. (Cada postagem só pode ser curtida uma vez.)",
    "ru_RU": "Каждый день оценивайте сообщения основателя. (Каждому сообщению можно поставить не более одного лайка.)",
    "th_TH": "กดไลก์โพสต์ของผู้สร้างทุกวัน (สามารถกดไลก์ได้โพสต์ละ 1 ครั้ง)",
    "tr_TR": "Kurucunun paylaşımlarını her gün beğen. (Her paylaşım sadece bir defa beğenilebilir.)",
    "ur": "بانی کی پوسٹس روزانہ لائک کریں۔ (ہر پوسٹ کو صرف ایک بار لائک کیا جا سکتا ہے۔)",
    "uz": "Asoschining postlariga har kuni Layk bosing. (Har bir postga faqat bir marta layk bosish mumkin.)",
    "vi_VN": "THÍCH bài đăng của Người Sáng Lập mỗi ngày. (Mỗi bài đăng được THÍCH 1 lần.)",
    "zh_CN": "每日点赞创建者发布的动态（每条动态仅能点赞1次）"
  },
  "club_rank_desc_3": {
    "HK": "每日評論建立者發佈的動態（每人每日最多發佈5條評論）",
    "TW": "每日評論建立者發佈的動態（每人每日最多發佈5則評論）",
    "ar_SA": "علِّق على مشاركات المؤسس يوميًا. (بحد أقصى 5 تعليقات لكل شخص في اليوم.)",
    "de_DE": "Kommentiere täglich die Beiträge des Gründers. (Maximal 5 Kommentare pro Person und Tag.)",
    "en_US": "Comment on the Founder's posts daily. (Maximum 5 comments per person per day.)",
    "es_ES": "Comenta las publicaciones del Fundador diariamente. (Máximo 5 comentarios por persona por día.)",
    "fr_FR": "Commentez les billets du fondateur tous les jours. (5 commentaires par jour max.)",
    "hi_IN": "Comment on the Founder's posts daily. (Maximum 5 comments per person per day.)",
    "in_ID": "Komentari postingan Pendiri setiap hari. (Maksimum 5 komentar per orang setiap hari.)",
    "ja_JP": "Comment on the Founder's posts daily. (Maximum 5 comments per person per day.)",
    "ko_KR": "Comment on the Founder's posts daily. (Maximum 5 comments per person per day.)",
    "ms_MY": "Komen pada siaran Pengasas setiap hari. (Maksimum 5 komen setiap orang setiap hari.)",
    "pt_PT": "Comente as postagens do Fundador diariamente. (Máximo de 5 comentários por pessoa por dia.)",
    "ru_RU": "Каждый день комментируйте сообщения основателя. (Один участник не может отправить за день более 5 комментариев)",
    "th_TH": "แสดงความคิดเห็นในโพสต์ของผู้สร้างทุกวัน (สูงสุดคนละ 5 ความคิดเห็น/วัน)",
    "tr_TR": "Kurucunun paylaşımlarına her gün yorum yap. (Kişi başı günde maksimum 5 yorum.)",
    "ur": "بانی کی پوسٹس پر روزانہ تبصرہ کریں۔ (فی دن ایک شخص کی جانب سے زیادہ سے زیادہ 5 تبصرے۔)",
    "uz": "Asoschining postlariga har kuni fikr bildiring. (Kuniga bir kishi uchun maksimal 5 ta fikr.)",
    "vi_VN": "Bình luận trên bài đăng của Người Sáng Lập mỗi ngày. (Mỗi người bình luận tối đa 5 lần mỗi ngày.)",
    "zh_CN": "每日评论创建者发布的动态（每人每日最多发布5条评论）"
  },
  "club_rank_desc_4": {
    "HK": "每日訪問該俱樂部頁面",
    "TW": "每日造訪該俱樂部頁面",
    "ar_SA": "زُر صفحة النادي يوميًا.",
    "de_DE": "Besuche täglich die Clubseite.",
    "en_US": "Visit the club page daily.",
    "es_ES": "Visita la página del club diariamente.",
    "fr_FR": "Visitez la page du club tous les jours.",
    "hi_IN": "Visit the club page daily.",
    "in_ID": "Kunjungi halaman klub setiap hari.",
    "ja_JP": "Visit the club page daily.",
    "ko_KR": "Visit the club page daily.",
    "ms_MY": "Lawati halaman kelab setiap hari.",
    "pt_PT": "Visite a página do clube diariamente.",
    "ru_RU": "Каждый день заходите на страницу клуба.",
    "th_TH": "เยี่ยมชมหน้าคลับทุกวัน",
    "tr_TR": "Kulüp sayfasını her gün ziyaret et.",
    "ur": "کلب کے صفحے کا روزانہ دورہ کریں۔",
    "uz": "Klub sahifasiga har kuni tashrif buyuring.",
    "vi_VN": "Truy cập trang Câu Lạc Bộ mỗi ngày.",
    "zh_CN": "每日访问该俱乐部页面"
  },
  "club_rank_desc_5": {
    "HK": "每日發佈你的動態至該俱樂部（每人每日最多發佈10條動態）",
    "TW": "每日發佈您的動態至該俱樂部（每人每日最多發佈10則動態）",
    "ar_SA": "انشر منشورات في النادي يوميًا. (بحد أقصى 10 منشورات لكل شخص يوميًا.)",
    "de_DE": "Veröffentliche täglich Beiträge im Club. (Maximal 10 Beiträge pro Person und Tag.)",
    "en_US": "Make posts in the club daily. (Maximum 10 posts per person per day.)",
    "es_ES": "Haz publicaciones en el club diariamente. (Máximo 10 publicaciones por persona por día)",
    "fr_FR": "Publiez des billets dans le club tous les jours. (10 billets par jour max.)",
    "hi_IN": "Make posts in the club daily. (Maximum 10 posts per person per day.)",
    "in_ID": "Buat postingan di klub setiap hari. (Maksimal 10 postingan per orang setiap hari.)",
    "ja_JP": "Make posts in the club daily. (Maximum 10 posts per person per day.)",
    "ko_KR": "Make posts in the club daily. (Maximum 10 posts per person per day.)",
    "ms_MY": "Buat siaran dalam kelab setiap hari. (Maksimum 10 siaran setiap orang setiap hari.)",
    "pt_PT": "Faça postagens no clube diariamente. (Máximo de 10 postagens por pessoa por dia.)",
    "ru_RU": "Каждый день отправляйте сообщения в клубе. (Один участник не может отправить за день более 10 сообщений)",
    "th_TH": "สร้างโพสต์ในคลับทุกวัน (สูงสุดคนละ 10 โพสต์/วัน)",
    "tr_TR": "Kulüpte her gün paylaşımda bulun. (Kişi başı günde maksimum 10 paylaşım.)",
    "ur": "کلب میں روزانہ پوسٹس کریں۔ (فی دن ایک شخص کی جانب سے زیادہ سے زیادہ 10 پوسٹس۔)",
    "uz": "Klubda har kuni postlar qoldiring. (Kuniga bir kishi uchun maksimal 10 ta post.)",
    "vi_VN": "Đăng bài trong Câu Lạc Bộ mỗi ngày. (Mỗi người đăng tối đa 10 bài mỗi ngày.)",
    "zh_CN": "每日发布你的动态至该俱乐部（每人每日最多发布10条动态）"
  },
  "club_rank_desc_6": {
    "HK": "你每日發佈至該俱樂部的動態有人讚好",
    "TW": "您每日發佈至該俱樂部的動態有人按讚",
    "ar_SA": "إعجابات أخرى مثل منشورات النادي الخاص بك يوميًا.",
    "de_DE": "Andere LIKEen täglich deine Clubbeiträge.",
    "en_US": "Others LIKE your club posts daily.",
    "es_ES": "A otros les gustan las publicaciones de tu club diariamente.",
    "fr_FR": "Recevez des LIKEs sur vos publications de club tous les jours.",
    "hi_IN": "Others LIKE your club posts daily.",
    "in_ID": "Orang lain MENYUKAI postingan klub kamu setiap hari.",
    "ja_JP": "Others LIKE your club posts daily.",
    "ko_KR": "Others LIKE your club posts daily.",
    "ms_MY": "Pemain lain SUKA siaran kelab anda setiap hari.",
    "pt_PT": "Outros CURTEM as postagens do seu clube diariamente.",
    "ru_RU": "Другие пользователи могут ставить вашим сообщениям лайки.",
    "th_TH": "คนอื่นกดไลก์โพสต์คลับของคุณทุกวัน",
    "tr_TR": "Diğerleri kulübünün paylaşımlarını her gün beğensin.",
    "ur": "دوسرے آپ کی کلب کی پوسٹس کو روزانہ لائک کریں۔",
    "uz": "Boshqalarning klubdagi postlaringizga har kuni bosgan Layklari.",
    "vi_VN": "Các thành viên khác THÍCH bài đăng của bạn mỗi ngày.",
    "zh_CN": "你每日发布至该俱乐部的动态被点赞"
  },
  "club_rank_desc_title": {
    "HK": "排行榜說明",
    "TW": "排行榜說明",
    "ar_SA": "تفاصيل لوحة الصدارة",
    "de_DE": "Ranglistenbeschreibung",
    "en_US": "Leaderboard Description",
    "es_ES": "Descripción de la Tabla de Clasificación",
    "fr_FR": "Description du classement",
    "hi_IN": "Leaderboard Description",
    "in_ID": "Deskripsi Leaderboard",
    "ja_JP": "Leaderboard Description",
    "ko_KR": "Leaderboard Description",
    "ms_MY": "Keterangan Carta Pendahulu",
    "pt_PT": "Descrição da Classificação",
    "ru_RU": "Описание рейтинга",
    "th_TH": "อธิบายตารางอันดับ",
    "tr_TR": "Sıralama Açıklaması",
    "ur": "لیڈر بورڈ کی تفصیل",
    "uz": "Yetakchilar jadvalining tavsifi",
    "vi_VN": "Mô Tả BXH",
    "zh_CN": "排行榜说明"
  },
  "club_rank_question": {
    "HK": "說明",
    "TW": "說明",
    "ar_SA": "الوصف",
    "de_DE": "Beschreibung",
    "en_US": "Description",
    "es_ES": "Descripción",
    "fr_FR": "Description",
    "hi_IN": "Description",
    "in_ID": "Deskripsi",
    "ja_JP": "Description",
    "ko_KR": "Description",
    "ms_MY": "Keterangan",
    "pt_PT": "Descrição",
    "ru_RU": "Описание",
    "th_TH": "คำอธิบาย",
    "tr_TR": "Açıklama",
    "ur": "تفصیل",
    "uz": "Tavsif",
    "vi_VN": "Mô Tả",
    "zh_CN": "说明"
  },
  "club_rank_setting": {
    "HK": "設定",
    "TW": "設定",
    "ar_SA": "الإعدادات",
    "de_DE": "Einstellungen",
    "en_US": "Settings",
    "es_ES": "Ajustes",
    "fr_FR": "Paramètres",
    "hi_IN": "Settings",
    "in_ID": "Pengaturan",
    "ja_JP": "Settings",
    "ko_KR": "Settings",
    "ms_MY": "Tetapan",
    "pt_PT": "Configurações",
    "ru_RU": "Настройки",
    "th_TH": "ตั้งค่า",
    "tr_TR": "Ayarlar",
    "ur": "‏سیٹنگز",
    "uz": "Sozlamalar",
    "vi_VN": "Cài đặt",
    "zh_CN": "设置"
  },
  "club_rank_setting_cancel": {
    "HK": "取消",
    "TW": "取消",
    "ar_SA": "إلغاء",
    "de_DE": "Abbrechen",
    "en_US": "Cancel",
    "es_ES": "Cancelar",
    "fr_FR": "Annuler",
    "hi_IN": "Cancel",
    "in_ID": "Batalkan",
    "ja_JP": "Cancel",
    "ko_KR": "Cancel",
    "ms_MY": "Batal",
    "pt_PT": "Cancelar",
    "ru_RU": "Отмена",
    "th_TH": "ยกเลิก",
    "tr_TR": "İptal",
    "ur": "منسوخ کریں",
    "uz": "Bekor qilish",
    "vi_VN": "Hủy",
    "zh_CN": "取消"
  },
  "club_rank_setting_confirm": {
    "HK": "確認",
    "TW": "確定",
    "ar_SA": "تأكيد",
    "de_DE": "Bestätigen",
    "en_US": "Confirm",
    "es_ES": "Aceptar",
    "fr_FR": "Confirmer",
    "hi_IN": "Confirm",
    "in_ID": "Konfirmasi",
    "ja_JP": "Confirm",
    "ko_KR": "Confirm",
    "ms_MY": "Sahkan",
    "pt_PT": "Confirmar",
    "ru_RU": "Подтвердить",
    "th_TH": "ยืนยัน",
    "tr_TR": "Onayla",
    "ur": "تصدیق کریں",
    "uz": "Tasdiqlash",
    "vi_VN": "Đồng ý",
    "zh_CN": "确认"
  },
  "club_rank_setting_content": {
    "HK": "我的資訊不顯示於排行榜",
    "TW": "我的資訊不在排行榜顯示",
    "ar_SA": "عدم إدراج معلوماتي في لوحة الصدارة",
    "de_DE": "Meine Daten nicht in die Rangliste eintragen",
    "en_US": "Don't enter my information into the leaderboard",
    "es_ES": "No incluir mis datos en la tabla de clasificación",
    "fr_FR": "Ne pas inclure mes informations dans le classement",
    "hi_IN": "Don't enter my information into the leaderboard",
    "in_ID": "Jangan masukkan informasi saya ke Leaderboard",
    "ja_JP": "Don't enter my information into the leaderboard",
    "ko_KR": "Don't enter my information into the leaderboard",
    "ms_MY": "Jangan masukkan maklumat saya ke carta pendahulu",
    "pt_PT": "Não insira minhas informações na tabela de classificação",
    "ru_RU": "Не вносить мою информацию в рейтинг",
    "th_TH": "ไม่นำข้อมูลของฉันเข้าสู่ตารางอันดับ",
    "tr_TR": "Bilgilerimi sıralama tablosunda gösterme",
    "ur": "میری معلومات لیڈر بورڈ میں داخل نہیں کریں",
    "uz": "Maʼlumotlarimni sardorlar jadvaliga kiritmang",
    "vi_VN": "Không đưa thông tin của tôi vào bảng xếp hạng",
    "zh_CN": "我的信息不进入排行榜"
  },
  "club_rank_setting_swith": {
    "HK": "開關",
    "TW": "開關",
    "ar_SA": "تبديل",
    "de_DE": "Wechseln",
    "en_US": "Switch",
    "es_ES": "Cambiar",
    "fr_FR": "Commutateur",
    "hi_IN": "Switch",
    "in_ID": "Ganti",
    "ja_JP": "Switch",
    "ko_KR": "Switch",
    "ms_MY": "Tukar",
    "pt_PT": "Trocar",
    "ru_RU": "Переключить",
    "th_TH": "สวิตช์",
    "tr_TR": "Değiştir",
    "ur": "سوئچ کریں",
    "uz": "Almashtirish",
    "vi_VN": "Chuyển",
    "zh_CN": "开关"
  },
  "club_rank_setting_tips": {
    "HK": "啟用後，我的資訊將不顯示於排行榜，並且積分會清零。請謹慎操作！",
    "TW": "開啟後，我的資訊將不會在排行榜顯示，並且積分會清零。請謹慎操作！",
    "ar_SA": "بعد التمكين ، لن تدخل معلوماتك في لوحة المتصدرين. وسيتم مسح النقاط. الرجاء العمل بحذر!",
    "de_DE": "Nach der Aktivierung werden deine Daten nicht in die Rangliste aufgenommen. Und die Punkte werden gelöscht. Bitte mit Vorsicht vorgehen!",
    "en_US": "After enabling, your information will not enter the leaderboard. And the points will be cleared. Please operate with caution!",
    "es_ES": "Al ser habilitado, tu información no entrará en la tabla de clasificación. Y los puntos se borrarán. ¡Opere con precaución!",
    "fr_FR": "Une fois activé, vos informations ne figureront plus dans le classement. Et les points seront effacés. Veuillez agir avec prudence !",
    "hi_IN": "After enabling, your information will not enter the leaderboard. And the points will be cleared. Please operate with caution!",
    "in_ID": "Setelah diaktifkan, informasi kamu tidak akan masuk ke Leaderboard. Dan poin akan dihapus. Harap beroperasi dengan hati-hati!",
    "ja_JP": "After enabling, your information will not enter the leaderboard. And the points will be cleared. Please operate with caution!",
    "ko_KR": "After enabling, your information will not enter the leaderboard. And the points will be cleared. Please operate with caution!",
    "ms_MY": "Selepas mendayakannya, maklumat anda tidak akan dimasukkan ke carta pendahulu. Dan mata akan dibersihkan. Sila beroperasi dengan berhati-hati!",
    "pt_PT": "Depois de habilitar, suas informações não entrarão na tabela de classificação. E os pontos serão apagados. Por favor, opere com cuidado!",
    "ru_RU": "Если вы включите эту настройку, ваша информация не попадет в рейтинг. И баллы будут сняты. Пожалуйста, работайте с осторожностью!",
    "th_TH": "หลังจากเปิด ข้อมูลของคุณจะไม่ถูกนำเข้าสู่ตารางอันดับ และคะแนนจะถูกล้าง โปรดดำเนินการด้วยความระมัดระวัง",
    "tr_TR": "Bu ayar etkinleştirildiğinde bilgilerin sıralama tablosunda gösterilmez. Ve noktalar temizlenecek. Lütfen dikkatli çalışın!",
    "ur": "فعال کرنے کے بعد، آپ کی معلومات لیڈر بورڈ میں داخل نہیں ہوں گی۔ اور پوائنٹس صاف ہو جائیں گے۔ براہ کرم احتیاط سے کام کریں!",
    "uz": "Yoqilgandan soʻng, maʼlumotlaringiz sardorlar jadvaliga kiritilmaydi. Ballar tozalab tashlanadi. Ehtiyotkorlik bilan harakat qiling!",
    "vi_VN": "Sau khi bật, thông tin của bạn sẽ không được đưa vào bảng xếp hạng và số điểm sẽ bị xóa. Hãy suy nghĩ thật kỹ!",
    "zh_CN": "开启后，我的信息将不会进入排行榜，并且积分会清零。请谨慎操作！"
  },
  "club_rank_setting_title": {
    "HK": "私隱設定",
    "TW": "隱私設定",
    "ar_SA": "إعدادات الخصوصية",
    "de_DE": "Datenschutz-Einstellungen",
    "en_US": "Privacy Settings",
    "es_ES": "Configuración de privacidad",
    "fr_FR": "Paramètres de confidentialité",
    "hi_IN": "Privacy Settings",
    "in_ID": "Pengaturan Privasi",
    "ja_JP": "Privacy Settings",
    "ko_KR": "Privacy Settings",
    "ms_MY": "Tetapan Privasi",
    "pt_PT": "Ajustes de Privacidade",
    "ru_RU": "Настройки конфиденциальности",
    "th_TH": "ตั้งค่าความเป็นส่วนตัว",
    "tr_TR": "Gizlilik Ayarları",
    "ur": "پرائیویسی سیٹنگز",
    "uz": "Maxfiylik sozlamalari",
    "vi_VN": "Cài Đặt Quyền Riêng Tư",
    "zh_CN": "隐私设置"
  },
  "club_rank_week_title": {
    "HK": "俱樂部本週排行榜",
    "TW": "俱樂部本週排行榜",
    "ar_SA": "نادي لوحة الصدارة الأسبوعي",
    "de_DE": "Wöchentliche Club-Rangliste",
    "en_US": "Club Weekly Leaderboard",
    "es_ES": "Tabla de Clasificación Semanal del Club",
    "fr_FR": "Classement hebdomadaire du club",
    "hi_IN": "Club Weekly Leaderboard",
    "in_ID": "Club Weekly Leaderboard",
    "ja_JP": "Club Weekly Leaderboard",
    "ko_KR": "Club Weekly Leaderboard",
    "ms_MY": "Carta Pendahulu Mingguan Kelab",
    "pt_PT": "Classificação Semanal de Clube",
    "ru_RU": "Еженедельный рейтинг клуба",
    "th_TH": "อันดับคลับประจำสัปดาห์",
    "tr_TR": "Haftalık Kulüp Sıralaması",
    "ur": "کلب کا ہفتہ وار لیڈر بورڈ",
    "uz": "Klubning haftalik yetakchilari jadvali",
    "vi_VN": "BXH Tuần",
    "zh_CN": "俱乐部本周排行榜"
  },
  "club_title": {
    "HK": "俱樂部邀請函",
    "TW": "俱樂部邀請函",
    "ar_SA": "دعوة نادٍ",
    "de_DE": "CLUB-Einladung",
    "en_US": "CLUB Invitation",
    "es_ES": "Invitación de club",
    "fr_FR": "Invitation de club",
    "hi_IN": "CLUB Invitation",
    "in_ID": "Undangan Klub",
    "ja_JP": "CLUB Invitation",
    "ko_KR": "CLUB Invitation",
    "ms_MY": "Jemputan Kelab",
    "pt_PT": "Convite do CLUBe",
    "ru_RU": "Приглашение в клуб",
    "th_TH": "คำเชิญคลับ",
    "tr_TR": "Kulüp Daveti",
    "ur": "کلب کا دعوت نامہ",
    "uz": "CLUB taklifnomasi",
    "vi_VN": "Thư Mời Câu Lạc Bộ",
    "zh_CN": "俱乐部邀请函"
  },
  "common_submit": {
    "HK": "確認提交",
    "TW": "確定提交",
    "ar_SA": "إرسال",
    "de_DE": "Absenden",
    "en_US": "Submit",
    "es_ES": "Enviar",
    "fr_FR": "Envoyer",
    "hi_IN": "Submit",
    "in_ID": "Kirim",
    "ja_JP": "Submit",
    "ko_KR": "Submit",
    "ms_MY": "Serahkan",
    "pt_PT": "Enviar",
    "ru_RU": "Отправить",
    "th_TH": "ส่ง",
    "tr_TR": "Gönder",
    "ur": "جمع کروائیں",
    "uz": "Yuborish",
    "vi_VN": "Gửi",
    "zh_CN": "确认提交"
  },
  "day_since_created": {
    "HK": "%s 天",
    "TW": "%s天",
    "ar_SA": "%s من الأيام",
    "de_DE": "%s Tage",
    "en_US": "%s Day",
    "es_ES": "%s Días",
    "fr_FR": "%s jours",
    "hi_IN": "%s Day",
    "in_ID": "%s Hari",
    "ja_JP": "%s Day",
    "ko_KR": "%s Day",
    "ms_MY": "%s Hari",
    "pt_PT": "%s Dias",
    "ru_RU": "%s дн.",
    "th_TH": "%s วัน",
    "tr_TR": "%s Gün",
    "ur": "%s دن",
    "uz": "%s kun",
    "vi_VN": "%s Ngày",
    "zh_CN": "%s 天"
  },
  "days_since_created": {
    "HK": "%s 天",
    "TW": "%s天",
    "ar_SA": "%s من الأيام",
    "de_DE": "%s Tag",
    "en_US": "%s Days",
    "es_ES": "%s Día",
    "fr_FR": "%s jour",
    "hi_IN": "%s Days",
    "in_ID": "%s Hari",
    "ja_JP": "%s Days",
    "ko_KR": "%s Days",
    "ms_MY": "%s Hari",
    "pt_PT": "%s Dia",
    "ru_RU": "%s дн.",
    "th_TH": "%s วัน",
    "tr_TR": "%s Gün",
    "ur": "%s دن",
    "uz": "%s kun",
    "vi_VN": "%s Ngày",
    "zh_CN": "%s 天"
  },
  "editor_auth_game_name": {
    "HK": "編輯器玩法的遊戲名稱",
    "TW": "編輯器玩法的遊戲名稱",
    "ar_SA": "اسم اللعبة",
    "de_DE": "Name des Spiels",
    "en_US": "Game Name",
    "es_ES": "Nombre del juego",
    "fr_FR": "Nom du jeu",
    "hi_IN": "Game Name",
    "in_ID": "Nama Game",
    "ja_JP": "Game Name",
    "ko_KR": "Game Name",
    "ms_MY": "Nama Permainan",
    "pt_PT": "Nome do Jogo",
    "ru_RU": "Имя игры",
    "th_TH": "ชื่อเกม",
    "tr_TR": "Oyun İsmi",
    "ur": "گیم کا نام",
    "uz": "Oʻyin nomi",
    "vi_VN": "Tên Trò Chơi",
    "zh_CN": "编辑器玩法的游戏名称"
  },
  "editor_auth_head": {
    "HK": "請提交編輯器玩法的創作經驗證明資料",
    "TW": "請提交編輯器玩法的創作經驗證明資訊",
    "ar_SA": "قدم دليلًا على تجربتك باستخدام محرري الألعاب.",
    "de_DE": "Bitte weise nach, dass du Spiele-Editoren verwendet hast.",
    "en_US": "Please provide proof of using game editors.",
    "es_ES": "Proporciona pruebas de haber usado editores de juegos.",
    "fr_FR": "Fournissez des preuves de votre expérience dans l'utilisation d'éditeurs de jeu.",
    "hi_IN": "Please provide proof of using game editors.",
    "in_ID": "Sediakan bukti penggunaan editor game.",
    "ja_JP": "Please provide proof of using game editors.",
    "ko_KR": "Please provide proof of using game editors.",
    "ms_MY": "Sila berikan bukti menggunakan editor permainan.",
    "pt_PT": "Prove ter usado editores de jogos.",
    "ru_RU": "Предоставьте данные, подтверждающие опыт использования игровых редакторов.",
    "th_TH": "กรุณาส่งหลักฐานการใช้เครื่องมือปรับแต่งเกม",
    "tr_TR": "Lütfen oyun editörlerini kullandığını kanıtla.",
    "ur": "براہ کرم گیم ایڈیٹرز استعمال کرنے کے ثبوت فراہم کریں۔",
    "uz": "Oʻyin muharrirlaridan foydalanishni tasdiqlovchi hujjatni taqdim qiling.",
    "vi_VN": "Vui lòng cung cấp bằng chứng về kinh nghiệm sử dụng trình chỉnh sửa trò chơi.",
    "zh_CN": "请提交编辑器玩法的创作经验证明信息"
  },
  "editor_auth_input": {
    "HK": "請輸入遊戲名稱",
    "TW": "請輸入遊戲名稱",
    "ar_SA": "حدد اسم اللعبة التي لديك خبرة فيها كمحرر.",
    "de_DE": "Bitte gib den Namen des Spiels ein, bei dem du Erfahrungen mit einem Editor gemacht hast.",
    "en_US": "Please enter the name of the game that you have game editing experience with.",
    "es_ES": "Especifica el nombre del juego con el que tiene experiencia usando editores de juegos.",
    "fr_FR": "Indiquez le nom du jeu pour lequel vous avez de l'expérience en tant qu'éditeur.",
    "hi_IN": "Please enter the name of the game that you have game editing experience with.",
    "in_ID": "Masukkan nama game yang yang pernah kamu edit.",
    "ja_JP": "Please enter the name of the game that you have game editing experience with.",
    "ko_KR": "Please enter the name of the game that you have game editing experience with.",
    "ms_MY": "Sila masukkan nama permainan yang anda pernah mempunyai pengalaman mengedit.",
    "pt_PT": "Digite o nome do jogo no qual você tem experiência em edição de jogos.",
    "ru_RU": "Укажите имя игры с которой у вас связан опыт использования игрового редактора.",
    "th_TH": "กรุณาใส่ชื่อเกมที่คุณเคยใช้เครื่องมือปรับแต่งเกม",
    "tr_TR": "Lütfen oyun düzenleme deneyimine sahip olduğun oyunun ismini gir.",
    "ur": "براہ کرم اس گیم کا نام درج کریں جس میں آپ کے پاس گیم کی ترمیم کاری کے حوالے سے تجربہ موجود ہے۔",
    "uz": "Oʻyinni sizning tahrirlash tajribangiz bor boʻlgan oʻyin nomini kiriting.",
    "vi_VN": "Vui lòng nhập tên trò chơi mà bạn có kinh nghiệm chỉnh sửa.",
    "zh_CN": "请输入游戏名称"
  },
  "editor_auth_input_len": {
    "HK": "最少4個字元",
    "TW": "最少4個字元",
    "ar_SA": "4 أحرف على الأقل.",
    "de_DE": "Mindestens 4 Zeichen.",
    "en_US": "At least 4 characters.",
    "es_ES": "Ingresa al menos 4 caracteres.",
    "fr_FR": "Au moins 4 caractères.",
    "hi_IN": "At least 4 characters.",
    "in_ID": "Minimal 4 karakter.",
    "ja_JP": "At least 4 characters.",
    "ko_KR": "At least 4 characters.",
    "ms_MY": "Sekurang-kurangnya 4 aksara.",
    "pt_PT": "Insira ao menos 4 caracteres.",
    "ru_RU": "Не менее 4 знаков.",
    "th_TH": "อย่างน้อย 4 ตัวอักษร",
    "tr_TR": "En az 4 karakter gir.",
    "ur": "کم از کم 4 حروف ہوں۔",
    "uz": "Kamida 4 ta belgi.",
    "vi_VN": "Ít nhất 4 ký tự.",
    "zh_CN": "最少4个字符"
  },
  "editor_auth_input_null": {
    "HK": "遊戲名稱不能為空白",
    "TW": "遊戲名稱不可空白",
    "ar_SA": "لا يمكن ترك اسم اللعبة فارغًا.",
    "de_DE": "Der Spielname darf nicht leer sein.",
    "en_US": "Game name cannot be empty.",
    "es_ES": "El nombre del juego no puede estar vacío.",
    "fr_FR": "Le nom du jeu ne peut pas être vide.",
    "hi_IN": "Game name cannot be empty.",
    "in_ID": "Nama game tidak boleh kosong.",
    "ja_JP": "Game name cannot be empty.",
    "ko_KR": "Game name cannot be empty.",
    "ms_MY": "Nama permainan tidak boleh kosong.",
    "pt_PT": "O nome do jogo não pode ficar em branco.",
    "ru_RU": "Поле с именем игры не может быть пустым",
    "th_TH": "ชื่อเกมไม่สามารถเว้นว่างได้",
    "tr_TR": "Oyun ismi boş bırakılamaz.",
    "ur": "گیم کا نام خالی نہیں ہو سکتا۔",
    "uz": "Oʻyin nomi boʻsh qolishi mumkin emas.",
    "vi_VN": "Không được để trống tên trò chơi.",
    "zh_CN": "游戏名称不能为空"
  },
  "editor_auth_login_hold": {
    "HK": "登入中，無法切換",
    "TW": "登入中，無法切換",
    "ar_SA": "عملية تسجيل الدخول قيد التشغيل. لا يمكن التغيير في الوقت الحالي.",
    "de_DE": "Einlogvorgang läuft. Momentan keine Änderung möglich.",
    "en_US": "Currently logging in. Cannot change at this time.",
    "es_ES": "No se puede cambiar; ya se está iniciando sesión.",
    "fr_FR": "En cours de connexion. Impossible de changer pour le moment.",
    "hi_IN": "Currently logging in. Cannot change at this time.",
    "in_ID": "Sedang login. Tidak bisa mengubah sekarang.",
    "ja_JP": "Currently logging in. Cannot change at this time.",
    "ko_KR": "Currently logging in. Cannot change at this time.",
    "ms_MY": "Sedang log masuk. Tidak boleh tukar pada masa ini.",
    "pt_PT": "Não é possível alterar neste momento por estar logando.",
    "ru_RU": "Невозможно изменить при входе в систему.",
    "th_TH": "กำลังล็อกอิน ไม่สามารถเปลี่ยนได้ในขณะนี้",
    "tr_TR": "Giriş yapılıyor. Şu an değiştirilemez.",
    "ur": "فی الحال لاگ ان کر رہے ہیں۔ اس وقت تبدیل نہیں کیا جا سکتا۔",
    "uz": "Hozir tizimga kirmoqda. Hozir o‘zgartirib bo‘lmaydi.",
    "vi_VN": "Đang đăng nhập. Không thể thay đổi lúc này.",
    "zh_CN": "登录中，无法切换"
  },
  "editor_auth_screenshot": {
    "HK": "請上傳證明截圖",
    "TW": "請上傳證明截圖",
    "ar_SA": "يُرجى تحميل لقطات صور كإثبات.",
    "de_DE": "Bitte lade zum Nachweis Screenshots hoch.",
    "en_US": "Please upload screenshots of proof.",
    "es_ES": "Sube capturas de pantalla como pruebas visuales.",
    "fr_FR": "Importez des preuves visuelles.",
    "hi_IN": "Please upload screenshots of proof.",
    "in_ID": "Unggah tangkapan layar sebagai bukti.",
    "ja_JP": "Please upload screenshots of proof.",
    "ko_KR": "Please upload screenshots of proof.",
    "ms_MY": "Sila muat naik syot layar bukti tersebut.",
    "pt_PT": "Envie capturas de tela como prova.",
    "ru_RU": "Загрузите изображения, подтверждающие данный факт.",
    "th_TH": "กรุณาอัปโหลดหลักฐานภาพสกรีนช็อต",
    "tr_TR": "Lütfen kanıt olarak ekran görüntüsü yükle.",
    "ur": "براہ کرم ثبوت کے اسکرین شاٹس اپ لوڈ کریں۔",
    "uz": "Dalilning skrinshotlarini yuklang.",
    "vi_VN": "Vui lòng tải lên ảnh chụp màn hình bằng chứng.",
    "zh_CN": "请上传证明截图"
  },
  "editor_auth_title": {
    "HK": "編輯器玩法經驗認證",
    "TW": "編輯器玩法經驗認證",
    "ar_SA": "التحقق من تجربة محرر اللعبة",
    "de_DE": "Spiele-Editor-Erlebnisverifizierung",
    "en_US": "Game Editor Experience Verification",
    "es_ES": "Verificación de la experiencia con el editor de juego",
    "fr_FR": "Vérification de l'expérience avec les éditeurs de jeu",
    "hi_IN": "Game Editor Experience Verification",
    "in_ID": "Verifikasi Pengalaman Editor Game",
    "ja_JP": "Game Editor Experience Verification",
    "ko_KR": "Game Editor Experience Verification",
    "ms_MY": "Pengesahan Pengalaman Editor Permainan",
    "pt_PT": "Verificação da experiência com o editor de jogos",
    "ru_RU": "Подтверждение опыта использования игровых редакторов",
    "th_TH": "การตรวจสอบประสบการณ์การปรับแต่งเกม",
    "tr_TR": "Oyun Editörlerinde Deneyim Doğrulaması",
    "ur": "گیم ایڈیٹر کے تجربے کی تصدیق",
    "uz": "Oʻyin muharriri tajribasini tekshirish",
    "vi_VN": "Xác Minh Kinh Nghiệm Dùng Trình Chỉnh Sửa Trò Chơi",
    "zh_CN": "编辑器玩法经验认证"
  },
  "editor_auth_upload_tips": {
    "HK": "（請上傳編輯玩法個人中心、創作的地圖作品等能夠證明你有創作經驗的截圖，最多4張）",
    "TW": "（請上傳編輯玩法個人中心、創作的地圖作品等能證明您有創作經驗的截圖，最多4張）",
    "ar_SA": "(يرجى تحميل لقطة شاشة لملف تعريف مستخدم محرر اللاعب وإنشاء خرائط/تعديلات/أوضاع ألعاب يمكن أن تثبت تجربتك. 4 ملفات كحد أقصى.)",
    "de_DE": "(Bitte lade einen Screenshot deines Spiele-Editor- und Nutzerprofils sowie von kreierten Karten/Mods/Spielmodi hoch, die deine Erfahrung belegen. Bis zu 4.)",
    "en_US": "(Please upload a screenshot of your gamer editor user profile and created maps/mods/game modes that can prove your experience. Up to 4.)",
    "es_ES": "(Sube una captura de pantalla de tu perfil de usuario en el editor de juego y mapas/mods/modos de juego que hayas creado y que demuestren tu experiencia. 4 imágenes como máximo).",
    "fr_FR": "(Importez une capture d'écran de votre profil utilisateur de l'éditeur du jeu et des cartes/mods/modes créés prouvant votre expérience. 4 fichiers max.)",
    "hi_IN": "(Please upload a screenshot of your gamer editor user profile and created maps/mods/game modes that can prove your experience. Up to 4.)",
    "in_ID": "(Harap unggah tangkapan layar profil pengguna editor gamer kamu serta peta/mod/mode permainan yang telah dibuat yang dapat membuktikan pengalamanmu. Maksimal 4.)",
    "ja_JP": "(Please upload a screenshot of your gamer editor user profile and created maps/mods/game modes that can prove your experience. Up to 4.)",
    "ko_KR": "(Please upload a screenshot of your gamer editor user profile and created maps/mods/game modes that can prove your experience. Up to 4.)",
    "ms_MY": "(Sila muat naik syot layar profil pengguna editor pemain anda dan cipta peta/mod/mod permainan yang boleh membuktikan pengalaman anda. Sehingga 4.)",
    "pt_PT": "(Envie uma captura de tela do perfil de usuário do seu editor de jogo e de mapas/mods/modos de jogo criados que possam provar sua experiência. Até 4.)",
    "ru_RU": "(Загрузите изображения своего пользовательского профиля в игровом редакторе и созданные карты/моды/режимы игры, которые могут подтвердить ваш опыт. До 4.)",
    "th_TH": "(กรุณาอัปโหลดภาพสกรีนช็อตโปรไฟล์ผู้ใช้เครื่องมือปรับแต่งเกมของคุณ รวมถึงแผนที่ที่สร้าง/mod/โหมดเกมเพื่อแสดงประสบการณ์ของคุณ สูงสุด 4 ภาพ)",
    "tr_TR": "(Lütfen oyun editörü kullanıcı profilinin ve deneyimini kanıtlayan bir harita/mod/oyun modu yapımının ekran görüntüsünü yükle. En fazla 4 tane yüklenebilir.)",
    "ur": "(براہ کرم اپنے گیمر ایڈیٹر کی صارف پروفائل اور تخلیق کردہ ایسے نقشوں/موڈز/ گیم موڈز کا اسکرین شاٹ اپ لوڈ کریں جو آپ کے تجربے کو ثابت کر سکیں۔ 4 تک۔)",
    "uz": "(Oʻyinchi-muharrir foydalanuvchi profili va tajribangizni tasdiqlovchi yaratilgan xaritalar/modlar/oʻyin rejimlarining skrinshotini yuklang. 4 tagacha.)",
    "vi_VN": "(Vui lòng tải lên ảnh chụp màn hình hồ sơ người dùng trình chỉnh sửa trò chơi của bạn và các bản đồ/bản mod/chế độ trò chơi đã tạo có thể chứng minh kinh nghiệm của bạn. Tối đa 4 ảnh.)",
    "zh_CN": "(请上传编辑玩法个人中心，创作的地图作品等能够证明有创作经验的截图，最多4张)"
  },
  "feed_bottom_open_comment": {
    "HK": "開啟PUBG MOBILE查看更多評論",
    "TW": "開啟PUBG MOBILE查看更多評論",
    "ar_SA": "افتح PUBG MOBILE لعرض المزيد من التعليقات",
    "de_DE": "Öffne PUBG MOBILE, um mehr Kommentare zu sehen",
    "en_US": "Open PUBG MOBILE to view more comments",
    "es_ES": "Abre PUBG MOBILE para ver más comentarios",
    "fr_FR": "Ouvrez PUBG MOBILE pour voir plus de commentaires",
    "hi_IN": "Open PUBG MOBILE to view more comments",
    "in_ID": "Buka PUBG MOBILE untuk melihat lebih banyak komentar",
    "ja_JP": "Open PUBG MOBILE to view more comments",
    "ko_KR": "Open PUBG MOBILE to view more comments",
    "ms_MY": "Bukakan PUBG MOBILE untuk melihat lagi komen",
    "pt_PT": "Abra o PUBG MOBILE para ver mais comentários",
    "ru_RU": "Чтобы увидеть больше комментариев, откройте PUBG MOBILE",
    "th_TH": "เปิด PUBG MOBILE เพื่อดูความคิดเห็นเพิ่มเติม",
    "tr_TR": "Daha fazla yorum görmek için PUBG MOBILE'ı aç",
    "ur": "مزید تبصرے دیکھنے کے لیے PUBG MOBILE کھولیں",
    "uz": "Boshqa fikrlarni ko‘rish uchun PUBG MOBILE ilovasini oching",
    "vi_VN": "Vào PUBG MOBILE để xem thêm bình luận.",
    "zh_CN": "打开PUBG MOBILE查看更多评论"
  },
  "feed_club_desc": {
    "HK": "結交更多好友，討論交流，一起遊戲",
    "TW": "結交更多好友，討論交流，一起遊戲",
    "ar_SA": "تعرَّف على أصدقاء أكثر، ودردشوا والعبوا سويًا.",
    "de_DE": "Finde neue Freunde, diskutiert und spielt zusammen.",
    "en_US": "Make more friends, discuss and play together.",
    "es_ES": "Haz más amigos, debate y juega en equipo.",
    "fr_FR": "Faites-vous plus d'amis, discutez et jouez ensemble.",
    "hi_IN": "Make more friends, discuss and play together.",
    "in_ID": "Perbanyak teman, berdiskusi dan bermain bersama.",
    "ja_JP": "Make more friends, discuss and play together.",
    "ko_KR": "Make more friends, discuss and play together.",
    "ms_MY": "Kenali lebih ramai rakan, berbincang dan bermain bersama-sama.",
    "pt_PT": "Crie amizades, conversem e joguem juntos.",
    "ru_RU": "Заводите друзей, общайтесь и играйте вместе.",
    "th_TH": "ทำความรู้จักเพื่อนมากขึ้น, พูดคุย และเล่นเกมด้วยกัน",
    "tr_TR": "Daha çok arkadaş edin, birlikte tartışın ve oynayın.",
    "ur": "مزید دوست بنائیں، ان سے بات چیت کریں اور مل کر کھیلیں۔",
    "uz": "Koʻproq doʻstlar orttiring, muhokama qiling va birga oʻynang.",
    "vi_VN": "Làm quen nhiều bạn mới, thảo luận về game và cùng chơi với nhau.",
    "zh_CN": "发现更多好友，讨论交流，一起游戏"
  },
  "feed_club_title": {
    "HK": "俱樂部",
    "TW": "俱樂部",
    "ar_SA": "النادي",
    "de_DE": "Club",
    "en_US": "Club",
    "es_ES": "CLUB",
    "fr_FR": "Club",
    "hi_IN": "Club",
    "in_ID": "Klub",
    "ja_JP": "Club",
    "ko_KR": "Club",
    "ms_MY": "Kelab",
    "pt_PT": "CLUB",
    "ru_RU": "Клуб",
    "th_TH": "คลับ",
    "tr_TR": "Kulüp",
    "ur": "‏کلب",
    "uz": "Klub",
    "vi_VN": "Câu Lạc Bộ",
    "zh_CN": "俱乐部"
  },
  "feed_club_top_open": {
    "HK": "打開",
    "TW": "開啟",
    "ar_SA": "فتح",
    "de_DE": "Öffnen",
    "en_US": "Open",
    "es_ES": "Abrir",
    "fr_FR": "Ouvrir",
    "hi_IN": "Open",
    "in_ID": "Buka",
    "ja_JP": "Open",
    "ko_KR": "Open",
    "ms_MY": "Buka",
    "pt_PT": "Abrir",
    "ru_RU": "Открыть",
    "th_TH": "เปิด",
    "tr_TR": "Aç",
    "ur": "‏کھولیں",
    "uz": "Ochish",
    "vi_VN": "Mở",
    "zh_CN": "打开"
  },
  "feed_comments": {
    "HK": "評論",
    "TW": "評論",
    "ar_SA": "تعليقات",
    "de_DE": "Kommentare",
    "en_US": "Comments",
    "es_ES": "Comentarios",
    "fr_FR": "Commentaires",
    "hi_IN": "Comments",
    "in_ID": "Komentar",
    "ja_JP": "Comments",
    "ko_KR": "Comments",
    "ms_MY": "Komen",
    "pt_PT": "Comentários",
    "ru_RU": "Комментарии",
    "th_TH": "ความคิดเห็น",
    "tr_TR": "Yorumlar",
    "ur": "تبصرے",
    "uz": "Fikrlar",
    "vi_VN": "Bình Luận",
    "zh_CN": "评论"
  },
  "feed_join": {
    "HK": "加入",
    "TW": "加入",
    "ar_SA": "انضمام",
    "de_DE": "Teilnehmen",
    "en_US": "Join",
    "es_ES": "Unir",
    "fr_FR": "Rejoindre",
    "hi_IN": "Join",
    "in_ID": "Ikuti",
    "ja_JP": "Join",
    "ko_KR": "Join",
    "ms_MY": "Sertai",
    "pt_PT": "Participar",
    "ru_RU": "Участвовать",
    "th_TH": "เข้าร่วม",
    "tr_TR": "Katıl",
    "ur": "‏شامل ہوں",
    "uz": "Qoʻshilish",
    "vi_VN": "Tham Gia",
    "zh_CN": "加入"
  },
  "feed_joined": {
    "HK": "已加入",
    "TW": "已加入",
    "ar_SA": "تم الانضمام",
    "de_DE": "Beigetreten",
    "en_US": "Joined",
    "es_ES": "Ya se unió",
    "fr_FR": "A rejoint",
    "hi_IN": "Joined",
    "in_ID": "bergabung",
    "ja_JP": "Joined",
    "ko_KR": "Joined",
    "ms_MY": "Disertai",
    "pt_PT": "Entrou",
    "ru_RU": "Иду",
    "th_TH": "เข้าร่วมแล้ว",
    "tr_TR": "Katıldın",
    "ur": "شامل ہو گئے",
    "uz": "Qoʻshildi",
    "vi_VN": "Đã tham gia",
    "zh_CN": "已加入"
  },
  "feed_time_hour": {
    "HK": "%s小時前",
    "TW": "%s小時前",
    "ar_SA": "منذ %s س",
    "de_DE": "%sh",
    "en_US": "%s h",
    "es_ES": "%s h",
    "fr_FR": "%s h",
    "hi_IN": "%s h",
    "in_ID": "%s jam yang lalu",
    "ja_JP": "%s h",
    "ko_KR": "%s h",
    "ms_MY": "%s j lalu",
    "pt_PT": "%s h",
    "ru_RU": "%s ч. назад",
    "th_TH": "%s ชั่วโมงก่อน",
    "tr_TR": "%ss önce",
    "ur": "‏%s گھنٹے",
    "uz": "%s soat",
    "vi_VN": "%s giờ trước",
    "zh_CN": "%s小时前"
  },
  "feed_time_min": {
    "HK": "%s分鐘前",
    "TW": "%s分鐘前",
    "ar_SA": "منذ %s د",
    "de_DE": "%sm",
    "en_US": "%s m",
    "es_ES": "%s m",
    "fr_FR": "%s m",
    "hi_IN": "%s m",
    "in_ID": "%s menit yang lalu",
    "ja_JP": "%s m",
    "ko_KR": "%s m",
    "ms_MY": "%s m lalu",
    "pt_PT": "%s m",
    "ru_RU": "%s мин. назад",
    "th_TH": "%s นาทีก่อน",
    "tr_TR": "%sdk önce",
    "ur": "‏%s منٹ",
    "uz": "%s daq",
    "vi_VN": "%s phút trước",
    "zh_CN": "%s分钟前"
  },
  "feed_time_now": {
    "HK": "剛剛",
    "TW": "剛剛",
    "ar_SA": "الآن",
    "de_DE": "Jetzt gerade",
    "en_US": "Just now",
    "es_ES": "Ahora mismo",
    "fr_FR": "À l'instant",
    "hi_IN": "Just now",
    "in_ID": "Baru saja",
    "ja_JP": "Just now",
    "ko_KR": "Just now",
    "ms_MY": "Sebentar tadi",
    "pt_PT": "Agora mesmo",
    "ru_RU": "Только что",
    "th_TH": "เมื่อสักครู่",
    "tr_TR": "Hemen şimdi",
    "ur": "بالکل ابھی",
    "uz": "Hozir",
    "vi_VN": "Vừa xong",
    "zh_CN": "刚刚"
  },
  "feed_title": {
    "HK": "帖子詳情",
    "TW": "貼文詳情",
    "ar_SA": "تفاصيل المنشور",
    "de_DE": "Postdetails",
    "en_US": "Post Detail",
    "es_ES": "Detalles de la publicación",
    "fr_FR": "Infos du billet",
    "hi_IN": "Post Detail",
    "in_ID": "Detil Posting",
    "ja_JP": "Post Detail",
    "ko_KR": "Post Detail",
    "ms_MY": "Butiran Siaran",
    "pt_PT": "Detalhes da Publicação",
    "ru_RU": "Сведения о публикации",
    "th_TH": "รายละเอียดการโพสต์",
    "tr_TR": "Gönderi Ayrıntıları",
    "ur": "پوسٹ کی تفصیل",
    "uz": "Post tafsilotlari",
    "vi_VN": "Chi Tiết Bài Đăng",
    "zh_CN": "帖子详情"
  },
  "media_auth_desc_1": {
    "HK": "請選擇你主要使用的社交媒體",
    "TW": "請選取您主要使用的社群媒體",
    "ar_SA": "حدد منصة الوسائط الاجتماعية الرئيسية الخاصة بك.",
    "de_DE": "Wähle deine bevorzugte Social-Media-Plattform.",
    "en_US": "Select your main social media platform.",
    "es_ES": "Selecciona tu plataforma principal de redes sociales.",
    "fr_FR": "Choisissez votre plateforme de réseau social principale.",
    "hi_IN": "Select your main social media platform.",
    "in_ID": "Pilih platform media sosial utama kamu.",
    "ja_JP": "Select your main social media platform.",
    "ko_KR": "Select your main social media platform.",
    "ms_MY": "Pilih platform media sosial utama anda.",
    "pt_PT": "Selecione sua plataforma de rede social principal.",
    "ru_RU": "Укажите свою основную соцплатформу.",
    "th_TH": "เลือกแพลตฟอร์มโซเชียลมีเดียหลักของคุณ",
    "tr_TR": "Ana sosyal medya platformunu seç.",
    "ur": "اپنا مرکزی سوشل میڈیا پلیٹ فارم منتخب کریں۔",
    "uz": "Asosiy ijtimoiy tarmoq platformangizni tanlang.",
    "vi_VN": "Chọn nền tảng mạng xã hội chính của bạn.",
    "zh_CN": "选择您主要的社交媒体"
  },
  "media_auth_desc_2": {
    "HK": "（提交時，將提交最終選擇的社交媒體資料）",
    "TW": "（提交時，會提交最後選取的社群媒體資訊）",
    "ar_SA": "(سيعتمد التقديم على معلومات وسائل التواصل الاجتماعي المختارة.)",
    "de_DE": "(Einreichung hängt von den gewählten Social Media-Informationen ab.)",
    "en_US": "(Submission will be based on the social media information chosen.)",
    "es_ES": "(La solicitud se basará en la red social que selecciones).",
    "fr_FR": "(La candidature sera basée sur la plateforme sélectionnée.)",
    "hi_IN": "(Submission will be based on the social media information chosen.)",
    "in_ID": "(Pengajuan akan didasarkan pada informasi media sosial yang dipilih.)",
    "ja_JP": "(Submission will be based on the social media information chosen.)",
    "ko_KR": "(Submission will be based on the social media information chosen.)",
    "ms_MY": "(Penyerahan akan berdasarkan maklumat media sosial yang dipilih.)",
    "pt_PT": "(O envio será baseado nas informações da rede social escolhida.)",
    "ru_RU": "(Заявка будет основываться на данных выбранной соцплатформы.)",
    "th_TH": "(การส่งจะอิงตามข้อมูลโซเชียลมีเดียที่ได้เลือกไว้)",
    "tr_TR": "(Katılım, seçilen sosyal medya bilgilerine göre düzenlenecektir.)",
    "ur": "(جمع کاری سوشل میڈیا کی منتخب کردہ معلومات پر مبنی ہو گی۔)",
    "uz": "(Yuborish tanlangan ijtimoiy tarmoq maʼlumotlariga asoslanadi.)",
    "vi_VN": "(Nội dung gửi sẽ dựa trên thông tin mạng xã hội được chọn.)",
    "zh_CN": "（提交时，会以最终选择的社媒信息进行提交）"
  },
  "media_auth_fail": {
    "HK": "審核未能通過，需於24小時後才能再次提交",
    "TW": "審核未通過，需24小時後才能再次提交",
    "ar_SA": "فشلت في اجتياز التحقق. يرجى الانتظار أكثر من 24 ساعة قبل التقديم مرة أخرى.",
    "de_DE": "Verifizierung fehlgeschlagen. Bitte warte 24 Stunden, bevor du erneut Daten einreichst.",
    "en_US": "Failed to pass verification. Please wait over 24 hours before submitting again.",
    "es_ES": "Error en la verificación. Espera 24 horas antes de enviarla de nuevo.",
    "fr_FR": "Votre dossier n'a pas été accepté. Veuillez patienter 24 heures avant de postuler à nouveau.",
    "hi_IN": "Failed to pass verification. Please wait over 24 hours before submitting again.",
    "in_ID": "Gagal lolos verifikasi. Mohon tunggu lebih dari 24 jam sebelum mengajukan kembali.",
    "ja_JP": "Failed to pass verification. Please wait over 24 hours before submitting again.",
    "ko_KR": "Failed to pass verification. Please wait over 24 hours before submitting again.",
    "ms_MY": "Gagal lulus pengesahan. Sila tunggu lebih 24 jam sebelum menyerahkan semula.",
    "pt_PT": "Verificação não aceita. Aguarde mais de 24 horas antes de reenviar.",
    "ru_RU": "Заявка на подтверждение была отклонена. Подождите 24 часа перед повторной отправкой.",
    "th_TH": "ไม่ผ่านการตรวจสอบ สามารถยื่นใหม่ได้อีกครั้งในอีก 24 ชั่วโมง",
    "tr_TR": "Doğrulama geçilemedi. Tekrar göndermeden önce en az 24 saat beklemelisin.",
    "ur": "تصدیق پاس کرنے میں ناکام۔ دوبارہ جمع کروانے سے قبل براہ کرم 24 گھنٹے انتظار کریں۔",
    "uz": "Tekshiruvdan o‘tib bo‘lmadi. Qayta yuborishdan oldin 24 soatdan koʻproq kuting.",
    "vi_VN": "Chưa thể xác minh. Vui lòng gửi lại sau hơn 24 giờ nữa.",
    "zh_CN": "审核未通过，需要超过24小时才能再次提交"
  },
  "media_auth_head": {
    "HK": "社交媒體支持者數目認證",
    "TW": "社群媒體粉絲人數認證",
    "ar_SA": "التحقق من عدد المتابعين على الشبكات التواصل الاجتماعي",
    "de_DE": "Verifizierung der Anzahl der Social-Media-Follower",
    "en_US": "Social Media Follower Count Verification",
    "es_ES": "Verificación de número de seguidores en redes sociales",
    "fr_FR": "Vérification du nombre d'abonnés sur les réseaux sociaux",
    "hi_IN": "Social Media Follower Count Verification",
    "in_ID": "Verifikasi Jumlah Pengikut Media Sosial",
    "ja_JP": "Social Media Follower Count Verification",
    "ko_KR": "Social Media Follower Count Verification",
    "ms_MY": "Pengesahan Kiraan Pengikut Media Sosial",
    "pt_PT": "Verificação de contagem de seguidores de rede social",
    "ru_RU": "Подтверждение числа подписчиков в соцсетях",
    "th_TH": "ตรวจสอบจำนวนผู้ติดตามบนโซเชียลมีเดีย",
    "tr_TR": "Sosyal Medya Takipçi Sayısı Doğrulaması",
    "ur": "سوشل میڈیا کے فالوور کی تعداد کی تصدیق",
    "uz": "Ijtimoiy tarmoqlardagi obunachilar sonini tekshirish",
    "vi_VN": "Xác Minh Số Người Theo Dõi Trên Mạng Xã Hội",
    "zh_CN": "社媒粉丝数认证"
  },
  "media_auth_input": {
    "HK": "請輸入你的社交媒體主頁連結",
    "TW": "請輸入您的社群媒體專頁連結",
    "ar_SA": "يُرجى توفير رابط الصفحة الرئيسية لشبكة التواصل الاجتماعي.",
    "de_DE": "Bitte gib den Link zu deiner Social-Media-Seite ein.",
    "en_US": "Please provide the link to your social media homepage.",
    "es_ES": "Proporciona el enlace a la página principal de tu red social.",
    "fr_FR": "Fournissez le lien vers la page d'accueil du réseau social.",
    "hi_IN": "Please provide the link to your social media homepage.",
    "in_ID": "Harap sediakan tautan ke beranda media sosialmu.",
    "ja_JP": "Please provide the link to your social media homepage.",
    "ko_KR": "Please provide the link to your social media homepage.",
    "ms_MY": "Sila berikan pautan ke laman utama media sosial anda.",
    "pt_PT": "Insira o link da sua página de rede social.",
    "ru_RU": "Предоставьте ссылку на главную страницу вашей соцплатформы.",
    "th_TH": "กรุณาใส่ลิ้งก์ของหน้าหลักโซเชียลมีเดียของคุณ",
    "tr_TR": "Lütfen sosyal medya hesabına ait sayfanın bağlantısını gir.",
    "ur": "براہ کرم اپنے سوشل میڈیا کے صفحہ اول کا لنک فراہم کریں۔",
    "uz": "Ijtimoiy tarmoqdagi bosh sahifangizga havolani taqdim qiling.",
    "vi_VN": "Hãy cung cấp liên kết dẫn đến trang chủ mạng xã hội của bạn.",
    "zh_CN": "请输入您的社媒主页链接"
  },
  "media_auth_link": {
    "HK": "填寫社交媒體主頁的連結",
    "TW": "填寫社群媒體專頁的連結",
    "ar_SA": "يُرجى توفير رابط الصفحة الرئيسية لشبكة التواصل الاجتماعي.",
    "de_DE": "Bitte gib den Link zu deiner Social-Media-Seite ein.",
    "en_US": "Please provide the link to your social media homepage.",
    "es_ES": "Proporciona el enlace a la página principal de tu red social.",
    "fr_FR": "Fournissez le lien vers la page d'accueil du réseau social.",
    "hi_IN": "Please provide the link to your social media homepage.",
    "in_ID": "Harap sediakan tautan ke beranda media sosialmu.",
    "ja_JP": "Please provide the link to your social media homepage.",
    "ko_KR": "Please provide the link to your social media homepage.",
    "ms_MY": "Sila berikan pautan ke laman utama media sosial anda.",
    "pt_PT": "Insira o link da sua página de rede social.",
    "ru_RU": "Предоставьте ссылку на главную страницу вашей соцплатформы.",
    "th_TH": "กรุณาใส่ลิ้งก์ของหน้าหลักโซเชียลมีเดียของคุณ",
    "tr_TR": "Lütfen sosyal medya hesabına ait sayfanın bağlantısını gir.",
    "ur": "براہ کرم اپنے سوشل میڈیا کے صفحہ اول کا لنک فراہم کریں۔",
    "uz": "Ijtimoiy tarmoqdagi bosh sahifangizga havolani taqdim qiling.",
    "vi_VN": "Hãy cung cấp liên kết dẫn đến trang chủ mạng xã hội của bạn.",
    "zh_CN": "填写社媒主页的链接"
  },
  "media_auth_link_empty": {
    "HK": "社交媒體主頁連結不能為空白",
    "TW": "社群媒體專頁連結不可空白",
    "ar_SA": "لا يمكن ترك رابط الصفحة الرئيسية لوسائل التواصل الاجتماعي فارغًا.",
    "de_DE": "Link zu der Social-Media-Seite darf nicht leer sein.",
    "en_US": "Social media homepage link cannot be empty.",
    "es_ES": "El enlace a la página principal de tu red social no puede estar vacío.",
    "fr_FR": "Le lien vers la page d'accueil du réseau social ne peut pas être vide.",
    "hi_IN": "Social media homepage link cannot be empty.",
    "in_ID": "Tautan beranda media sosial tidak boleh kosong.",
    "ja_JP": "Social media homepage link cannot be empty.",
    "ko_KR": "Social media homepage link cannot be empty.",
    "ms_MY": "Pautan halaman utama media sosial tidak boleh kosong.",
    "pt_PT": "O link da página da rede social não pode estar vazio.",
    "ru_RU": "Ссылка на главную страницу соцплатформы не может быть пустой.",
    "th_TH": "ลิ้งก์หน้าหลักของโซเชียลมีเดียไม่สามารถเว้นว่างได้",
    "tr_TR": "Sosyal medya sayfasının bağlantı adresi boş bırakılamaz.",
    "ur": "سوشل میڈیا کا صفحہ اول کا لنک خالی نہیں ہو سکتا۔",
    "uz": "Ijtimoiy tarmoq bosh sahifasi havolasi boʻsh qolishi mumkin emas.",
    "vi_VN": "Không được để trống liên kết trang chủ mạng xã hội.",
    "zh_CN": "社媒主页链接不能为空"
  },
  "media_auth_link_error": {
    "HK": "請輸入正確的社交媒體主頁連結",
    "TW": "請輸入正確的社群媒體專頁連結",
    "ar_SA": "يرجى توفير رابط صالح للصفحة الرئيسية لوسائل التواصل الاجتماعي.",
    "de_DE": "Bitte gib einen gültigen Link zu deiner Social-Media-Seite ein.",
    "en_US": "Please provide a valid social media homepage link.",
    "es_ES": "Proporciona un enlace válido a la página principal de tu red social.",
    "fr_FR": "Le lien de la page d'accueil du réseau social est incorrect.",
    "hi_IN": "Please provide a valid social media homepage link.",
    "in_ID": "Harap sediakan tautan beranda media sosial yang valid.",
    "ja_JP": "Please provide a valid social media homepage link.",
    "ko_KR": "Please provide a valid social media homepage link.",
    "ms_MY": "Sila berikan pautan halaman utama media sosial yang sah.",
    "pt_PT": "Insira um link válido da página da rede social.",
    "ru_RU": "Предоставьте действительную ссылку на главную страницу соцплатформы.",
    "th_TH": "กรุณาใส่ลิ้งก์หน้าหลักของโซเชียลมีเดียให้ถูกต้อง",
    "tr_TR": "Lütfen geçerli bir sosyal medya bağlantısı gir.",
    "ur": "براہ کرم سوشل میڈیا کے صفحہ اول کا درست لنک فراہم کریں۔",
    "uz": "Haqiqiy ijtimoiy tarmoq bosh sahifasi havolasini taqdim qiling.",
    "vi_VN": "Hãy cung cấp liên kết trang chủ mạng xã hội hợp lệ.",
    "zh_CN": "请输入正确的社媒主页链接"
  },
  "media_auth_login": {
    "HK": "登入社交媒體帳號以認證",
    "TW": "登入社群媒體帳號以認證",
    "ar_SA": "سجل الدخول إلى حساب الوسائط الاجتماعية الخاص بك للتحقق.",
    "de_DE": "Logge dich zur Verifizierung in deinen Social-Media-Account ein.",
    "en_US": "Log into your social media account to verify.",
    "es_ES": "Inicia sesión en tu cuenta de red social para confirmar.",
    "fr_FR": "Connectez-vous à votre compte de réseau social pour confirmer.",
    "hi_IN": "Log into your social media account to verify.",
    "in_ID": "Login ke akun media sosialmu untuk melakukan verifikasi.",
    "ja_JP": "Log into your social media account to verify.",
    "ko_KR": "Log into your social media account to verify.",
    "ms_MY": "Log masuk ke akaun media sosial anda untuk mengesahkan.",
    "pt_PT": "Faça login na sua conta de rede social para verificar.",
    "ru_RU": "Зайдите в свой аккаунт соцплатформы для подтверждения.",
    "th_TH": "ล็อกอินบัญชีโซเชียลมีเดียของคุณเพื่อทำการตรวจสอบ",
    "tr_TR": "Doğrulamak için sosyal medya hesabına giriş yap.",
    "ur": "تصدیق کرنے کے لیے اپنے سوشل میڈیا اکاؤنٹ میں لاگ ان کریں۔",
    "uz": "Tasdiqlash uchun ijtimoiy tarmoq akkauntingizni kiring.",
    "vi_VN": "Đăng nhập tài khoản mạng xã hội để xác minh.",
    "zh_CN": "登录社媒账号进行认证"
  },
  "media_auth_login_btn": {
    "HK": "點擊登入社交媒體帳號",
    "TW": "點按登入社群媒體帳號",
    "ar_SA": "اضغط لتسجيل الدخول إلى حساب الوسائط الاجتماعية",
    "de_DE": "Tippe, um dich in den Social-Media-Account einzuloggen",
    "en_US": "Tap to log into social media account",
    "es_ES": "Toca para iniciar sesión en tu cuenta de red social",
    "fr_FR": "Appuyez pour vous connecter à votre compte de réseau social",
    "hi_IN": "Tap to log into social media account",
    "in_ID": "Ketuk untuk login ke akun media sosial",
    "ja_JP": "Tap to log into social media account",
    "ko_KR": "Tap to log into social media account",
    "ms_MY": "Ketik untuk log masuk ke akaun media sosial",
    "pt_PT": "Toque para fazer login na sua conta de rede social",
    "ru_RU": "Нажмите для входа на аккаунт соцплатформы",
    "th_TH": "แตะเพื่อล็อกอินบัญชีโซเชียลมีเดีย",
    "tr_TR": "Sosyal medya hesabına giriş yapmak için dokun",
    "ur": "سوشل میڈیا اکاؤنٹ میں لاگ ان کرنے کے لیے ٹیپ کریں",
    "uz": "Ijtimoiy tarmoq akkauntiga kirish uchun tegining",
    "vi_VN": "Nhấn để đăng nhập tài khoản mạng xã hội",
    "zh_CN": "点击登录社媒账号"
  },
  "media_auth_message": {
    "HK": "你已經成功提交了認證資料，審核期間無法再次提交",
    "TW": "您已成功提交認證資訊，審核期間無法再次提交",
    "ar_SA": "قدمت مسبقًا المعلومات اللازمة ولا يمكنك إرسالها مرة أخرى خلال فترة التحقق.",
    "de_DE": "Du hast deine Informationen zur Verifizierung bereits eingereicht! Während du auf die Ergebnisse wartest, kannst du sie nicht erneut einreichen.",
    "en_US": "You've already submitted your information for verification! You cannot resubmit while waiting for results.",
    "es_ES": "Ya enviaste toda la información necesaria para la verificación y no puedes volver a enviarla mientras esperas los resultados.",
    "fr_FR": "Vous avez déjà transmis les informations nécessaires et ne pouvez pas les soumettre à nouveau pendant la période d'audit.",
    "hi_IN": "You've already submitted your information for verification! You cannot resubmit while waiting for results.",
    "in_ID": "Kamu telah mengirimkan informasi untuk verifikasi! Kamu tidak dapat mengirim ulang saat menunggu hasil.",
    "ja_JP": "You've already submitted your information for verification! You cannot resubmit while waiting for results.",
    "ko_KR": "You've already submitted your information for verification! You cannot resubmit while waiting for results.",
    "ms_MY": "Anda telah memberikan maklumat anda untuk pengesahan! Anda tidak boleh menyerahkan semula sementara menunggu keputusan.",
    "pt_PT": "Você já enviou suas informações para verificação! Você não pode reenviar enquanto aguarda os resultados.",
    "ru_RU": "Вы уже отправили свои данные для подтверждения! Повторная отправка данных в период рассмотрения невозможна.",
    "th_TH": "คุณส่งข้อมูลเพื่อทำการตรวจสอบแล้ว! โดยจะไม่สามารถส่งซ้ำได้ในระหว่างรอผล",
    "tr_TR": "Bilgilerini zaten doğrulama için gönderdin! Sonuçları beklerken tekrar gönderemezsin.",
    "ur": "آپ نے تصدیق کے لیے اپنی معلومات پہلے ہی جمع کروا دی ہیں! آپ نتائج کا انتظار کرنے کے دوران دوبارہ جمع نہیں کروا سکتے۔",
    "uz": "Maʼlumotlaringizni tekshirish uchun allaqachon yuborgansiz! Natijalarni kutayotganda qayta yubora olmaysiz.",
    "vi_VN": "Bạn đã gửi thông tin của mình để xác minh! Không thể gửi lại trong khi chờ kết quả.",
    "zh_CN": "您已经成功提交了认证信息，审核期间无法再次提交"
  },
  "media_auth_notice": {
    "HK": "提示",
    "TW": "提示",
    "ar_SA": "ملاحظة",
    "de_DE": "Hinweis",
    "en_US": "Notice",
    "es_ES": "Aviso",
    "fr_FR": "Avis",
    "hi_IN": "Notice",
    "in_ID": "Pemberitahuan",
    "ja_JP": "Notice",
    "ko_KR": "Notice",
    "ms_MY": "Notis",
    "pt_PT": "Aviso",
    "ru_RU": "Уведомление",
    "th_TH": "แจ้งเตือน",
    "tr_TR": "Dikkat",
    "ur": "‏نوٹس",
    "uz": "Eslatma",
    "vi_VN": "Chú ý",
    "zh_CN": "提示"
  },
  "media_auth_ok": {
    "HK": "確定",
    "TW": "確定",
    "ar_SA": "موافق",
    "de_DE": "OK",
    "en_US": "OK",
    "es_ES": "Aceptar",
    "fr_FR": "OK",
    "hi_IN": "OK",
    "in_ID": "Oke",
    "ja_JP": "OK",
    "ko_KR": "OK",
    "ms_MY": "OK",
    "pt_PT": "OK",
    "ru_RU": "OK",
    "th_TH": "ตกลง",
    "tr_TR": "Tamam",
    "ur": "‏ٹھیک ہے",
    "uz": "OK",
    "vi_VN": "Đồng ý",
    "zh_CN": "确定"
  },
  "media_auth_screenshot": {
    "HK": "上傳社交媒體主頁截圖",
    "TW": "上傳社群媒體專頁截圖",
    "ar_SA": "حمّل لقطات من الصفحة الرئيسية لوسائل التواصل الاجتماعي",
    "de_DE": "Lade Screenshots des Social-Media-Accounts hoch.",
    "en_US": "Upload social media homepage screenshots",
    "es_ES": "Sube capturas de pantalla de tu página principal de la red social",
    "fr_FR": "Importez des captures d'écran de la page d'accueil du réseau social.",
    "hi_IN": "Upload social media homepage screenshots",
    "in_ID": "Unggah tangkapan layar beranda media sosial",
    "ja_JP": "Upload social media homepage screenshots",
    "ko_KR": "Upload social media homepage screenshots",
    "ms_MY": "Muat naik syot layar laman utama media sosial",
    "pt_PT": "Envie capturas de tela da sua página de rede social",
    "ru_RU": "Загрузите изображение главной страницы соцплатформы.",
    "th_TH": "อัปโหลดภาพสกรีนช็อตหน้าหลักของโซเชียลมีเดีย",
    "tr_TR": "Sosyal medya sayfasının ekran görüntülerini yükle",
    "ur": "سوشل میڈیا کے صفحہ اول کے اسکرین شاٹس اپ لوڈ کریں",
    "uz": "Ijtimoiy tarmoqlardagi bosh sahifangiz skrinshotlarini yuklang",
    "vi_VN": "Tải lên ảnh chụp màn hình trang chủ mạng xã hội",
    "zh_CN": "上传社媒主页截图"
  },
  "media_auth_show": {
    "HK": "查看範例",
    "TW": "查看範例",
    "ar_SA": "عرض المثال",
    "de_DE": "Beispiel ansehen",
    "en_US": "View example",
    "es_ES": "Ver ejemplo",
    "fr_FR": "Voir un exemple",
    "hi_IN": "View example",
    "in_ID": "Lihat contoh",
    "ja_JP": "View example",
    "ko_KR": "View example",
    "ms_MY": "Lihat contoh",
    "pt_PT": "Ver exemplo",
    "ru_RU": "Просмотреть пример",
    "th_TH": "ดูตัวอย่าง",
    "tr_TR": "Örneği görüntüle",
    "ur": "مثال دیکھیں",
    "uz": "Misolni koʻrish",
    "vi_VN": "Xem ví dụ",
    "zh_CN": "查看示例"
  },
  "media_auth_success": {
    "HK": "成功提交",
    "TW": "提交成功",
    "ar_SA": "تم الإرسال!",
    "de_DE": "Eingereicht!",
    "en_US": "Submitted!",
    "es_ES": "¡Enviado!",
    "fr_FR": "Envoi terminé !",
    "hi_IN": "Submitted!",
    "in_ID": "Terkirim!",
    "ja_JP": "Submitted!",
    "ko_KR": "Submitted!",
    "ms_MY": "Diserahkan!",
    "pt_PT": "Enviado!",
    "ru_RU": "Отправлено!",
    "th_TH": "ส่งแล้ว!",
    "tr_TR": "Gönderildi!",
    "ur": "جمع ہو گئی!",
    "uz": "Yuborildi!",
    "vi_VN": "Đã gửi!",
    "zh_CN": "提交成功"
  },
  "media_auth_title": {
    "HK": "社交媒體支持者數目認證",
    "TW": "社群媒體粉絲人數認證",
    "ar_SA": "التحقق من عدد المتابعين على الشبكات التواصل الاجتماعي",
    "de_DE": "Verifizierung der Anzahl der Social-Media-Follower",
    "en_US": "Social Media Follower Count Verification",
    "es_ES": "Verificación de número de seguidores en redes sociales",
    "fr_FR": "Vérification du nombre d'abonnés sur les réseaux sociaux",
    "hi_IN": "Social Media Follower Count Verification",
    "in_ID": "Verifikasi Jumlah Pengikut Media Sosial",
    "ja_JP": "Social Media Follower Count Verification",
    "ko_KR": "Social Media Follower Count Verification",
    "ms_MY": "Pengesahan Kiraan Pengikut Media Sosial",
    "pt_PT": "Verificação de contagem de seguidores de rede social",
    "ru_RU": "Подтверждение числа подписчиков в соцсетях",
    "th_TH": "ตรวจสอบจำนวนผู้ติดตามบนโซเชียลมีเดีย",
    "tr_TR": "Sosyal Medya Takipçi Sayısı Doğrulaması",
    "ur": "سوشل میڈیا کے فالوور کی تعداد کی تصدیق",
    "uz": "Ijtimoiy tarmoqlardagi obunachilar sonini tekshirish",
    "vi_VN": "Xác Minh Số Người Theo Dõi Trên Mạng Xã Hội",
    "zh_CN": "社媒粉丝数认证"
  },
  "rank_title": {
    "HK": "俱樂部排行榜",
    "TW": "俱樂部排行榜",
    "ar_SA": "لوحة الصدارة",
    "de_DE": "Rangliste",
    "en_US": "Leaderboard",
    "es_ES": "Tabla de posiciones",
    "fr_FR": "Classement",
    "hi_IN": "Leaderboard",
    "in_ID": "Leaderboard",
    "ja_JP": "Leaderboard",
    "ko_KR": "Leaderboard",
    "ms_MY": "Carta Pendahulu",
    "pt_PT": "Classificação",
    "ru_RU": "Рейтинг",
    "th_TH": "ตารางอันดับ",
    "tr_TR": "Sıralama",
    "ur": "لیڈر بورڈ",
    "uz": "Yetakchilar jadvali",
    "vi_VN": "BXH Câu Lạc Bộ",
    "zh_CN": "俱乐部排行榜"
  },
  "space_accept_title": {
    "HK": "邀請列表",
    "TW": "邀請清單",
    "ar_SA": "قائمة الدعوات",
    "de_DE": "Einladungsliste",
    "en_US": "Invitation List",
    "es_ES": "Lista de Invitados",
    "fr_FR": "Liste d'invitations",
    "hi_IN": "Invitation List",
    "in_ID": "Daftar Undangan",
    "ja_JP": "Invitation List",
    "ko_KR": "Invitation List",
    "ms_MY": "Senarai Jemputan",
    "pt_PT": "Lista de Convites",
    "ru_RU": "Список приглашений",
    "th_TH": "รายการเชิญ",
    "tr_TR": "Davet Listesi",
    "ur": "‏دعوت نامے کی فہرست",
    "uz": "Takliflar roʻyxati",
    "vi_VN": "Danh Sách Mời",
    "zh_CN": "邀请列表"
  },
  "space_agree_invalid_msg": {
    "HK": "邀請無效",
    "TW": "邀請無效",
    "ar_SA": "دعوة غير صالحة",
    "de_DE": "Ungültige Einladung.",
    "en_US": "Invalid invitation.",
    "es_ES": "Invitación inválida",
    "fr_FR": "Invitation non valide",
    "hi_IN": "Invalid invitation.",
    "in_ID": "Undangan tidak valid.",
    "ja_JP": "Invalid invitation.",
    "ko_KR": "Invalid invitation.",
    "ms_MY": "Jemputan tidak sah.",
    "pt_PT": "Convite inválido.",
    "ru_RU": "Неверное приглашение.",
    "th_TH": "ไม่พบคำเชิญ",
    "tr_TR": "Geçersiz davet.",
    "ur": "دعوت نامہ غلط ہے۔",
    "uz": "Yaroqsiz taklifnoma.",
    "vi_VN": "Thư mời không hợp lệ",
    "zh_CN": "此邀请已失效"
  },
  "space_agree_invite": {
    "HK": "同意",
    "TW": "同意",
    "ar_SA": "قبول",
    "de_DE": "Annehmen",
    "en_US": "Accept",
    "es_ES": "Aceptar",
    "fr_FR": "Accepter",
    "hi_IN": "Accept",
    "in_ID": "Terima",
    "ja_JP": "Accept",
    "ko_KR": "Accept",
    "ms_MY": "Terima",
    "pt_PT": "Aceitar",
    "ru_RU": "Принять",
    "th_TH": "ตอบรับ",
    "tr_TR": "Kabul Et",
    "ur": "قبول کریں",
    "uz": "Qabul qilish",
    "vi_VN": "Đồng ý",
    "zh_CN": "同意"
  },
  "space_agree_msg": {
    "HK": "此邀請已被同意",
    "TW": "此邀請已被同意",
    "ar_SA": "قبل اللاعب الدعوة",
    "de_DE": "Spieler hat die Einladung angenommen.",
    "en_US": "Player has accepted the invitation.",
    "es_ES": "El jugador ha aceptado la invitación.",
    "fr_FR": "Ce joueur a accepté l'invitation.",
    "hi_IN": "Player has accepted the invitation.",
    "in_ID": "Pemain sudah menerima undangan.",
    "ja_JP": "Player has accepted the invitation.",
    "ko_KR": "Player has accepted the invitation.",
    "ms_MY": "Pemain telah menerima jemputan.",
    "pt_PT": "O jogador aceitou o convite.",
    "ru_RU": "Игрок принял приглашение.",
    "th_TH": "ผู้เล่นตอบรับคำเชิญแล้ว",
    "tr_TR": "Oyuncu, daveti kabul etti.",
    "ur": "پلیئر نے دعوت نامہ قبول کر لیا ہے۔",
    "uz": "Oʻyinchi taklifni qabul qildi.",
    "vi_VN": "Người chơi đã chấp nhận lời mời.",
    "zh_CN": "此邀请已被同意"
  },
  "space_cancel_invite": {
    "HK": "取消邀請",
    "TW": "取消邀請",
    "ar_SA": "إلغاء دعوة",
    "de_DE": "Einladung abbrechen",
    "en_US": "Cancel Invite",
    "es_ES": "Cancelar Invitación",
    "fr_FR": "Annuler l'invitation",
    "hi_IN": "Cancel Invite",
    "in_ID": "Batalkan Undangan",
    "ja_JP": "Cancel Invite",
    "ko_KR": "Cancel Invite",
    "ms_MY": "Batal Jemputan",
    "pt_PT": "Cancelar Convite",
    "ru_RU": "Отменить приглашение",
    "th_TH": "ยกเลิกคำเชิญ",
    "tr_TR": "Daveti İptal Et",
    "ur": "دعوت نامہ منسوخ کریں",
    "uz": "Taklifni bekor qilish",
    "vi_VN": "Hủy Lời Mời",
    "zh_CN": "取消邀请"
  },
  "space_change_bg": {
    "HK": "更換背景圖",
    "TW": "更換背景圖",
    "ar_SA": "تغيير الخلفية",
    "de_DE": "Hintergrund ändern",
    "en_US": "Change Background",
    "es_ES": "Cambiar fondo",
    "fr_FR": "Modifier l'arrière-plan",
    "hi_IN": "Change Background",
    "in_ID": "Ganti Latar Belakang",
    "ja_JP": "Change Background",
    "ko_KR": "Change Background",
    "ms_MY": "Tukar Latar Belakang",
    "pt_PT": "Mudar Im. de Fundo",
    "ru_RU": "Изменить фон",
    "th_TH": "เปลี่ยนพื้นหลัง",
    "tr_TR": "Arka Planı Değiştir",
    "ur": "پس منظر تبدیل کریں",
    "uz": "Fonni oʻzgartirish",
    "vi_VN": "Đổi Ảnh Nền",
    "zh_CN": "更换背景图"
  },
  "space_close_btn": {
    "HK": "關閉私人空間",
    "TW": "關閉私密空間",
    "ar_SA": "إغلاق المساحة الخاصة",
    "de_DE": "Privatbereich schließen",
    "en_US": "Close Private Space",
    "es_ES": "Cerrar Espacio Privado",
    "fr_FR": "Fermer l'espace privé",
    "hi_IN": "Close Private Space",
    "in_ID": "Tutup Space Pribadi",
    "ja_JP": "Close Private Space",
    "ko_KR": "Close Private Space",
    "ms_MY": "Tutup Ruang Peribadi",
    "pt_PT": "Fechar Espaço Privado",
    "ru_RU": "Закрыть частное пространство",
    "th_TH": "ปิดพื้นที่ส่วนตัว",
    "tr_TR": "Özel Alanı Kapat",
    "ur": "نجی اسپیس بند کریں",
    "uz": "Shaxsiy makonni yopish",
    "vi_VN": "Đóng Không Gian Riêng Tư",
    "zh_CN": "关闭私密空间"
  },
  "space_close_confirm_tips": {
    "HK": "請再次確定是否關閉你的私人空間？",
    "TW": "請再次確定是否關閉您的私密空間？",
    "ar_SA": "هل أنت متأكد من أنك تريد إغلاق مساحتك الخاصة؟",
    "de_DE": "Deinen Privatbereich wirklich schließen?",
    "en_US": "Are you sure you want to close your Private Space?",
    "es_ES": "¿Estás seguro de que quieres cerrar tu Espacio Privado?",
    "fr_FR": "Voulez-vous vraiment fermer votre espace privé ?",
    "hi_IN": "Are you sure you want to close your Private Space?",
    "in_ID": "Kamu yakin ingin menutup Space Pribadi kamu?",
    "ja_JP": "Are you sure you want to close your Private Space?",
    "ko_KR": "Are you sure you want to close your Private Space?",
    "ms_MY": "Adakah anda pasti ingin menutup Ruang Peribadi anda?",
    "pt_PT": "Tem certeza de que deseja fechar seu Espaço Privado?",
    "ru_RU": "Действительно закрыть частное пространство?",
    "th_TH": "คุณยืนยันที่จะปิดพื้นที่ส่วนตัวของคุณหรือไม่?",
    "tr_TR": "Özel Alanını kapatmak istediğinden emin misin?",
    "ur": "کیا آپ واقعی اپنی نجی اسپیس بند کرنا چاہتے ہیں؟",
    "uz": "Haqiqatan ham Shaxsiy makoningizni yopmoqchimisiz?",
    "vi_VN": "Bạn chắc chắn muốn đóng Không Gian Riêng Tư?",
    "zh_CN": "请再次确认是否关闭你的私密空间？"
  },
  "space_close_confirm_title": {
    "HK": "提示",
    "TW": "提示",
    "ar_SA": "النصائح",
    "de_DE": "Tipps",
    "en_US": "Tips",
    "es_ES": "Consejos",
    "fr_FR": "Conseils",
    "hi_IN": "Tips",
    "in_ID": "Tips",
    "ja_JP": "Tips",
    "ko_KR": "Tips",
    "ms_MY": "Panduan",
    "pt_PT": "Dicas",
    "ru_RU": "Советы",
    "th_TH": "แนะนำ",
    "tr_TR": "İpuçları",
    "ur": "تجاویز",
    "uz": "Maslahatlar",
    "vi_VN": "Chú ý",
    "zh_CN": "提示"
  },
  "space_close_friend_tips": {
    "HK": "你的好友已選擇關閉你們的私人空間。你可以重新邀請好友建立新的私人空間。",
    "TW": "您的好友已選擇關閉你們的私密空間。您可以重新邀請好友建立新的私密空間。",
    "ar_SA": "أغلق صديقك مساحتكما الخاصة. يمكنك دعوة أصدقائك مجددًا لإنشاء مساحة خاصة جديدة.",
    "de_DE": "Dein Freund hat euren Privatbereich geschlossen. Du kannst Freunde erneut einladen, um einen neuen Privatbereich zu erstellen.",
    "en_US": "Your friend has closed your Private Space. You can re-invite friends to create new Private Space.",
    "es_ES": "Tu amigo ha cerrado tu Espacio Privado. Puede volver a invitar a amigos para crear un nuevo Espacio Privado.",
    "fr_FR": "Votre ami a fermé votre espace privé. Vous pouvez inviter à nouveau vos amis ou créer un nouvel espace privé.",
    "hi_IN": "Your friend has closed your Private Space. You can re-invite friends to create new Private Space.",
    "in_ID": "Temanmu telah menutup Space Pribadi kamu. Kamu bisa kembali mengundang teman untuk membuat Space Pribadi baru.",
    "ja_JP": "Your friend has closed your Private Space. You can re-invite friends to create new Private Space.",
    "ko_KR": "Your friend has closed your Private Space. You can re-invite friends to create new Private Space.",
    "ms_MY": "Rakan anda telah menutup Ruang Peribadi anda. Anda boleh menjemput semula rakan untuk mencipta Ruang Peribadi baharu.",
    "pt_PT": "Seu amigo fechou seu Espaço Privado. Você pode convidar amigos novamente para criar um novo Espaço Privado.",
    "ru_RU": "Ваш друг закрыл ваше частное пространство. Можете пригласить друзей повторно, чтобы создать новое частное пространство.",
    "th_TH": "เพื่อนของคุณได้ปิดพื้นที่ส่วนตัวแล้ว โดยคุณสามารถเชิญเพื่อนเพื่อสร้างพื้นที่ส่วนตัวใหม่อีกครั้งได้",
    "tr_TR": "Arkadaşın Özel Alanını kapattı. Yeni bir Özel Alan oluşturmak için arkadaşlarını tekrar davet edebilirsin.",
    "ur": "آپ کے دوست نے آپ کی نجی اسپیس بند کر دی ہے۔ آپ نئی نجی اسپیس بنانے کے لیے دوستوں کو دوبارہ مدعو کر سکتے ہیں۔",
    "uz": "Doʻstingiz shaxsiy makoningizni yopdi. Yangi Shaxsiy makon yaratish uchun qaytadan doʻstlarni taklif qilish mumkin.",
    "vi_VN": "Bạn bè của bạn đã đóng Không Gian Riêng Tư. Bạn có thể mời lại bạn bè để tạo Không Gian Riêng Tư mới.",
    "zh_CN": "您的好友已选择关闭你们的私密空间。您可以重新邀请好友创建新的私密空间。"
  },
  "space_close_friend_title": {
    "HK": "關閉私人空間",
    "TW": "關閉私密空間",
    "ar_SA": "إغلاق المساحة الخاصة",
    "de_DE": "Privatbereich schließen",
    "en_US": "Close Private Space",
    "es_ES": "Cerrar Espacio Privado",
    "fr_FR": "Fermer l'espace privé",
    "hi_IN": "Close Private Space",
    "in_ID": "Tutup Space Pribadi",
    "ja_JP": "Close Private Space",
    "ko_KR": "Close Private Space",
    "ms_MY": "Tutup Ruang Peribadi",
    "pt_PT": "Fechar Espaço Privado",
    "ru_RU": "Закрыть частное пространство",
    "th_TH": "ปิดพื้นที่ส่วนตัว",
    "tr_TR": "Özel Alanı Kapat",
    "ur": "نجی اسپیس بند کریں",
    "uz": "Shaxsiy makonni yopish",
    "vi_VN": "Đóng Không Gian Riêng Tư",
    "zh_CN": "关闭私密空间"
  },
  "space_close_tips": {
    "HK": "請問你是否確定關閉你們的私人空間？ 確定後，你們的私人空間入口將會關閉。你可以重新邀請好友建立新的私密空間。",
    "TW": "請問您是否確定關閉你們的私密空間？確定後，你們的私密空間入口將會關閉。您可以重新邀請好友建立新的私密空間。",
    "ar_SA": "هل ترغب في إغلاق المساحة الخاصة؟ لن يكون الوصول إلى مساحتك الخاصة ممكنًا بعد الآن. يمكنك دعوة أصدقائك مجددًا لإنشاء مساحة خاصة جديدة.",
    "de_DE": "Privatbereich wirklich schließen? Dein Privatbereich ist dann nicht mehr zugänglich. Du kannst Freunde einladen, um einen neuen Privatbereich zu erstellen.",
    "en_US": "Close your Private Space? Your Private Space will no longer be accessible. You can re-invite friends to create a new Private Space.",
    "es_ES": "¿Cerrar tu Espacio Privado? Ya no se podrá acceder a tu Espacio Privado. Puedes volver a invitar a amigos para crear un nuevo Espacio Privado.",
    "fr_FR": "Fermer votre espace privé le rendra inaccessible. Continuer ? Vous pourrez inviter à nouveau vos amis ou créer un nouvel espace privé.",
    "hi_IN": "Close your Private Space? Your Private Space will no longer be accessible. You can re-invite friends to create a new Private Space.",
    "in_ID": "Tutup Space Pribadi kamu? Space Pribadi kamu tidak akan bisa lagi diakses. Kamu bisa kembali mengundang teman untuk membuat Space Pribadi baru.",
    "ja_JP": "Close your Private Space? Your Private Space will no longer be accessible. You can re-invite friends to create a new Private Space.",
    "ko_KR": "Close your Private Space? Your Private Space will no longer be accessible. You can re-invite friends to create a new Private Space.",
    "ms_MY": "Tutup Ruang Peribadi anda? Ruang Peribadi anda tidak akan lagi boleh diakses. Anda boleh menjemput semula rakan untuk mencipta Ruang Peribadi baharu.",
    "pt_PT": "Fechar seu Espaço Privado? Ele não poderá mais ser acessado. Você pode convidar amigos novamente para criar um novo Espaço Privado.",
    "ru_RU": "Закрыть частное пространство? После этого доступ к нему будет утрачен. Можете пригласить друзей повторно, чтобы создать новое частное пространство.",
    "th_TH": "ต้องการปิดพื้นที่ส่วนตัวของคุณหรือไม่? คุณจะไม่สามารถเข้าสู่พื้นที่ส่วนตัวของคุณได้อีก โดยคุณสามารถเชิญเพื่อนเพื่อสร้างพื้นที่ส่วนตัวใหม่อีกครั้งได้",
    "tr_TR": "Özel Alanını kapatacak mısın? Özel Alanına artık erişilemeyecek. Yeni bir Özel Alan oluşturmak için arkadaşlarını tekrar davet edebilirsin.",
    "ur": "آپ کی نجی اسپیس کو بند کریں؟ آپ کی نجی اسپیس مزید قابلِ رسائی نہیں رہے گی۔ آپ نئی نجی اسپیس بنانے کے لیے دوستوں کو دوبارہ مدعو کر سکتے ہیں۔",
    "uz": "Shaxsiy makoningizni yopasizmi? Shaxsiy makoningizga boshqa kirish imkoni bo‘lmaydi. Yangi shaxsiy makon yaratish uchun qaytadan doʻstlarni taklif qilish mumkin.",
    "vi_VN": "Đóng Không Gian Riêng Tư của bạn? Không Gian Riêng Tư của bạn sẽ không thể truy cập nữa. Bạn có thể mời lại bạn bè cùng tạo Không Gian Riêng Tư mới.",
    "zh_CN": "请问您是否确认关闭你们的私密空间？ 确认后，你们的私密空间入口将关闭。您可以重新邀请好友创建新的私密空间。"
  },
  "space_close_title": {
    "HK": "關閉私人空間",
    "TW": "關閉私密空間",
    "ar_SA": "إغلاق المساحة الخاصة",
    "de_DE": "Privatbereich schließen",
    "en_US": "Close Private Space",
    "es_ES": "Cerrar Espacio Privado",
    "fr_FR": "Fermer l'espace privé",
    "hi_IN": "Close Private Space",
    "in_ID": "Tutup Space Pribadi",
    "ja_JP": "Close Private Space",
    "ko_KR": "Close Private Space",
    "ms_MY": "Tutup Ruang Peribadi",
    "pt_PT": "Fechar Espaço Privado",
    "ru_RU": "Закрыть частное пространство",
    "th_TH": "ปิดพื้นที่ส่วนตัว",
    "tr_TR": "Özel Alanı Kapat",
    "ur": "نجی اسپیس بند کریں",
    "uz": "Shaxsiy makonni yopish",
    "vi_VN": "Đóng Không Gian Riêng Tư",
    "zh_CN": "关闭私密空间"
  },
  "space_closed": {
    "HK": "私人空間已被關閉",
    "TW": "私密空間已被關閉",
    "ar_SA": "أُغلقت المساحة الخاصة",
    "de_DE": "Privatbereich wurde geschlossen.",
    "en_US": "Private Space has been closed.",
    "es_ES": "El Espacio Privado ha sido cerrado.",
    "fr_FR": "L'espace privé a été fermé.",
    "hi_IN": "Private Space has been closed.",
    "in_ID": "Space Pribadi ditutup.",
    "ja_JP": "Private Space has been closed.",
    "ko_KR": "Private Space has been closed.",
    "ms_MY": "Ruang Peribadi telah ditutup.",
    "pt_PT": "O Espaço Privado foi fechado.",
    "ru_RU": "Частное пространство закрыто.",
    "th_TH": "พื้นที่ส่วนตัวถูกปิดแล้ว",
    "tr_TR": "Özel Alan kapatıldı.",
    "ur": "نجی اسپیس بند کر دی گئی ہے۔",
    "uz": "Shaxsiy makon yopildi.",
    "vi_VN": "Không Gian Riêng Tư đã đóng.",
    "zh_CN": "私密空间已被关闭"
  },
  "space_content_items": {
    "HK": "已發佈動態數：%s",
    "TW": "已發佈動態數：%s",
    "ar_SA": "عدد المنشورات: %s",
    "de_DE": "Anzahl der Beiträge: %s",
    "en_US": "Number of Posts: %s",
    "es_ES": "Número de publicaciones: %s",
    "fr_FR": "Publications : %s",
    "hi_IN": "Number of Posts: %s",
    "in_ID": "Jumlah Postingan: %s",
    "ja_JP": "Number of Posts: %s",
    "ko_KR": "Number of Posts: %s",
    "ms_MY": "Bilangan Hantaran: %s",
    "pt_PT": "Número de Publicações: %s",
    "ru_RU": "Количество публикаций: %s",
    "th_TH": "จำนวนโพสต์: %s",
    "tr_TR": "Gönderi Sayısı: %s",
    "ur": "پوسٹس کی تعداد: %s",
    "uz": "Postlar soni: %s",
    "vi_VN": "Số Bài Viết: %s",
    "zh_CN": "已发布动态数：%s"
  },
  "space_crop_bg": {
    "HK": "裁剪",
    "TW": "裁剪",
    "ar_SA": "حصّاد",
    "de_DE": "Zuschneiden",
    "en_US": "Crop",
    "es_ES": "Recortador",
    "fr_FR": "Recadreur",
    "hi_IN": "Crop",
    "in_ID": "Tanaman",
    "ja_JP": "Crop",
    "ko_KR": "Crop",
    "ms_MY": "Potong",
    "pt_PT": "Cortar",
    "ru_RU": "Обрезать",
    "th_TH": "พืชผล",
    "tr_TR": "Kırp",
    "ur": "کراپ کریں",
    "uz": "Qirqish",
    "vi_VN": "Cắt",
    "zh_CN": "裁剪"
  },
  "space_current_level": {
    "HK": "目前空間等級和經驗值",
    "TW": "目前空間等級和經驗值",
    "ar_SA": "نقاط الخبرة ومستوى المساحة الحاليان",
    "de_DE": "Aktueller Bereichlevel und EXP",
    "en_US": "Current Space Level and EXP",
    "es_ES": "Nivel y EXP de Espacio actual",
    "fr_FR": "Niv et EXP d'espace perso actuels",
    "hi_IN": "Current Space Level and EXP",
    "in_ID": "Level dan EXP Space Saat Ini",
    "ja_JP": "Current Space Level and EXP",
    "ko_KR": "Current Space Level and EXP",
    "ms_MY": "Tahap Ruang Semasa dan EXP",
    "pt_PT": "Nível e EXP Atuais do Espaço",
    "ru_RU": "Текущий уровень и опыт личного пространства",
    "th_TH": "เลเวลและ EXP พื้นที่ส่วนตัวขณะนี้",
    "tr_TR": "Mevcut Alan Seviyesi ve TP",
    "ur": "موجودہ اسپیس کا لیول اور EXP",
    "uz": "Joriy Shaxsiy makon darajasi va EXP",
    "vi_VN": "Cấp và EXP Không Gian Hiện Tại",
    "zh_CN": "当前空间等级和经验值"
  },
  "space_current_level_1": {
    "HK": "提升等級所需經驗值",
    "TW": "提升等級所需經驗值",
    "ar_SA": "نقاط الخبرة مطلوبة للارتقاء بالمستوى",
    "de_DE": "Erforderliche EXP zum Aufleveln",
    "en_US": "EXP Required to Level Up",
    "es_ES": "EXP requerida para subir de nivel",
    "fr_FR": "EXP requis pour niveau sup.",
    "hi_IN": "EXP Required to Level Up",
    "in_ID": "EXP Diperlukan untuk Naik Level",
    "ja_JP": "EXP Required to Level Up",
    "ko_KR": "EXP Required to Level Up",
    "ms_MY": "EXP Diperlukan untuk Naik Tahap",
    "pt_PT": "EXP para Subir de Nível",
    "ru_RU": "Опыт, необходимый для нового уровня",
    "th_TH": "EXP ที่ใช้ในการเพิ่มระดับ",
    "tr_TR": "Seviye Yükseltmek için Gereken TP",
    "ur": "لیول اپ کے لیے درکار EXP",
    "uz": "Darajani oshirish uchun EXP zarur",
    "vi_VN": "Yêu Cầu EXP để Nâng Cấp",
    "zh_CN": "提升等级所需经验值"
  },
  "space_current_level_10": {
    "HK": "發佈動態：1則10分 （同一空間每日最多100分）",
    "TW": "發佈動態：1則10分（同一空間每天最多100分）",
    "ar_SA": "انشر منشورات: +10 نقاط خبرة لكل منشور (حتى 100 نقطة خبرة في اليوم لنفس المساحة).",
    "de_DE": "Beiträge erstellen: +10 EXP pro Beitrag (bis zu 100 EXP pro Tag für denselben Bereich).",
    "en_US": "Make posts: +10 EXP per post (up to 100 EXP per day for the same Space).",
    "es_ES": "Hacer publicaciones: +10 de EXP por publicación (hasta 100 de EXP por día para el mismo Espacio).",
    "fr_FR": "Publier des billets : +10 EXP par publication (Jusqu'à 100 EXP par jour pour un même espace.)",
    "hi_IN": "Make posts: +10 EXP per post (up to 100 EXP per day for the same Space).",
    "in_ID": "Membuat postingan: +10 EXP per postingan (maksimal 100 EXP per hari untuk Space yang sama).",
    "ja_JP": "Make posts: +10 EXP per post (up to 100 EXP per day for the same Space).",
    "ko_KR": "Make posts: +10 EXP per post (up to 100 EXP per day for the same Space).",
    "ms_MY": "Cipta hantaran: +10 EXP bagi setiap hantaran (sehingga 100 EXP sehari untuk Ruang yang sama).",
    "pt_PT": "Fazer publicações: +10 EXP por publicação (até 100 EXP por dia para o mesmo Espaço).",
    "ru_RU": "Делайте публикации: +10 ед. опыта за публикацию (до 100 ед. в день в одном и том же пространстве).",
    "th_TH": "สร้างโพสต์: +10 EXP ต่อหนึ่งโพสต์ (สูงสุดวันละ 100 EXP สำหรับพื้นที่ส่วนตัวเดียวกัน)",
    "tr_TR": "Gönderi paylaşma: Gönderi başına +10 TP (aynı Alan için günlük maksimum 100 TP).",
    "ur": "پوسٹس بنائیں:فی پوسٹ +10 EXP (یکساں اسپیس کے لیے فی دن 100 EXP تک)۔",
    "uz": "Post qoldirish: Har bir post uchun +10 EXP (xuddi shu shaxsiy makon uchun kuniga 100 EXP gacha).",
    "vi_VN": "Tạo bài viết: Mỗi bài viết +10 EXP (cùng một Không Gian mỗi ngày tối đa 100 EXP).",
    "zh_CN": "发布动态：1条10分 （同一空间每日最多100分）"
  },
  "space_current_level_11": {
    "HK": "讚好動態：1次讚好5分，每則動態僅能讚好1次（同一空間每日最多50分）",
    "TW": "按讚動態：1次按讚5分，每則動態僅能按讚1次（同一空間每天最多50分）",
    "ar_SA": "إعجاب بالمنشورات: +5 نقاط خبرة لكل إعجاب، ويمكن الإعجاب بالمنشور مرة واحدة فقط (حتى 50 نقطة خبرة في اليوم لنفس المساحة).",
    "de_DE": "Beiträge liken: +5 EXP pro Like, jeder Beitrag kann nur einmal geliked werden (bis zu 50 EXP pro Tag für denselben Bereich).",
    "en_US": "Like posts: +5 EXP per like, each post can only be liked once (up to 50 EXP per day for the same Space).",
    "es_ES": "Me gusta de publicaciones: +5 de EXP por me gusta, cada publicación solo puede recibir me gusta una vez (hasta 50 de EXP por día para el mismo espacio).",
    "fr_FR": "Aimer des publications : +5 EXP par LIKE, un seul LIKE par billet (Jusqu'à 50 EXP par jour pour un même espace.)",
    "hi_IN": "Like posts: +5 EXP per like, each post can only be liked once (up to 50 EXP per day for the same Space).",
    "in_ID": "Menyukai postingan: +5 EXP per Suka, setiap postingan hanya bisa diberi Suka satu kali (maksimal 50 EXP per hari untuk Space yang sama).",
    "ja_JP": "Like posts: +5 EXP per like, each post can only be liked once (up to 50 EXP per day for the same Space).",
    "ko_KR": "Like posts: +5 EXP per like, each post can only be liked once (up to 50 EXP per day for the same Space).",
    "ms_MY": "Suka hantaran: +5 EXP bagi setiap suka, setiap hantaran hanya boleh disukai sebanyak sekali (sehingga 50 EXP setiap hari untuk Ruang yang sama).",
    "pt_PT": "Curtir publicações: +5 EXP por curtida. Cada publicação só pode ser curtida uma vez (até 50 EXP por dia para o mesmo Espaço).",
    "ru_RU": "Ставьте лайки публикациям: +5 ед. опыта за лайк; каждую публикацию можно оценить только один раз (до 50 ед. в день в одном и том же пространстве).",
    "th_TH": "ไลก์โพสต์: +5 EXP ต่อหนึ่งไลก์ สามารถไลก์ได้โพสต์ละ 1 ครั้งเท่านั้น (สูงสุดวันละ 50 EXP สำหรับพื้นที่ส่วนตัวเดียวกัน)",
    "tr_TR": "Gönderi beğenme: Beğeni başına +5 TP, her gönderi sadece bir defa beğenilebilir (aynı Alan için günlük maksimum 50 TP).",
    "ur": "پوسٹس لائک کریں: فی لائک +5 ،EXP ہر پوسٹ کو صرف ایک بار لائک کیا جا سکتا ہے (یکساں اسپیس کے لیے فی دن 50 EXP تک)۔",
    "uz": "Layk bosilgan postlar: har bir layk uchun +5 EXP, har bir postga faqat bir marta layk bosish mumkin (xuddi shu shaxsiy makon uchun kuniga 50 EXP gacha).",
    "vi_VN": "THÍCH bài viết: Mỗi lượt +5 EXP, mỗi bài viết chỉ có thể thích 1 lần (cùng một Không Gian mỗi ngày tối đa 50 EXP).",
    "zh_CN": "点赞动态：1次点赞5分，每条动态仅能点赞1次（同一空间每日最多50分）"
  },
  "space_current_level_12": {
    "HK": "評論動態：1則評論5分（同一空間每天最多150分）",
    "TW": "評論動態：1則評論5分（同一空間每天最多150分）",
    "ar_SA": "تعليق على المنشورات: +5 نقاط خبرة لكل تعليق (حتى 150 نقطة خبرة في اليوم لنفس المساحة).",
    "de_DE": "Beiträge kommentieren: +5 EXP pro Kommentar (bis zu 150 EXP pro Tag für denselben Bereich).",
    "en_US": "Comment on posts: +5 EXP per comment (up to 150 EXP per day for the same Space).",
    "es_ES": "Comentar publicaciones: +5 de EXP por comentario (hasta 150 de EXP por día para el mismo Espacio).",
    "fr_FR": "Commenter des publications : +5 EXP par commentaire (Jusqu'à 150 EXP par jour pour un même espace.)",
    "hi_IN": "Comment on posts: +5 EXP per comment (up to 150 EXP per day for the same Space).",
    "in_ID": "Mengomentari postingan: +5 EXP per komentar (maksimal 150 EXP per hari untuk Space yang sama).",
    "ja_JP": "Comment on posts: +5 EXP per comment (up to 150 EXP per day for the same Space).",
    "ko_KR": "Comment on posts: +5 EXP per comment (up to 150 EXP per day for the same Space).",
    "ms_MY": "Berikan komen pada hantaran: +5 EXP bagi setiap komen (sehingga 150 EXP setiap hari untuk Ruang yang sama).",
    "pt_PT": "Comentar em publicações: +5 EXP por comentário (até 150 EXP por dia para o mesmo Espaço).",
    "ru_RU": "Комментируйте публикации: +5 ед. опыта за комментарий (до 150 ед. в день в одном и том же пространстве).",
    "th_TH": "แสดงความเห็นบนโพสต์: +5 EXP ต่อหนึ่งความคิดเห็น (สูงสุดวันละ 150 EXP สำหรับพื้นที่ส่วนตัวเดียวกัน)",
    "tr_TR": "Gönderilere yorum yapma: Yorum başına +5 TP (aynı Alan için günlük maksimum 150 TP).",
    "ur": "پوسٹس پر تبصرہ کریں:فی تبصرہ +5 EXP (یکساں اسپیس کے لیے فی دن 150 EXP تک)۔",
    "uz": "Postlarga fikr bildirish: har bir fikr uchun +5 EXP (xuddi shu shaxsiy makon uchun kuniga 150 EXP gacha).",
    "vi_VN": "Bình luận bài viết: Mỗi bình luận +5 EXP (cùng một Không Gian mỗi ngày tối đa 150 EXP).",
    "zh_CN": "评论动态：1条评论5分（同一空间每日最多150分）"
  },
  "space_current_level_2": {
    "HK": "0-1級：5分",
    "TW": "0-1級：5分",
    "ar_SA": "المستوى 0-1: 5 نقاط خبرة",
    "de_DE": "Lv. 0–1: 5 EXP",
    "en_US": "Lv. 0–1: 5 EXP",
    "es_ES": "Niv. 0–1: 5 EXP",
    "fr_FR": "Niv. 0-1 : 5 EXP",
    "hi_IN": "Lv. 0–1: 5 EXP",
    "in_ID": "Lv. 0–1: 5 EXP",
    "ja_JP": "Lv. 0–1: 5 EXP",
    "ko_KR": "Lv. 0–1: 5 EXP",
    "ms_MY": "Thp. 0 - 1: 5 EXP",
    "pt_PT": "Nv. 0–1: 5 EXP",
    "ru_RU": "Ур. 0–1: 5 ед. опыта",
    "th_TH": "Lv.0 - 1: 5 EXP",
    "tr_TR": "Sv. 0-1: 5 TP",
    "ur": "لیول 0–1: 5 EXP",
    "uz": "0–1-daraja: 5 EXP",
    "vi_VN": "Cấp 0-1: 5 EXP",
    "zh_CN": "0-1级：5分"
  },
  "space_current_level_3": {
    "HK": "2-5級：50分",
    "TW": "2-5級：50分",
    "ar_SA": "المستوى 2-50: 50 نقطة خبرة",
    "de_DE": "Lv. 2–5: 50 EXP",
    "en_US": "Lv. 2–5: 50 EXP",
    "es_ES": "Niv. 2–5: 50 EXP",
    "fr_FR": "Niv. 2-5 : 50 EXP",
    "hi_IN": "Lv. 2–5: 50 EXP",
    "in_ID": "Lv. 2–5: 50 EXP",
    "ja_JP": "Lv. 2–5: 50 EXP",
    "ko_KR": "Lv. 2–5: 50 EXP",
    "ms_MY": "Thp. 2 - 5: 50 EXP",
    "pt_PT": "Nv. 2–50: 5 EXP",
    "ru_RU": "Ур. 2–5: 50 ед. опыта",
    "th_TH": "Lv.2 - 5: 50 EXP",
    "tr_TR": "Sv. 2-5: 50 TP",
    "ur": "لیول 2–5: 50 EXP",
    "uz": "2–5-daraja: 50 EXP",
    "vi_VN": "Cấp 2-50: 50 EXP",
    "zh_CN": "2-5级：50分"
  },
  "space_current_level_4": {
    "HK": "6-10級：100分",
    "TW": "6-10級：100分",
    "ar_SA": "المستوى 6-10: 100 نقطة من الخبرة",
    "de_DE": "Lv. 6–10: 100 EXP",
    "en_US": "Lv. 6–10: 100 EXP",
    "es_ES": "Niv. 6–10: 100 EXP",
    "fr_FR": "Niv. 6-10 : 100 EXP",
    "hi_IN": "Lv. 6–10: 100 EXP",
    "in_ID": "Lv. 6–10: 100 EXP",
    "ja_JP": "Lv. 6–10: 100 EXP",
    "ko_KR": "Lv. 6–10: 100 EXP",
    "ms_MY": "Thp. 6 - 10: 100 EXP",
    "pt_PT": "Nv. 6–10: 100 EXP",
    "ru_RU": "Ур. 6–10: 100 ед. опыта",
    "th_TH": "Lv.6 - 10: 100 EXP",
    "tr_TR": "Sv. 6-10: 100 TP",
    "ur": "لیول 6–10: 100 EXP",
    "uz": "6–10-daraja: 100 EXP",
    "vi_VN": "Cấp 6-10: 100 EXP",
    "zh_CN": "6-10级：100分"
  },
  "space_current_level_5": {
    "HK": "11-20級：500分",
    "TW": "11-20級：500分",
    "ar_SA": "المستوى 11-200: 500 نقطة خبرة",
    "de_DE": "Lv. 11–20: 500 EXP",
    "en_US": "Lv. 11–20: 500 EXP",
    "es_ES": "Niv. 11–20: 500 EXP",
    "fr_FR": "Niv. 11-20 : 500 EXP",
    "hi_IN": "Lv. 11–20: 500 EXP",
    "in_ID": "Lv. 11–20: 500 EXP",
    "ja_JP": "Lv. 11–20: 500 EXP",
    "ko_KR": "Lv. 11–20: 500 EXP",
    "ms_MY": "Thp. 11 - 20: 500 EXP",
    "pt_PT": "Nv. 11–20: 500 EXP",
    "ru_RU": "Ур. 11–20: 500 ед. опыта",
    "th_TH": "Lv.11 - 20: 500 EXP",
    "tr_TR": "Sv. 11-20: 500 TP",
    "ur": "لیول 11–20: 500 EXP",
    "uz": "11–20-daraja: 500 EXP",
    "vi_VN": "Cấp 11-20: 500 EXP",
    "zh_CN": "11-20级：500分"
  },
  "space_current_level_6": {
    "HK": "21-50級：500分",
    "TW": "21-50級：500分",
    "ar_SA": "المستوى 21-500: 500 نقطة خبرة",
    "de_DE": "Lv. 21–50: 500 EXP",
    "en_US": "Lv. 21–50: 500 EXP",
    "es_ES": "Niv. 21–50: 500 EXP",
    "fr_FR": "Niv. 21-50 : 500 EXP",
    "hi_IN": "Lv. 21–50: 500 EXP",
    "in_ID": "Lv. 21–50: 500 EXP",
    "ja_JP": "Lv. 21–50: 500 EXP",
    "ko_KR": "Lv. 21–50: 500 EXP",
    "ms_MY": "Thp. 21 - 50: 500 EXP",
    "pt_PT": "Nv. 21–50: 500 EXP",
    "ru_RU": "Ур. 21–50: 500 ед. опыта",
    "th_TH": "Lv.21 - 50: 500 EXP",
    "tr_TR": "Sv. 21-50: 500 TP",
    "ur": "لیول 21–50: 500 EXP",
    "uz": "21–50-daraja: 500 EXP",
    "vi_VN": "Cấp 21-50: 500 EXP",
    "zh_CN": "21-50级：500分"
  },
  "space_current_level_7": {
    "HK": "51-100級：1000分",
    "TW": "51-100級：1000分",
    "ar_SA": "المستوى 51-100: 1000 نقطة خبرة",
    "de_DE": "Lv. 51–100: 1000 EXP",
    "en_US": "Lv. 51–100: 1000 EXP",
    "es_ES": "Niv. 51–100: 1000 EXP",
    "fr_FR": "Niv. 51-100 : 1 000 EXP",
    "hi_IN": "Lv. 51–100: 1000 EXP",
    "in_ID": "Lv. 51–100: 1.000 EXP",
    "ja_JP": "Lv. 51–100: 1000 EXP",
    "ko_KR": "Lv. 51–100: 1000 EXP",
    "ms_MY": "Thp. 51 - 100: 1000 EXP",
    "pt_PT": "Nv. 51–100: 1000 EXP",
    "ru_RU": "Ур. 51–100: 1000 ед. опыта",
    "th_TH": "Lv.51 - 100: 1,000 EXP",
    "tr_TR": "Sv. 51-100: 1.000 TP",
    "ur": "لیول 51–100: 1000 EXP",
    "uz": "51–100-daraja: 1000 EXP",
    "vi_VN": "Cấp 51-100: 1000 EXP",
    "zh_CN": "51-100级：1000分"
  },
  "space_current_level_8": {
    "HK": "如何獲取經驗值",
    "TW": "如何獲取經驗值",
    "ar_SA": "كيفية كسب نقاط الخبرة",
    "de_DE": "Wie man EXP erhält",
    "en_US": "How to Gain EXP",
    "es_ES": "Cómo ganar EXP",
    "fr_FR": "Comment gagner de l'EXP",
    "hi_IN": "How to Gain EXP",
    "in_ID": "Cara Mendapatkan EXP",
    "ja_JP": "How to Gain EXP",
    "ko_KR": "How to Gain EXP",
    "ms_MY": "Cara Memperoleh EXP",
    "pt_PT": "Como Ganhar EXP",
    "ru_RU": "Получение опыта",
    "th_TH": "วิธีการรับ EXP",
    "tr_TR": "Nasıl TP Kazanılır",
    "ur": "‏EXP حاصل کرنے کا طریقہ کار",
    "uz": "EXP qanday olinadi",
    "vi_VN": "Cách Nhận EXP",
    "zh_CN": "如何获取经验值"
  },
  "space_current_level_9": {
    "HK": "初次設定空間名稱或背景圖：+5分（同一空間最多10分）",
    "TW": "初次設定空間名稱或背景圖：+5分（同一空間最多10分）",
    "ar_SA": "عيّين اسم أو صورة خلفية للمساحة لأول مرة: +5 نقاط خبرة (حتى 10 نقاط خبرة لنفس المساحة).",
    "de_DE": "Lege zum ersten Mal einen Bereichsnamen oder ein Hintergrundbild fest:  +5 EXP (bis zu 10 EXP für denselben Bereich).",
    "en_US": "Set a Space name or background image for the first time:  +5 EXP (up to 10 EXP for the same Space).",
    "es_ES": "Establece un nombre de Espacio o imagen de fondo por primera vez: +5 de EXP (hasta 10 de EXP para el mismo Espacio).",
    "fr_FR": "Définir un nom ou un arrière-plan d'espace perso pour la première fois : +5 EXP (Jusqu'à 10 EXP pour un même espace.)",
    "hi_IN": "Set a Space name or background image for the first time:  +5 EXP (up to 10 EXP for the same Space).",
    "in_ID": "Tetapkan nama atau gambar latar belakang Space untuk pertama kalinya: +5 EXP (maksimal 10 EXP untuk Space yang sama).",
    "ja_JP": "Set a Space name or background image for the first time:  +5 EXP (up to 10 EXP for the same Space).",
    "ko_KR": "Set a Space name or background image for the first time:  +5 EXP (up to 10 EXP for the same Space).",
    "ms_MY": "Tetapkan nama Ruang atau imej latar belakang untuk kali pertama: +5 EXP (sehingga 10 EXP untuk Ruang yang sama).",
    "pt_PT": "Definir o nome ou a imagem de fundo de um Espaço pela primeira vez: +5 EXP (até 10 EXP para o mesmo Espaço).",
    "ru_RU": "Впервые задайте имя или фон личного пространства: +5 ед. опыта (вплоть до 10 ед. в одном и том же пространстве).",
    "th_TH": "ตั้งชื่อและภาพพื้นหลังพื้นที่ส่วนตัวเป็นครั้งแรก: +5 EXP (สูงสุด 10 EXP สำหรับพื้นที่ส่วนตัวเดียวกัน)",
    "tr_TR": "İlk kez Alan adı veya arka plan resmi belirleme: +5 TP (aynı Alan için maksimum 10 TP).",
    "ur": "پہلی مرتبہ اسپیس کا نام یا پس منظر کی تصویر سیٹ کریں: +5 EXP (یکساں اسپیس کے لیے 10 EXP تک)۔",
    "uz": "Birinchi marta shaxsiy makon nomi yoki fon rasmini oʻrnating: +5 EXP (xuddi shu shaxsiy makon uchun 10 EXP gacha).",
    "vi_VN": "Đặt tên hoặc hình nền Không Gian lần đầu: +5 EXP (cùng một Không Gian tối đa 10 EXP).",
    "zh_CN": "初次设置空间名称或背景图：+5分（同一空间最多10分）"
  },
  "space_default_name": {
    "HK": "我們的私人空間",
    "TW": "我們的私密空間",
    "ar_SA": "مساحتنا الخاصة",
    "de_DE": "Unser Privatbereich",
    "en_US": "Our Private Space",
    "es_ES": "Nuestro Espacio Privado",
    "fr_FR": "Notre espace privé",
    "hi_IN": "Our Private Space",
    "in_ID": "Space Pribadi Kami",
    "ja_JP": "Our Private Space",
    "ko_KR": "Our Private Space",
    "ms_MY": "Ruang Peribadi Kami",
    "pt_PT": "Nosso Espaço Privado",
    "ru_RU": "Наше частное пространство",
    "th_TH": "พื้นที่ส่วนตัวของเรา",
    "tr_TR": "Özel Alanımız",
    "ur": "ہماری نجی اسپیس",
    "uz": "Shaxsiy makonimiz",
    "vi_VN": "Không Gian Tiêng Tư Của Chúng Tôi",
    "zh_CN": "我们的私密空间"
  },
  "space_delete_feed": {
    "HK": "刪除",
    "TW": "刪除",
    "ar_SA": "حذف",
    "de_DE": "Löschen",
    "en_US": "Delete",
    "es_ES": "Eliminar",
    "fr_FR": "Effacer",
    "hi_IN": "Delete",
    "in_ID": "Hapus",
    "ja_JP": "Delete",
    "ko_KR": "Delete",
    "ms_MY": "Padam",
    "pt_PT": "Excluir",
    "ru_RU": "Удалить",
    "th_TH": "ลบ",
    "tr_TR": "Sil",
    "ur": "‏حذف کریں",
    "uz": "Oʻchirish",
    "vi_VN": "Xóa",
    "zh_CN": "删除"
  },
  "space_feed_belong": {
    "HK": "僅私人空間可見",
    "TW": "僅可在私密空間看見",
    "ar_SA": "مرئي فقط في المساحة الخاصة",
    "de_DE": "Nur im Privatbereich sichtbar",
    "en_US": "Only Visible in Private Space",
    "es_ES": "Solo visible en el Espacio Privado",
    "fr_FR": "Visible uniquement dans l'espace privé",
    "hi_IN": "Only Visible in Private Space",
    "in_ID": "Hanya Terlihat di Space Pribadi",
    "ja_JP": "Only Visible in Private Space",
    "ko_KR": "Only Visible in Private Space",
    "ms_MY": "Hanya Boleh Dilihat dalam Ruang Peribadi",
    "pt_PT": "Visível Apenas no Espaço Privado",
    "ru_RU": "Видно только в частном пространстве",
    "th_TH": "สามารถเห็นได้แค่ในพื้นที่ส่วนตัว",
    "tr_TR": "Sadece Özel Alanda Görülebilir",
    "ur": "صرف نجی اسپیس میں ظاہر ہوتا ہے",
    "uz": "Faqat Shaxsiy makonda koʻrinadi",
    "vi_VN": "Chỉ Hiển Thị Trong Không Gian Riêng Tư",
    "zh_CN": "仅私密空间可见"
  },
  "space_invitation_cancel": {
    "HK": "已取消",
    "TW": "已取消",
    "ar_SA": "إلغاء",
    "de_DE": "Abgebrochen.",
    "en_US": "Canceled.",
    "es_ES": "Cancelado.",
    "fr_FR": "Annulée.",
    "hi_IN": "Canceled.",
    "in_ID": "Dibatalkan.",
    "ja_JP": "Canceled.",
    "ko_KR": "Canceled.",
    "ms_MY": "Dibatalkan.",
    "pt_PT": "Cancelado.",
    "ru_RU": "Отменено.",
    "th_TH": "ยกเลิกแล้ว",
    "tr_TR": "İptal Edildi.",
    "ur": "منسوخ ہو گیا۔",
    "uz": "Bekor qilingan.",
    "vi_VN": "Đã hủy.",
    "zh_CN": "已取消"
  },
  "space_invitation_list": {
    "HK": "邀請列表",
    "TW": "邀請清單",
    "ar_SA": "قائمة الدعوات",
    "de_DE": "Einladungsliste",
    "en_US": "Invitation List",
    "es_ES": "Lista de Invitados",
    "fr_FR": "Liste d'invitations",
    "hi_IN": "Invitation List",
    "in_ID": "Daftar Undangan",
    "ja_JP": "Invitation List",
    "ko_KR": "Invitation List",
    "ms_MY": "Senarai Jemputan",
    "pt_PT": "Lista de Convites",
    "ru_RU": "Список приглашений",
    "th_TH": "รายการเชิญ",
    "tr_TR": "Davet Listesi",
    "ur": "‏دعوت نامے کی فہرست",
    "uz": "Takliflar roʻyxati",
    "vi_VN": "Danh Sách Mời",
    "zh_CN": "邀请列表"
  },
  "space_invitation_sent": {
    "HK": "已發送邀請",
    "TW": "已傳送邀請",
    "ar_SA": "تم إرسال الدعوة",
    "de_DE": "Einladung gesendet.",
    "en_US": "Invitation sent.",
    "es_ES": "Invitación enviada.",
    "fr_FR": "Invitation envoyée.",
    "hi_IN": "Invitation sent.",
    "in_ID": "Undangan terkirim.",
    "ja_JP": "Invitation sent.",
    "ko_KR": "Invitation sent.",
    "ms_MY": "Jemputan dihantar.",
    "pt_PT": "Convite enviado.",
    "ru_RU": "Приглашение отправлено.",
    "th_TH": "ส่งคำเชิญแล้ว",
    "tr_TR": "Davet gönderildi.",
    "ur": "دعوت نامہ بھیج دیا گیا۔",
    "uz": "Taklif yuborildi.",
    "vi_VN": "Đã gửi lời mời.",
    "zh_CN": "已发送邀请"
  },
  "space_invite": {
    "HK": "邀請",
    "TW": "邀請",
    "ar_SA": "دعوة",
    "de_DE": "Einladen",
    "en_US": "Invite",
    "es_ES": "Invitar",
    "fr_FR": "Inviter",
    "hi_IN": "Invite",
    "in_ID": "Undang",
    "ja_JP": "Invite",
    "ko_KR": "Invite",
    "ms_MY": "Jemput",
    "pt_PT": "Convidar",
    "ru_RU": "Пригласить",
    "th_TH": "เชิญ",
    "tr_TR": "Davet Et",
    "ur": "‏مدعو کریں",
    "uz": "Taklif qilish",
    "vi_VN": "Mời vào Đội",
    "zh_CN": "邀请"
  },
  "space_invite_dialog_title": {
    "HK": "邀請",
    "TW": "邀請",
    "ar_SA": "دعوة",
    "de_DE": "Einladen",
    "en_US": "Invite",
    "es_ES": "Invitar",
    "fr_FR": "Inviter",
    "hi_IN": "Invite",
    "in_ID": "Undang",
    "ja_JP": "Invite",
    "ko_KR": "Invite",
    "ms_MY": "Jemput",
    "pt_PT": "Convidar",
    "ru_RU": "Пригласить",
    "th_TH": "เชิญ",
    "tr_TR": "Davet Et",
    "ur": "‏مدعو کریں",
    "uz": "Taklif qilish",
    "vi_VN": "Mời vào Đội",
    "zh_CN": "邀请"
  },
  "space_invite_tips": {
    "HK": "邀請你最親密的好友來建立專屬的私人空間吧！",
    "TW": "邀請您最親密的好友來建立專屬的私密空間吧！",
    "ar_SA": "ادعُ صديقك المقرب لإنشاء مساحة خاصة حصرية معًا",
    "de_DE": "Laden deinen besten Freund ein, um gemeinsam einen exklusiven Privatbereich zu erstellen!",
    "en_US": "Invite your best friend to create an exclusive Private Space together!",
    "es_ES": "¡Invita a tu mejor amigo a crear juntos un Espacio Privado exclusivo!",
    "fr_FR": "Invitez votre meilleur ami et créez un espace privé exclusif ensemble !",
    "hi_IN": "Invite your best friend to create an exclusive Private Space together!",
    "in_ID": "Undang sahabatmu untuk membuat Space Pribadi eksklusif bersama-sama!",
    "ja_JP": "Invite your best friend to create an exclusive Private Space together!",
    "ko_KR": "Invite your best friend to create an exclusive Private Space together!",
    "ms_MY": "Jemput rakan karib anda untuk mencipta Ruang Peribadi eksklusif bersama-sama!",
    "pt_PT": "Convide seu melhor amigo para criar um Espaço Privado exclusivo com você!",
    "ru_RU": "Пригласите лучшего друга вместе создать эксклюзивное частное пространство!",
    "th_TH": "เชิญเพื่อนที่คุณสนิทที่สุดมาสร้างพื้นที่ส่วนตัวสุดพิเศษไปพร้อมกัน!",
    "tr_TR": "En iyi arkadaşını birlikte seçkin bir Özel Alan oluşturmaya davet et!",
    "ur": "اپنے بہترین دوست کے ساتھ مل کر ایک خصوصی نجی اسپیس بنانے کے لیے اسے مدعو کریں!",
    "uz": "Eng yaqin doʻstingizni birgalikda ekskluziv Shaxsiy makon yaratishga taklif qiling!",
    "vi_VN": "Mời bạn bè thân thiết nhất cùng tạo Không Gian Riêng Tư độc quyền!",
    "zh_CN": "邀请你最亲密的好友来创建专属的私密空间吧！"
  },
  "space_level": {
    "HK": "空間等級",
    "TW": "空間等級",
    "ar_SA": "مستوى المساحة",
    "de_DE": "Bereichlevel",
    "en_US": "Space Level",
    "es_ES": "Nivel de Espacio",
    "fr_FR": "Niv d'espace perso",
    "hi_IN": "Space Level",
    "in_ID": "Level Space",
    "ja_JP": "Space Level",
    "ko_KR": "Space Level",
    "ms_MY": "Tahap Ruang",
    "pt_PT": "Nível do Espaço",
    "ru_RU": "Уровень личного пространства",
    "th_TH": "เลเวลพื้นที่ส่วนตัว",
    "tr_TR": "Alan Seviyesi",
    "ur": "اسپیس کا لیول",
    "uz": "Shaxsiy makon darajasi",
    "vi_VN": "Cấp Không Gian",
    "zh_CN": "空间等级"
  },
  "space_level_title": {
    "HK": "空間等級",
    "TW": "空間等級",
    "ar_SA": "مستوى المساحة",
    "de_DE": "Bereichlevel",
    "en_US": "Space Level",
    "es_ES": "Nivel de Espacio",
    "fr_FR": "Niv d'espace perso",
    "hi_IN": "Space Level",
    "in_ID": "Level Space",
    "ja_JP": "Space Level",
    "ko_KR": "Space Level",
    "ms_MY": "Tahap Ruang",
    "pt_PT": "Nível do Espaço",
    "ru_RU": "Уровень личного пространства",
    "th_TH": "เลเวลพื้นที่ส่วนตัว",
    "tr_TR": "Alan Seviyesi",
    "ur": "اسپیس کا لیول",
    "uz": "Shaxsiy makon darajasi",
    "vi_VN": "Cấp Không Gian",
    "zh_CN": "空间等级"
  },
  "space_operate_error": {
    "HK": "處理失敗，請重試",
    "TW": "操作失敗，請重試",
    "ar_SA": "فشل العملية. يُرجى المحاولة مرة أخرى",
    "de_DE": "Fehler. Bitte erneut versuchen!",
    "en_US": "Operation error. Please try again!",
    "es_ES": "Falló la operación. ¡Inténtalo de nuevo!",
    "fr_FR": "Erreur de manipulation. Veuillez réessayer.",
    "hi_IN": "Operation error. Please try again!",
    "in_ID": "Kesalahan operasi. Harap coba lagi!",
    "ja_JP": "Operation error. Please try again!",
    "ko_KR": "Operation error. Please try again!",
    "ms_MY": "Ralat operasi. Sila cuba lagi!",
    "pt_PT": "Falha na operação. Tente novamente!",
    "ru_RU": "Ошибка операции. Повторите попытку!",
    "th_TH": "ดำเนินการผิดพลาด โปรดลองอีกครั้ง!",
    "tr_TR": "İşlem hatası. Lütfen tekrar dene!",
    "ur": "آپریشن کا نقص۔ براہ کرم دوبارہ کوشش کریں!",
    "uz": "Amaliyot xatoligi. Qayta urining!",
    "vi_VN": "Lỗi thao tác. Hãy thử lại!",
    "zh_CN": "操作失败，请重试"
  },
  "space_post": {
    "HK": "發佈",
    "TW": "發佈",
    "ar_SA": "نشر",
    "de_DE": "Posten",
    "en_US": "Post",
    "es_ES": "Publicar",
    "fr_FR": "Publier",
    "hi_IN": "Post",
    "in_ID": "Posting",
    "ja_JP": "Post",
    "ko_KR": "Post",
    "ms_MY": "Siarkan",
    "pt_PT": "Publicar",
    "ru_RU": "Опубликовать",
    "th_TH": "โพสต์",
    "tr_TR": "Gönder",
    "ur": "‏پوسٹ کریں",
    "uz": "Post",
    "vi_VN": "Đăng",
    "zh_CN": "发布"
  },
  "space_refuse_invite": {
    "HK": "拒絕",
    "TW": "拒絕",
    "ar_SA": "رفض",
    "de_DE": "Ablehnen",
    "en_US": "Decline",
    "es_ES": "Rechazar",
    "fr_FR": "Refuser",
    "hi_IN": "Decline",
    "in_ID": "Tolak",
    "ja_JP": "Decline",
    "ko_KR": "Decline",
    "ms_MY": "Tolak",
    "pt_PT": "Recusar",
    "ru_RU": "Отмена",
    "th_TH": "ปฏิเสธ",
    "tr_TR": "Reddet",
    "ur": "‏رد کریں",
    "uz": "Rad etish",
    "vi_VN": "Từ chối",
    "zh_CN": "拒绝"
  },
  "space_refuse_invite_setting": {
    "HK": "不接受任何邀請請求",
    "TW": "不接受任何邀請請求",
    "ar_SA": "عدم تلقي طلبات دعوة",
    "de_DE": "Keine Einladungsanfragen erhalten",
    "en_US": "Don't Receive Invite Requests",
    "es_ES": "No recibir Solicitudes de Invitación",
    "fr_FR": "Ne pas recevoir de demandes d'invitation",
    "hi_IN": "Don't Receive Invite Requests",
    "in_ID": "Jangan Terima Permintaan Undangan",
    "ja_JP": "Don't Receive Invite Requests",
    "ko_KR": "Don't Receive Invite Requests",
    "ms_MY": "Jangan Terima Permintaan Jemputan",
    "pt_PT": "Não Receber Convites",
    "ru_RU": "Не получать запросы на приглашения",
    "th_TH": "ไม่รับคำเชิญ",
    "tr_TR": "Davet İsteklerini Alma",
    "ur": "دعوت کی درخواستیں وصول نہ کریں",
    "uz": "Taklif soʻrovlarini olmang",
    "vi_VN": "Không Nhận Yêu Cầu Lời Mời",
    "zh_CN": "不接受任何邀请请求"
  },
  "space_refuse_msg": {
    "HK": "此邀請已被拒絕",
    "TW": "此邀請已被拒絕",
    "ar_SA": "رفض اللاعب دعوتك",
    "de_DE": "Spieler hat die Einladung abgelehnt.",
    "en_US": "Player has declined the invitation.",
    "es_ES": "El jugador ha rechazado la invitación.",
    "fr_FR": "Ce joueur a refusé l'invitation.",
    "hi_IN": "Player has declined the invitation.",
    "in_ID": "Pemain menolak undangan.",
    "ja_JP": "Player has declined the invitation.",
    "ko_KR": "Player has declined the invitation.",
    "ms_MY": "Pemain telah menolak jemputan.",
    "pt_PT": "O jogador recusou o convite.",
    "ru_RU": "Игрок отклонил приглашение.",
    "th_TH": "ผู้เล่นปฏิเสธคำเชิญแล้ว",
    "tr_TR": "Oyuncu, daveti reddetti.",
    "ur": "پلیئر نے دعوت نامہ مسترد کر دیا ہے۔",
    "uz": "Oʻyinchi taklifni rad qildi.",
    "vi_VN": "Người chơi đã từ chối lời mời.",
    "zh_CN": "此邀请已被拒绝"
  },
  "space_save_bg_error": {
    "HK": "儲存背景圖失敗，請重試",
    "TW": "儲存背景圖失敗，請重試",
    "ar_SA": "تعذر حفظ صورة الخلفية. حاول مرة اخرى",
    "de_DE": "Speichern den Hintergrundbilds fehlgeschlagen. Bitte erneut versuchen!",
    "en_US": "Failed to save the background image. Please try again!",
    "es_ES": "No se pudo guardar la imagen de fondo. ¡Inténtalo de nuevo!",
    "fr_FR": "Échec de l'enregistrement de l'arrière-plan. Veuillez réessayer.",
    "hi_IN": "Failed to save the background image. Please try again!",
    "in_ID": "Gagal menyimpan gambar latar belakang. Harap coba lagi!",
    "ja_JP": "Failed to save the background image. Please try again!",
    "ko_KR": "Failed to save the background image. Please try again!",
    "ms_MY": "Gagal menyimpan imej latar belakang. Sila cuba lagi!",
    "pt_PT": "Falha ao salvar a imagem de fundo. Por favor, tente novamente!",
    "ru_RU": "Ошибка сохранения фона. Повторите попытку позже!",
    "th_TH": "บันทึกภาพพื้นหลังไม่สำเร็จ โปรดลองอีกครั้ง!",
    "tr_TR": "Arka plan resmi kaydedilemedi. Lütfen tekrar dene!",
    "ur": "پس منظر کی تصویر محفوظ کرنے میں ناکامی۔ براہ کرم دوبارہ کوشش کریں!",
    "uz": "Fon rasmini saqlab bo‘lmadi. Qayta urining!",
    "vi_VN": "Không thể lưu ảnh nền. Hãy thử lại!",
    "zh_CN": "保存背景图失败，请重试"
  },
  "space_time_to_build": {
    "HK": "已建立天數：%s 天",
    "TW": "已建立天數：%s天",
    "ar_SA": "تم الإنشاء منذ %s من الأيام",
    "de_DE": "Vor %s Tagen erstellt",
    "en_US": "Created %s Days Ago",
    "es_ES": "Creado hace %s Días",
    "fr_FR": "Créé depuis : %s j",
    "hi_IN": "Created %s Days Ago",
    "in_ID": "Dibuat %s Hari Lalu",
    "ja_JP": "Created %s Days Ago",
    "ko_KR": "Created %s Days Ago",
    "ms_MY": "Dicipta %s Hari Yang Lalu",
    "pt_PT": "Criado %s Dias Atrás",
    "ru_RU": "Создано %s д. назад",
    "th_TH": "สร้างแล้ว %s วัน",
    "tr_TR": "%s Gün Önce Oluşturuldu",
    "ur": "%s دن قبل تخلیق کردہ",
    "uz": "%s kun oldin yaratilgan",
    "vi_VN": "Đã Tạo %s Ngày Trước",
    "zh_CN": "已创建天数：%s 天"
  },
  "space_time_to_build_less_two": {
    "HK": "已建立天數：%s 天",
    "TW": "已建立天數：%s天",
    "ar_SA": "تم الإنشاء منذ %s من الأيام",
    "de_DE": "Vor %s Tag erstellt",
    "en_US": "Created %s Day Ago",
    "es_ES": "Creado hace %s Día",
    "fr_FR": "Créé depuis : %s j",
    "hi_IN": "Created %s Day Ago",
    "in_ID": "Dibuat %s Hari Lalu",
    "ja_JP": "Created %s Day Ago",
    "ko_KR": "Created %s Day Ago",
    "ms_MY": "Dicipta %s Hari Yang Lalu",
    "pt_PT": "Criado %s Dia Atrás",
    "ru_RU": "Создано %s д. назад",
    "th_TH": "สร้างแล้ว %s วัน",
    "tr_TR": "%s Gün Önce Oluşturuldu",
    "ur": "%s دن قبل تخلیق کردہ",
    "uz": "%s kun oldin yaratilgan",
    "vi_VN": "Đã Tạo %s Ngày Trước",
    "zh_CN": "已创建天数：%s 天"
  },
  "space_title": {
    "HK": "私人空間",
    "TW": "私密空間",
    "ar_SA": "المساحة الخاصة",
    "de_DE": "Privatbereich",
    "en_US": "Private Space",
    "es_ES": "Espacio Privado",
    "fr_FR": "Espace privé",
    "hi_IN": "Private Space",
    "in_ID": "Space Pribadi",
    "ja_JP": "Private Space",
    "ko_KR": "Private Space",
    "ms_MY": "Ruang Peribadi",
    "pt_PT": "Espaço Privado",
    "ru_RU": "Частное пространство",
    "th_TH": "พื้นที่ส่วนตัว",
    "tr_TR": "Özel Alan",
    "ur": "نجی اسپیس",
    "uz": "Shaxsiy makon",
    "vi_VN": "Không Gian Riêng Tư",
    "zh_CN": "私密空间"
  },
  "topic_hot_post": {
    "HK": "熱門帖子",
    "TW": "熱門貼文",
    "ar_SA": "الرائجة",
    "de_DE": "Angesagt",
    "en_US": "Trending",
    "es_ES": "Tendencia",
    "fr_FR": "Tendances",
    "hi_IN": "Trending",
    "in_ID": "Trending",
    "ja_JP": "Trending",
    "ko_KR": "Trending",
    "ms_MY": "Popular",
    "pt_PT": "Em Alta",
    "ru_RU": "Популярное",
    "th_TH": "มาแรง",
    "tr_TR": "Revaçta",
    "ur": "ٹرینڈنگ",
    "uz": "Trendda",
    "vi_VN": "Hot",
    "zh_CN": "热门帖子"
  }
}